{
  "copy.f10000000001": "This file is not accepted.",
  "copy.f10000000002": "HTML, SVG, XML, and other active files are not accepted.",
  "copy.f10000000003": "The file type does not match its name or declared format.",
  "copy.f10000000004": "This archive contains unsafe or excessively expanded entries.",
  "copy.f10000000005": "The file was rejected by malware protection.",
  "copy.f10000000006": "File scanning is temporarily unavailable. Nothing was stored.",
  "copy.f10000000007": "The file is larger than the allowed upload size.",
  "copy.f10000000008": "There is not enough file storage available for this upload.",
  "copy.f10000000009": "This uploaded file is already attached to another record.",
  "copy.f1000000000a": "The underlying file is no longer available.",
  "copy.f1000000000b": "The upload expired. Start it again.",
  "copy.f1000000000c": "This upload is already in progress.",
  "copy.f1000000000d": "This upload is not ready to be completed.",
  "copy.f1000000000e": "The download link expired or was revoked. Request a new one.",
  "copy.f1000000000f": "The file could not be committed to durable storage.",
  "copy.f10000000010": "File integrity verification failed.",
  "copy.f10000000011": "The required file storage backend is unavailable.",
  "copy.f10000000012": "File references need reconciliation before this operation.",
  "copy.f10000000013": "Backup integrity verification failed. No data was changed.",
  "copy.f10000000014": "The backup signature is invalid.",
  "copy.f10000000015": "Secure backup signing is not configured.",
  "copy.99ccda9ac024": "Registration",
  "copy.6e967a3e89bc": "Password reset",
  "copy.790357450f9c": "Sign in",
  "copy.cb27cced5cc5": "Personal cognitive workspace",
  "copy.ab0887752ff0": "Less on your mind, a clearer day ahead.",
  "copy.12b9d11566e3": "Exognitos captures your thoughts, gives your work context, and helps you find it again at the right moment. The decisions remain yours.",
  "copy.122913f4b005": "Keep the context",
  "copy.8a999cccc0af": "Projects, notes, and values stay connected.",
  "copy.8ce297e26be6": "See your day",
  "copy.c5fc01e89f91": "See your capacity, plan, and next meaningful step in one place.",
  "copy.7534a646bfd1": "Find it again",
  "copy.1a357d80f548": "Quickly return to past decisions and learning through search.",
  "copy.d874d8980561": "No scores, streaks, or guilt. Just meaningful progress.",
  "copy.cac362bfa89e": "Your data belongs to your account and can be exported.",
  "copy.96de1bf904a7": "Could not sign in.",
  "copy.1ded787a47a6": "Verify sign-in",
  "copy.d1ab13bcc5ff": "Welcome back",
  "copy.9124574ad28f": "Enter the six-digit code from your authenticator app.",
  "copy.7cc5b030a950": "Securely return to where you left off.",
  "copy.20ae94edf9f0": "Verification code",
  "copy.cc75b9cda14d": "The code is valid until {{value1}}.",
  "copy.e1081b69d80a": "Email",
  "copy.e3962ceb93e1": "Password",
  "copy.3f3f476f7c53": "Forgot password",
  "copy.a1125173b696": "Verify and sign in",
  "copy.93f4dcc5424f": "Sign in",
  "copy.bcab3b593715": "Sign in with another account",
  "copy.957387f11f7c": "Don't have an account?",
  "copy.f2c0c4779e9d": "Register",
  "copy.0ad7ff3fb585": "Could not create the account.",
  "copy.9776c3fa42f1": "Get started with Exognitos",
  "copy.dda75ea742ce": "Your data stays on this server. No ads, tracking, or third-party analytics.",
  "copy.c5176ef33f7c": "Your name",
  "copy.fd278f35f29f": "Optional",
  "copy.ebba7f77a8d6": "At least 10 characters.",
  "copy.b2d8a657f766": "Invitation code",
  "copy.28799f27050c": "Enter a code if this server requires an invitation.",
  "copy.58593661c0db": "Create account",
  "copy.8e90e87fd2e9": "Already have an account?",
  "copy.96028bee8845": "Reset your password",
  "copy.d98bd06d8787": "If this address is registered, a reset link has been sent. The link is valid for two hours.",
  "copy.bc8256446160": "If the email has not arrived, check the address or make sure the server's email settings are configured.",
  "copy.3210a9a0a33b": "Back to sign-in",
  "copy.7e717af902c3": "We'll send a link to your registered email address.",
  "copy.b061b1a14741": "Send link",
  "copy.600d46c29699": "Could not change the password.",
  "copy.55013f334652": "Your password has changed",
  "copy.9ced4778c962": "Your previous API keys have been revoked for security. You can sign in with your new password.",
  "copy.5498e19834c5": "Set a new password",
  "copy.7f51a9b76aae": "New password",
  "copy.b0e095a26762": "Change password",
  "copy.3fac8e82ff3f": "Settings sections",
  "copy.3c39b8330eb6": "Account and security",
  "copy.31c258bfd0b8": "Day and planning",
  "copy.e1b0af0c144d": "Appearance",
  "copy.9bbb369bcada": "Data and backup",
  "copy.dedf357e48bd": "Control room",
  "copy.bbb1132f30f1": "Light",
  "copy.0579c9d9e5ac": "A bright workspace with gentle shadows.",
  "copy.4e52adc41240": "Navy",
  "copy.f9cc2f54b768": "The default blue-black Exognitos appearance.",
  "copy.b24a36089466": "Dark",
  "copy.09e7ebefa6c7": "Neutral graphite surfaces with low brightness.",
  "copy.17f8a4286226": "Enter a valid IANA timezone, such as Europe/Istanbul.",
  "copy.989b7310c07a": "Timezone saved",
  "copy.575ace75f026": "Could not save timezone",
  "copy.35784c3627d6": "Day",
  "copy.a8ca9f7e5126": "Free time and capacity calculations use these settings.",
  "copy.a30bdb59f27f": "Show sleep range",
  "copy.31283aa6b6b8": "A planning preference, not a medical record. Shown as shading on the clock.",
  "copy.8288a7742db5": "Bedtime",
  "copy.9343e72ea78d": "Wake-up time",
  "copy.9723d134bafa": "Daily capacity",
  "copy.7630c0813cfd": "Daily capacity",
  "copy.36bd3aba5116": "The threshold for describing a day as light, balanced, or full. A scale, not a target.",
  "copy.ff9d48576ade": "Week starts on",
  "copy.980bd89a0b6d": "Week starts on",
  "copy.4e4f470ade3a": "Monday",
  "copy.2bd6371ea1e4": "Sunday",
  "copy.59de31cc9f7f": "Timezone",
  "copy.12bd4e2996d0": "This determines what counts as today. For example: Europe/Istanbul.",
  "copy.3e952ba1bc9c": "Starting workspace",
  "copy.e12d3f164b76": "Starting workspace",
  "copy.73da4635f33b": "Exognitos opens this workspace when you are not following a direct record link. The default is Planner.",
  "copy.d5df3708bc68": "Theme",
  "copy.8d9849ab4452": "Saving theme…",
  "copy.8f73c6093926": "Theme saved.",
  "copy.676746c60973": "The theme could not be saved; your previous choice was restored.",
  "copy.2839a67ba293": "Your choice is previewed immediately and saved to your account.",
  "copy.6fcb1bcd9a09": "Show completed tasks in lists",
  "copy.31d672524630": "Notification permission was not granted",
  "copy.e81e9c7e11dd": "In-app notifications are on",
  "copy.62cbfe31871d": "Notifications while the browser is closed require a VAPID key on the server.",
  "copy.4370c330aaab": "Push notifications enabled",
  "copy.fd900fd31815": "Could not set up push notifications",
  "copy.854e2dcd5116": "The browser subscription could not be created. Check notification permission and your secure connection.",
  "copy.b6cd2a14a1fc": "Push notifications disabled",
  "copy.bd28db9d8f41": "Could not remove push subscription",
  "copy.07c8698663ba": "The browser subscription could not be removed. Refresh the page and try again.",
  "copy.2b37aa840fe6": "Reminders",
  "copy.491e77e5ffe2": "A reminder is a time linked to a schedule block; delivery is separate. Every reminder appears here while the application is open. Web Push is required for delivery when the browser is closed.",
  "copy.0b47d0881340": "Refresh notifications",
  "copy.a6fe95a912f2": "Allow notifications",
  "copy.1ffc39c22b1c": "Disable push notifications",
  "copy.49e62454340a": "Permission granted",
  "copy.0cad353f2bae": "Blocked by the browser",
  "copy.658d742a69ea": "Push is not configured on the server",
  "copy.ee28de8dbf01": "Daily planning reminder",
  "copy.21004173ed75": "A morning prompt to plan your day.",
  "copy.6bc5a901db48": "Time",
  "copy.285af6543a87": "Review reminder",
  "copy.27c734778cff": "Could not read the file.",
  "copy.d2a59dc02427": "Could not inspect the file.",
  "copy.0d4c8aa82886": "Could not read backup",
  "copy.4d3a52d755ea": "Restore complete",
  "copy.5d0141c44ddd": "{{value1}} records restored.",
  "copy.7ef22d4f9e39": "Could not restore",
  "copy.6135a42bf53e": "Data",
  "copy.4bd012f22dc6": "Download backup",
  "copy.ed806cf70c05": "Download Markdown",
  "copy.f2a88edf41a6": "Restore from backup",
  "copy.6fcc00eeee69": "A backup is a plain JSON document containing every row and can be read by other programs. Restore accepts both this format and the Flutter application's own backup, allowing phone data to be moved to the server. The Flutter database is never modified.",
  "copy.9ab231d7ae79": "The Markdown file is for reading: projects, tasks, routines, notes, and journal entries in one document that any editor can open. It cannot be restored; download the JSON backup for a complete copy.",
  "copy.97e09437b22b": "This action replaces all your current data.",
  "copy.55ed39df01e7": "Replace everything",
  "copy.071c30132baf": "Format:",
  "copy.9fbd25a3a325": "Restore runs in a single transaction: if the file is invalid, your current data remains untouched. If it succeeds, all current data is replaced with this backup.",
  "copy.e594a7374ebf": "Could not inspect the backup file",
  "copy.1c56ac8f2dc6": "Account",
  "copy.26d51c460f0b": "Password changed",
  "copy.5e5ed7325e20": "Could not change password",
  "copy.32b3b79aaf12": "Current password",
  "copy.1de4bd6bfd9c": "Change",
  "copy.9112c2a2ec5f": "API keys",
  "copy.7938ed2c3830": "For clients outside the browser. The future Flutter application uses the same API this way. A key is displayed only once; the server stores only its hash.",
  "copy.63a37bba0c7e": "Key name",
  "copy.4a3d53ad97e5": "Flutter · phone",
  "copy.a6b7090cf3f7": "API key created",
  "copy.d2724171a732": "Could not create API key",
  "copy.89c75b03b93f": "Create",
  "copy.2e8944436e76": "This key will not be shown again. Copy it now.",
  "copy.2a05663cf99e": "API key copied",
  "copy.4830b08fd70a": "Could not copy API key",
  "copy.06f4c085606c": "Copy key",
  "copy.089ede514fc5": "Could not load API keys",
  "copy.3ecf0643fb4a": "No API keys yet",
  "copy.43b1ea49527b": "Manage keys here when you connect an external client.",
  "copy.a1a8b6d5f45b": "last used {{value1}}",
  "copy.647df8479ced": "never used",
  "copy.027d04b51d4d": "Revoking",
  "copy.0e6a4a39ff65": "Revoke key",
  "copy.a656eb128532": "Revoke the API key “{{value1}}”?",
  "copy.8241550568a6": "Clients using this key will immediately lose access.",
  "copy.e5a1d1fc47d3": "API key revoked",
  "copy.360423f4a9de": "Could not revoke API key",
  "copy.283092d12a56": "Sign out",
  "copy.9c0288e28f48": "Delete account",
  "copy.2221b1be9c7d": "Permanently delete account",
  "copy.45167c3129fe": "All your personal records will be permanently deleted. You can download a backup from the Data section first.",
  "copy.93c576376df4": "Could not delete account",
  "copy.f065ec043d16": "Delete account and all data",
  "copy.9752a34ccec5": "Enter your email address to confirm",
  "copy.bb82cdb533c2": "Could not start two-step verification setup",
  "copy.cb7ee627497c": "Two-step verification enabled",
  "copy.d069a78d03a3": "Could not verify code",
  "copy.1091b67d6db2": "Disable two-step verification?",
  "copy.a43d800a9f19": "Your account will be protected by your password alone.",
  "copy.b0057747f18c": "Disable verification",
  "copy.15fa9c08634a": "Two-step verification disabled",
  "copy.dee98045c5da": "Could not disable two-step verification",
  "copy.4527d07bc1ab": "Two-step verification",
  "copy.de9131310413": "Active",
  "copy.5f7034fb8282": "Requires a one-time code from your authenticator app after your password.",
  "copy.494aa90793a6": "Start setup",
  "copy.4abd83238a1f": "Add the key below to your authenticator app, then verify the generated code.",
  "copy.24e79a23345f": "Setup key copied",
  "copy.be09dd731d0b": "Could not copy setup key",
  "copy.dce8edc1f8c5": "Copy key",
  "copy.5c00187a2ff0": "Setup link copied",
  "copy.1023809cf73d": "Could not copy setup link",
  "copy.b144eb0e1e87": "Copy setup link",
  "copy.f0e09f445c16": "Six-digit code",
  "copy.a95c3631c07c": "Verify and enable",
  "copy.3bfc38419944": "Disable two-step verification",
  "copy.c16ff70cadf7": "Create concept map",
  "copy.02f429580797": "A map does not copy knowledge items; it stores a visual layout for the shared knowledge network.",
  "copy.c5bf2bbb3e0a": "Create map",
  "copy.a3b8c0cb41b2": "Title",
  "copy.e7ae0d9a164c": "Description",
  "copy.48e488f58d9c": "Concept map created",
  "copy.6cfa113b2ffc": "Could not create concept map",
  "copy.ab8c0d276d7b": "Concept maps",
  "copy.cd3725f0201c": "Visualize this context's knowledge in the shared knowledge network.",
  "copy.1122edeaf6b2": "Go to knowledge network",
  "copy.faf7c7deea49": "New map",
  "copy.c65e1d312d7d": "Could not load concept maps",
  "copy.b8e59fb1d563": "The knowledge network is currently unavailable.",
  "copy.9371d0677126": "No concept maps yet",
  "copy.0f351e4625b1": "Create a map for this context and add items from the knowledge network.",
  "copy.9f2fb4fd0fab": "knowledge items",
  "copy.dcc084f9a2e1": "Open",
  "copy.ba26074f4bcf": "Concept",
  "copy.57998053d77d": "Fact",
  "copy.4d2dbc852280": "Claim",
  "copy.37c9299cc784": "Definition",
  "copy.916fcb840691": "Method",
  "copy.9670899fdcff": "Example",
  "copy.2f0db590c3dc": "Source",
  "copy.0e7e238b1da4": "Loading knowledge library.",
  "copy.0aa78f4cc099": "Could not load the knowledge library.",
  "copy.d8fbb865cf2b": "The library contains {{value1}} knowledge records. Semantic relations are managed in the shared Relations panel.",
  "copy.6341f61f1f16": "See connections between knowledge items.",
  "copy.17d7999c9c9f": "Save it once; use the same knowledge in notes, projects, and maps.",
  "copy.ad9c6f95dff2": "Add knowledge",
  "copy.3e4e2ad7969b": "Search knowledge",
  "copy.0c0dbeb8d256": "Search title, description, or alias",
  "copy.e98e7ed16c63": "Could not retrieve knowledge",
  "copy.304ae84d606f": "The knowledge library cannot be loaded right now.",
  "copy.39caa44a8a8d": "No knowledge matches your search",
  "copy.8ad154203512": "No knowledge yet",
  "copy.bf5f1440ae7b": "Change your search or add a knowledge item.",
  "copy.46ad22af4fc5": "Capture your first concept, definition, or method in one sentence.",
  "copy.de2b7b02d529": "Add your first knowledge item",
  "copy.487bb6f48874": "Knowledge details",
  "copy.f5afa9429103": "Select a knowledge item to see its details",
  "copy.91cd451ca120": "The knowledge item's description, aliases, and relations appear here.",
  "copy.ea33b58c1d8e": "Edit",
  "copy.82d5f40bb2f6": "No short description has been added yet.",
  "copy.f6f0d73998a3": "Aliases",
  "copy.89a0ccceb3bc": "Could not retrieve concept maps",
  "copy.c7c52545852b": "Saved maps cannot be loaded right now.",
  "copy.75d124168685": "Open your first map to create different perspectives on the same knowledge network.",
  "copy.98a57fdcb335": "Concept maps",
  "copy.4c71e939d90a": "Maps",
  "copy.c49bb3dc164e": "Add concept map",
  "copy.e946061f575d": "Create visual layouts without duplicating knowledge items.",
  "copy.eae894d6068a": "Selected concept map",
  "copy.8dd21c376daa": "Select a map to view",
  "copy.8a4fbc7be035": "A map stores only item positions; knowledge and relations come from the shared network.",
  "copy.2bd11e318b03": "Could not retrieve map",
  "copy.37c7bfb928a2": "nodes",
  "copy.e699f39f8014": "Knowledge to add to the map",
  "copy.e235b92514e6": "Select knowledge…",
  "copy.7bc3fd2fdd78": "Add to map",
  "copy.485f6079a58b": "{{value1}} concept map",
  "copy.fab00418a21f": "The map is empty",
  "copy.0862cb8ca0d8": "Select a knowledge item above and add it to the map. Drag nodes to arrange the layout; manage semantic relations in the selected item's shared Relations panel.",
  "copy.57aec0d3cde9": "· Map position selected",
  "copy.a6aa714085a7": "Remove from map",
  "copy.aa61eddb228d": "Edit knowledge",
  "copy.886e262917d1": "Use one concise description; link knowledge to notes for detailed content.",
  "copy.5d33fa789962": "Knowledge type",
  "copy.d0903530c3cc": "Short description",
  "copy.1aec633b7fa7": "A brief description of the knowledge item at a glance.",
  "copy.e5d90c03cd12": "Aliases",
  "copy.e4f5709d854a": "Separate with commas.",
  "copy.014555b0cd45": "All notes",
  "copy.e472df084ad0": "Collection",
  "copy.c0977fd7e739": "Collections",
  "copy.94d8ad6ca5b5": "Could not load collections.",
  "copy.1e3f5b71382d": "Search selected collection",
  "copy.d79b8374ac49": "Search this collection…",
  "copy.c85b32b81834": "Could not load notes.",
  "copy.7f9e8516d8cd": "No notes match your search",
  "copy.5d6a926f5038": "This collection is empty",
  "copy.85fbac45abaa": "Add a new note or drag an existing note here.",
  "copy.be81df2e2f74": "Move note {{value1}}; use the left and right arrows for the previous or next collection",
  "copy.0c2319c34c4d": "Untitled note",
  "copy.0720141575bd": "There is no content yet.",
  "copy.af5314c74764": "Load more notes",
  "copy.c47288f712d7": "Select a note to read",
  "copy.ed70439d3159": "Collection archived",
  "copy.e767f6520b1e": "Its notes were not deleted; the collection's location, order, and note placements are preserved.",
  "copy.a1a42bee962d": "Could not archive collection",
  "copy.c34e60dc6967": "Try again shortly.",
  "copy.8161c2e2f138": "Reorder collection {{value1}}",
  "copy.cda75a7a40ba": "Archive collection {{value1}}",
  "copy.ff33abf236d8": "Memory collections",
  "copy.37200f9aa455": "Drop at root",
  "copy.719b89b6b404": "Open to edit",
  "copy.28697ae7dc33": "This note is still empty.",
  "copy.d4c443070010": "Create collection",
  "copy.2c5802e49e24": "A new subcollection inside {{value1}}.",
  "copy.b38cca770e15": "A new knowledge space.",
  "copy.4cd247ff5c07": "Collection name",
  "copy.a5ad04672105": "Short description",
  "copy.e282bf08a937": "Life records",
  "copy.28b679f4fca7": "Memory",
  "copy.31adddf058fd": "Memories",
  "copy.abab70053722": "Draft",
  "copy.779c7177e97a": "Decision",
  "copy.4419e0aef47c": "Focus records",
  "copy.3d7c54eef3f9": "History view",
  "copy.186197b176e7": "History view",
  "copy.4e850716074e": "Recent",
  "copy.c9a878720fa5": "Time",
  "copy.a3830980d61b": "Could not load history",
  "copy.6b4275f1f7cb": "Your notes and life records are currently unavailable.",
  "copy.49f44b3ac144": "No history yet",
  "copy.4558404455a3": "Notes, journal entries, and life records appear together here.",
  "copy.f9751f975bb4": "Recently updated",
  "copy.ebf4fcd4d1a2": "Life timeline",
  "copy.4fa0633a66bc": "Load older records",
  "copy.3c9f2a84065f": "Record details",
  "copy.5a9c55b92a06": "Select a record to see its details",
  "copy.0c4b5330b16e": "Loading history",
  "copy.5729428c8301": "Open details for {{value1}} · {{value2}}",
  "copy.e27c5b4c5a57": "Draft converted to a note",
  "copy.46713d910a91": "This record has no text.",
  "copy.e1d51eb61dd8": "Created",
  "copy.40fdb26f3cfe": "Updated",
  "copy.27184cb9b470": "Occurred",
  "copy.8bd057388e28": "Status",
  "copy.a8d897547560": "Source and context",
  "copy.3dd2db670c40": "Open linked project",
  "copy.dc378bd68203": "Convert to note",
  "copy.e75b5dc1a5f3": "Open note",
  "copy.a37edb689683": "Open in Life tracking",
  "copy.eb9fd3d385e9": "Open in Drafts",
  "copy.a599140a43c6": "Open in project decisions",
  "copy.b81ebeb6909d": "Open in Projects",
  "copy.720e1e63e424": "Open life record",
  "copy.18711bade2f4": "Open focus history",
  "copy.a40fa2f422d2": "Open in life records",
  "copy.193410982b9f": "Journal note",
  "copy.734cfd05c468": "Untitled draft",
  "copy.41f1200287ab": "Awaiting processing",
  "copy.6d676228d805": "Processed",
  "copy.a7248eeb45eb": "Normal",
  "copy.301ef766a15b": "Journal",
  "copy.4cbfeef81fdf": "Added to journal",
  "copy.8b98d2808d38": "Could not add journal entry",
  "copy.37865452302c": "Today's journal",
  "copy.76834c1dc5f0": "Clear my mind",
  "copy.31387c5f43a1": "Clear your mind",
  "copy.8840ef4929f4": "Write in your journal",
  "copy.1561033ecd0e": "You don't need to sort or organize anything.",
  "copy.648efb007a51": "A brief moment or a long account can be a single entry.",
  "copy.f155b3d83319": "Write whatever is on your mind, in any order…",
  "copy.bdca02bf6354": "What happened today, what did you think, and how do you feel?",
  "copy.c35ce2067f4e": "Mood",
  "copy.2cfd3126aac2": "Energy",
  "copy.78827e6c01ea": "Add to journal",
  "copy.a43cd9c432ea": "Open related record directly",
  "copy.08acae7bc533": "Choose a life context without leaving the journal",
  "copy.21468bc8c572": "Timeline",
  "copy.7c6de22a8c72": "Independent, timestamped entries",
  "copy.814154914f15": "Could not load journal",
  "copy.278d97e211c9": "Ready for your first entry",
  "copy.6f6922d85815": "A short sentence or a long stream of thoughts can be a single entry.",
  "copy.15fbb69da018": "Brain dump",
  "copy.df115500233f": "Conversation",
  "copy.77b99959017d": "From AI",
  "copy.34515e4055e2": "energy",
  "copy.edeeb9e1679d": "Journal window",
  "copy.dd97b4df33fd": "Minimize moment window",
  "copy.3bc0515406c7": "Moment · Journal",
  "copy.f2d73da75ca2": "Move moment window; use arrow keys to position it and Home to center it",
  "copy.8e38c0d838ee": "Drag or move with arrow keys",
  "copy.04c48f347564": "Expand moment window",
  "copy.979540421e75": "Restore moment window size",
  "copy.8a4c53f5395c": "Close moment window",
  "copy.3f8fb95771d7": "Could not load note",
  "copy.d2ffe86b10c4": "The content is currently unavailable. Check your connection and try again.",
  "copy.fbdde700237f": "Relations",
  "copy.6f08277817be": "Map",
  "copy.35993c4e1a07": "Untitled note",
  "copy.809a89aa5afa": "Note workspace",
  "copy.e2f4a0fec18f": "Could not save · try again",
  "copy.dd292f855cd8": "Saving…",
  "copy.d6d27b472489": "Changes pending…",
  "copy.569e6436ea71": "Saved · {{value1}}",
  "copy.2fe83d132e3d": "Mode",
  "copy.4a2884827a36": "Write",
  "copy.3ca30db82b66": "Read",
  "copy.82c552e2d402": "Archive",
  "copy.88e176f2a0e6": "Note archived",
  "copy.03b226cec5d0": "Move to Trash",
  "copy.b1555d57c2a7": "Move “{{value1}}” to Trash?",
  "copy.c7d4503603a3": "The note and its content are moved to Trash and can be restored from there. Use the adjacent button if you want to archive it.",
  "copy.16a587ad2c09": "Context",
  "copy.9d577d1d2ed9": "Note metadata",
  "copy.430d32b5de5c": "Edit the project and values separately from the content. Changes are saved immediately.",
  "copy.e7dc4ae35876": "Search metadata",
  "copy.5fccaf98381f": "Search projects",
  "copy.cfcbce97d6e0": "Project context",
  "copy.60deebf3df56": "No project",
  "copy.020c2a36778d": "Could not save metadata · Try again",
  "copy.9e5be53b8f2d": "Note content",
  "copy.da660887e4e2": "Start writing…\n\n# Heading\n- Item\n- [ ] To do\n> Quote",
  "copy.246a1f0e91b2": "Loading note history",
  "copy.6e031db7f962": "Could not load note history",
  "copy.18a36c15eac9": "Saved snapshots are currently unavailable.",
  "copy.83702fdefb08": "Note history",
  "copy.cd0a5f25a736": "Complete snapshots. Identical content is not saved repeatedly.",
  "copy.5a5a29abba15": "Note snapshot saved",
  "copy.4595298d737d": "Save now",
  "copy.a1e192c5d443": "No history yet",
  "copy.29f6bf64e917": "Your first saved snapshot will appear here.",
  "copy.3c1698c0e8ef": "The note text is empty in this snapshot.",
  "copy.8ca610c50004": "· Source revision",
  "copy.ef77f8e2bda4": "Restore this revision?",
  "copy.f113cb6d765c": "The current content is saved to history first; the selected snapshot then becomes the new revision.",
  "copy.2d0cf3a0aff6": "Restore",
  "copy.0089ce0949fb": "Note revision restored",
  "copy.71cb54e14d68": "Restored revision",
  "copy.6fd8a45f58d5": "Before restore",
  "copy.961611152385": "Snapshot",
  "copy.6af64a401241": "<p class=\"cx-empty\">This note is empty.</p>",
  "copy.f3d3bb4e2fb3": "Note view and filters",
  "copy.4447849a4d05": "Search notes",
  "copy.84610aff8195": "Filters",
  "copy.c1d67bf78759": "Note view",
  "copy.7343841e724e": "List",
  "copy.b1b05e3eb50d": "Cards",
  "copy.747e078b6022": "Note filters",
  "copy.1191aff270da": "All projects",
  "copy.468d9f680caa": "Clear filters",
  "copy.a7587d828765": "Could not load notes",
  "copy.91441af0ba4a": "No notes for “{{value1}}”",
  "copy.885cf62e1b0c": "No notes yet",
  "copy.8498f479155c": "Notes are for things you want to keep. Thoughts you haven't processed yet stay in Drafts.",
  "copy.2b2a398126da": "Write your first note",
  "copy.443e7f4a2b74": "Empty note",
  "copy.cf6499ad96a2": "notes shown",
  "copy.d0e39a8e5c8f": "Load more notes",
  "copy.fe0e34366b5a": "Could not load more notes. You can try again.",
  "copy.e5dc5437dcb4": "Tab limit reached",
  "copy.04d93bf407bb": "A note window can have up to {{value1}} notes open. Close a tab first.",
  "copy.55c7c1986f4b": "Note workspace window",
  "copy.ae2a40b4d164": "Minimize note window",
  "copy.8fb911dcd76e": "Move note window; use arrow keys to position it and Home to center it",
  "copy.ff13cd3370f8": "Open notes",
  "copy.f39674b236c2": "Create a note and open it in a tab",
  "copy.ff89fe1be595": "Show two notes side by side",
  "copy.e8874f776a69": "Add an existing note as a tab",
  "copy.7931d04b3a97": "Expand note window",
  "copy.70b7fb0dd36f": "Restore note window size",
  "copy.cb6e87fb5944": "Close note window",
  "copy.d8116ac68d43": "Select note",
  "copy.8576940aa0fe": "New note",
  "copy.73041134791c": "This window supports up to",
  "copy.00858ad236c8": "open notes. Close a tab before adding another note.",
  "copy.81b2a24d53c0": "Loading notes",
  "copy.70040ce7974d": "Work notes are currently unavailable.",
  "copy.50fc81010461": "Create your first work note and start writing directly in this window.",
  "copy.9dc191af034f": "More notes",
  "copy.126e4fae4dd4": "No content yet",
  "copy.6b90e23a89ee": "Open tab",
  "copy.2b88a710cfd0": "completed",
  "copy.b7992378caee": "skipped",
  "copy.49730237c2a7": "Paused",
  "copy.bd5d2911824c": "Archived",
  "copy.37e2cf2fa7cf": "Could not load routine",
  "copy.604c1a53e347": "The routine's plan and history are currently unavailable.",
  "copy.56bf34ff3770": "no occurrence on this date",
  "copy.24c7be1b09ec": "Resume",
  "copy.8b821f1a0c83": "Routine group:",
  "copy.127aef763ca8": ". Routine status:",
  "copy.92b43618cb97": "Completed today",
  "copy.a7ce264a8338": "Skipped today",
  "copy.09564815dd9c": "Today's occurrence is open",
  "copy.b78cb2c56557": "No occurrence for today",
  "copy.2eccf6038ace": "Reopen",
  "copy.d723799ffbf6": "Undo skip",
  "copy.70ad067c3757": "Skip today",
  "copy.8917b01bb398": "Routine overview",
  "copy.0212854030fa": "30-day rhythm",
  "copy.c6f743dde499": "Generate 28 days",
  "copy.d694d5719eaa": "30 days ago",
  "copy.1279dae674df": "Today",
  "copy.5383a260a281": "The routine's record for the last 30 days",
  "copy.d6924100da57": "Last 30 days",
  "copy.0bcb5ff74923": "Last 7 days",
  "copy.73fc1e6b33e4": "Streak",
  "copy.0ecea5c1b188": "days · best",
  "copy.5b3df0cf7cc8": "Skipped",
  "copy.f95267f29623": "Effort",
  "copy.b4b558237ae3": "The effort summary could not be calculated right now.",
  "copy.f4ad0b67bd35": "Actual focus",
  "copy.40201a4eb444": "last 365 days",
  "copy.d784e2e6d474": "Estimate for completed tasks",
  "copy.9d14a5ce5e27": "{{value1}} tasks",
  "copy.1348a1207b09": "The year ahead",
  "copy.3a78efdd2a93": "completed tasks have no estimated duration; the estimated total includes only known durations.",
  "copy.5f12d026fc97": "Add a default duration to the routine to see future cumulative effort.",
  "copy.917e2b5439bf": "Upcoming days",
  "copy.6b8771d56886": "Linked project",
  "copy.053664dcbb41": "Not linked to a project",
  "copy.5da57b457b37": "Recurrence",
  "copy.e14ad577955f": "No duration specified",
  "copy.074c7bd805e8": "No time specified",
  "copy.e9498e148b1f": "Reminder",
  "copy.a11d42f98c24": "Color from context",
  "copy.bfaca8828655": "Custom color",
  "copy.d55dd778c931": "Automatic color",
  "copy.39ce8f387818": "Off",
  "copy.60f97fc2fff5": "No limit",
  "copy.21f81ca74299": "Selected days",
  "copy.ace7f0833a9d": "Every X days",
  "copy.461f8fe7a08a": "N times a week",
  "copy.d2bc3efeb1c0": "The end cannot be before the start.",
  "copy.02f933b8581d": "Edit routine",
  "copy.9030480b9ade": "New routine",
  "copy.e6289605b1c8": "Changing the rule does not change history.",
  "copy.c96f14c92d16": "What will repeat?",
  "copy.b0e4706c6dcd": "Frequency",
  "copy.e5e7f5719c8e": "Every how many days",
  "copy.d66cae7606de": "days",
  "copy.6dccd1a20031": "Per week",
  "copy.10dbe20d4ad5": "Times per week",
  "copy.24196fe8174c": "times",
  "copy.c60438bbed33": "Not tied to specific days. It leaves Today when the weekly quota is reached.",
  "copy.e69f304adc92": "This time is suggested when scheduling.",
  "copy.5c053d01946d": "Start date",
  "copy.d5dc5b6e533c": "Starts immediately if left empty.",
  "copy.6d4b32f1eedb": "End date",
  "copy.f92cdf77a8c7": "Continues indefinitely if left empty.",
  "copy.aa2d27eacb80": "Uses the project or value color if left empty.",
  "copy.cba36654e0f5": "A reminder is set when scheduled. Nothing sends a notification automatically.",
  "copy.bf7a73dbee81": "The routine is moved to Trash and can be restored from there. Pause the routine if you only want to stop creating new tasks temporarily.",
  "copy.53e796c2d4be": "Routine list filters",
  "copy.191d885ea878": "Could not load routines",
  "copy.45535fb5b28d": "No routines yet",
  "copy.9c2ca1f60091": "Create your first routine by defining the days, time, and duration of a recurring activity.",
  "copy.d1f9d8919e11": "Create your first routine",
  "copy.f546116422a8": "Active routines",
  "copy.afd1e6207559": "No routines are currently running",
  "copy.facf43ea229a": "Resume a paused routine or create a new recurrence rule.",
  "copy.b9377fce6e10": "Create routine",
  "copy.f80edd33efd3": "Independent routines",
  "copy.99b57227b30e": "Archived",
  "copy.4eb3b9f0a041": "Paused",
  "copy.f8224ce322c4": "Routine and context",
  "copy.70ba1bbe6850": "Rhythm",
  "copy.02600cabf6d4": "Next occurrence",
  "copy.b93c839f51f3": "Action",
  "copy.56dc29143dcd": "Reorder routine {{value1}}",
  "copy.8498fb76aee8": "Independent routine",
  "copy.4222cd4cba97": "No duration specified",
  "copy.c3c906d77742": "Reminder enabled",
  "copy.07bd01d53c3a": "Not generating new tasks",
  "copy.5421e3bbecf9": "Next open occurrence",
  "copy.37e4b6a7987d": "No date",
  "copy.5aa457084b05": "The routine has ended",
  "copy.6968ef1b930a": "Next occurrence not calculated",
  "copy.19b6acde3303": "Pause",
  "copy.b7428c0608da": "More",
  "copy.b1b94c42b1ee": "Could not load task",
  "copy.2696ceee5b85": "Task details are currently unavailable.",
  "copy.160a0c04f40f": "In archive",
  "copy.a395d3f03cd5": "Start focus",
  "copy.7c6f3f5f37bc": "Completed",
  "copy.c56ee44480c4": "Reopen",
  "copy.e99c0f5f39c4": "Scheduling",
  "copy.28f367c06d06": "One scheduled time for the task; you can leave it empty.",
  "copy.eda0ec4e68fc": "Edit schedule",
  "copy.6e53533c7eee": "Focus history",
  "copy.e39d882bed59": "Total {{value1}}",
  "copy.20a1bc039cb5": "Recorded actual work sessions.",
  "copy.af458a65e955": "Loading focus history",
  "copy.191ef851f132": "Could not load focus history",
  "copy.7ef1bec67806": "The task's work records are currently unavailable.",
  "copy.41e52748392f": "No focus records yet",
  "copy.66edcbed3b55": "Completed focus sessions will appear here.",
  "copy.68301d6363c0": "No duration recorded",
  "copy.0fbfb68f1fea": "Context and origin",
  "copy.b37eb675bf47": "Work relations, priority, and record history",
  "copy.5f6c274c0968": "Open project",
  "copy.feaf3bca563c": "Open plan",
  "copy.a6204fb9ae1e": "Not linked",
  "copy.c8a5aafada26": "Origin",
  "copy.89d3bff7cac1": "Open source routine",
  "copy.6ed956b0b6dc": "Converted from a draft",
  "copy.da3952395dbe": "Direct task",
  "copy.874608e6ef44": "Created via",
  "copy.10cc43323876": "Priority",
  "copy.aa5be1febbcb": "Task actions",
  "copy.721698ff82bb": "Split, change status, archive, and move to Trash",
  "copy.0f2f871ae988": "Split task",
  "copy.964e5c87e8d2": "Skip this occurrence",
  "copy.dee2f8e430fe": "Cancel",
  "copy.5bc872cacfa7": "Unarchived",
  "copy.2bd6fa586ed3": "Unarchive",
  "copy.a566e98a17ee": "The task is moved to Trash and can be restored from there. Archive it to keep it while removing it from active lists.",
  "copy.0ce25055a534": "Task overview",
  "copy.9acca15934e5": "Task date",
  "copy.a4fe24966302": "Estimate {{value1}}",
  "copy.2e07de89affa": "No estimate",
  "copy.c169dad911d5": "On calendar",
  "copy.a135e05bc1ff": "List visibility",
  "copy.c77135fdca59": "Work context",
  "copy.59a9c862f500": "No task date added",
  "copy.95d7dcfd55e9": "Leave the task undated or place it directly on today or tomorrow.",
  "copy.c704a0289b62": "Tomorrow",
  "copy.e052ca7e0a11": "No reminder",
  "copy.8e612a881191": "Remind {{value1}} before",
  "copy.e5685b250866": "Open in calendar",
  "copy.3c9be645ee70": "Canceled",
  "copy.594b1254c47d": "Skipped",
  "copy.f46439f36834": "Low",
  "copy.06213d812746": "High",
  "copy.bbcaca2db421": "Show everywhere",
  "copy.80d7c6117abc": "Hide in general lists",
  "copy.02e302c78c1e": "Direct",
  "copy.20facd515829": "Import",
  "copy.63dd812ab288": "Data migration",
  "copy.954f0858d921": "Low energy",
  "copy.432b14918534": "Medium energy",
  "copy.7e1e6873b1f7": "High energy",
  "copy.4369b336d7d9": "None",
  "copy.9bd00c306092": "At the scheduled time",
  "copy.3cd4735a3fe4": "5 min before",
  "copy.6f9f73d717ce": "15 min before",
  "copy.5d57342b7a4f": "30 min before",
  "copy.b59a46e8b948": "Edit task",
  "copy.a4d247b8df96": "New task",
  "copy.f55aac09fd54": "What needs to be done?",
  "copy.5c0ac1d583b3": "Describe the task's scope or expected outcome.",
  "copy.9f21e646042b": "Project and plan context",
  "copy.d67ced741420": "No plan",
  "copy.ffcb471eae18": "Current plan",
  "copy.40131626f1a0": "Can be left empty.",
  "copy.e306951c12fe": "Clear",
  "copy.b31ad9244182": "Optional. If empty, the task stays on that day without a specific time.",
  "copy.825a623342bf": "Estimated duration",
  "copy.70aab7b9b7e3": "Details",
  "copy.b4b9890a72f6": "Unspecified",
  "copy.f0c77623fdfc": "List visibility",
  "copy.2dbe78aee227": "visible",
  "copy.0894d27e4b5d": "Show everywhere",
  "copy.6511a6d3b677": "Hide in general lists",
  "copy.c80aefc61331": "Undated",
  "copy.dbd417da03e1": "Canceled",
  "copy.7eb27764c944": "No duration",
  "copy.3ade1f388d35": "Dated",
  "copy.2ae48de34178": "High priority",
  "copy.341c89df4699": "Add to today's calendar",
  "copy.9af9083e23c5": "Add to tomorrow's calendar",
  "copy.3f6920a9ead3": "Cancel",
  "copy.b5fb430e1781": "Skip this occurrence",
  "copy.4cbe371f24e1": "Overdue",
  "copy.ebf017bde39a": "Completed",
  "copy.3bad15cd9763": "Stopped",
  "copy.6d3fa3fdb177": "All",
  "copy.5a98326ea72d": "No open tasks",
  "copy.7585d98e6ee4": "Capture the task on your mind; decide when to do it later.",
  "copy.29eef5007472": "No tasks placed on today",
  "copy.f78bdbaec539": "Return to Calendar to see your day's schedule.",
  "copy.4077f68b85ab": "No overdue tasks",
  "copy.afcb8109ff8b": "None of your open tasks has a past date or planned end time.",
  "copy.9103ae8c1f63": "No completed tasks",
  "copy.65cc8905e935": "Your finished work appears here, most recently completed first.",
  "copy.36c978566a06": "No canceled or skipped tasks",
  "copy.503c6b93a6ff": "Canceled tasks and skipped routine occurrences appear here.",
  "copy.eb61dfad320e": "No matching tasks",
  "copy.4ea8111f84dc": "No results for “{{value1}}” in this view.",
  "copy.4bff24c71cd5": "No {{value1}} tasks in this view",
  "copy.11a5f5913441": "Change the date filter to see other tasks.",
  "copy.c70acf93fd29": "New order",
  "copy.0be3998bcc26": "Reorder manually",
  "copy.d5c9b3e3bef8": "Task filters",
  "copy.b918e4d5261e": "Task view",
  "copy.49645c228b78": "Task date filter",
  "copy.7df146b5ba8d": "Search tasks",
  "copy.043cbcd4e8b5": "Narrow the view by project, priority, energy, and source.",
  "copy.cc7fcf8ee6d0": "Filter by project",
  "copy.dea358c3157d": "Filter by priority",
  "copy.10bcad87d149": "All priorities",
  "copy.0363cc1a7759": "Filter by energy",
  "copy.d1e3bd0cb4d4": "All energy levels",
  "copy.4120388e3ca6": "Filter by source",
  "copy.158b2f775c1f": "All sources",
  "copy.81f6f7f0c433": "From a routine",
  "copy.53306a82f141": "From inbox",
  "copy.9e12b68131c5": "Imported",
  "copy.4782424b8a21": "Sort tasks",
  "copy.55fa21269c40": "Smart order",
  "copy.3e109d157254": "By task date",
  "copy.f434360cfd50": "By latest change",
  "copy.ed6367311d42": "By creation date",
  "copy.184aee9eca0d": "By title",
  "copy.82906b7b4bcc": "Manual order",
  "copy.e980e73462a7": "Loading tasks",
  "copy.d60cb36f492d": "{{value1}} tasks shown",
  "copy.d1eb7fe130e7": "Could not load tasks",
  "copy.11d0da610718": "Check your connection and reload the list.",
  "copy.8975bb30e876": "Clear search",
  "copy.7c7c5b2ec391": "Add task",
  "copy.3005a154a599": "Task and context",
  "copy.af3e04fd73aa": "Task date and status",
  "copy.1c8289d66557": "Drag task {{value1}} to reorder",
  "copy.132290e5e9e9": "This view is calculated from the first",
  "copy.e9f68d5f2cb8": "tasks; narrow your search or filters to find the remaining tasks.",
  "copy.46e8e6e245e1": "Enter a title for each part.",
  "copy.5121fc9b367e": "Estimates must be whole numbers between 1 and 1440 minutes.",
  "copy.42240b459bc6": "Task split into {{value1}} parts",
  "copy.60e2a7a0d592": "The original task was left open.",
  "copy.0ea48fef5bb4": "The original task was canceled.",
  "copy.63438088511c": "Split “{{value1}}” into independent, actionable parts.",
  "copy.dbfb40cac736": "Split into {{value1}} parts",
  "copy.5ccb12e24e3c": "Number of parts",
  "copy.f06f072de208": "parts",
  "copy.f5aaa7faf374": ". part",
  "copy.96dd9382cb27": "Minutes · optional",
  "copy.7aa935ebb7ad": "Keep the original task open",
  "copy.60960e2fc54b": "When off, the original task is canceled; the new parts keep the same project, plan, and value context.",
  "copy.c3e13b03dc99": "Action could not be completed",
  "copy.a5ec4079a398": "The change could not be saved. Check your connection and try again.",
  "copy.d4d0b9f5e404": "This area is not yet available in the prototype.",
  "copy.18ec784cabf5": "In development",
  "copy.2d573297256f": "This area will be available once its workflow is complete.",
  "copy.e99bd3a990b9": "Expand menu",
  "copy.16eb3489b945": "Collapse menu",
  "copy.64467805a844": "Open main navigation",
  "copy.f49efddc6485": "Search, run a command, or go to a page",
  "copy.d9f0d8d1e13c": "Open moment journal",
  "copy.304ae1558cde": "Moment",
  "copy.92fbe8a2cca5": "Focus page is open",
  "copy.3360084dc9e3": "Open focus tool",
  "copy.41620582d621": "Focus",
  "copy.e24b757f73ec": "Open the I feel scattered support tool",
  "copy.36008d4c423c": "I feel scattered",
  "copy.e9f7351d6ce8": "Quick capture",
  "copy.1968f5976659": "Open profile and account settings",
  "copy.a3254376acd7": "{{value1}} pages",
  "copy.338a27d7a65a": "Main navigation",
  "copy.7a7a80bfab44": "The request could not be processed. Check the information you entered.",
  "copy.39f6162d8263": "Your session has ended. Sign in again.",
  "copy.a25c909874f9": "You do not have permission for this action.",
  "copy.31377a9a1089": "Security verification could not be renewed. Refresh the page and try again.",
  "copy.4c8f6d456015": "The access permission required for this action is missing.",
  "copy.c7c2d58c091b": "The record was not found or is no longer available.",
  "copy.e53e2fae9cfc": "The record changed in the meantime. Refresh the page and try again.",
  "copy.560418b7fa5d": "Some information is invalid. Check the highlighted fields.",
  "copy.7f98f92e9117": "Some field values do not meet the schema rules. Check the fields.",
  "copy.232da33bbc54": "A published field's key cannot be changed.",
  "copy.70495730f4bf": "This field type is incompatible with the existing records.",
  "copy.f2db1cf1a3a3": "Too many attempts. Wait a moment and try again.",
  "copy.a240b9844254": "A server error occurred. Try again shortly.",
  "copy.3ae448d5fd3f": "The email address or password is incorrect.",
  "copy.63aa560bc872": "New account registration is currently closed.",
  "copy.f531becf149c": "The invitation code is invalid.",
  "copy.ad844c2eddce": "An account already exists with this email address.",
  "copy.fed49c4fa912": "The password does not meet the security requirements.",
  "copy.e9052867369c": "Your current password is incorrect.",
  "copy.6c963742257c": "The confirmation you entered does not match.",
  "copy.bf647903640b": "The password reset link is invalid, already used, or expired.",
  "copy.29264ede9afa": "Two-step verification is already enabled for this account.",
  "copy.69b436bca334": "The verification code did not match. Try a new code.",
  "copy.fa96a514cee4": "The verification session is invalid. Sign in again with your password.",
  "copy.bf96bcfec84f": "Verification has expired. Sign in again with your password.",
  "copy.849189b4fc23": "Too many incorrect codes. Start signing in again.",
  "copy.b6b5914072ea": "Sign in again to permanently delete records.",
  "copy.889b2f0761db": "Sign in again and complete two-step verification to permanently delete records.",
  "copy.006357b61a98": "This record was changed elsewhere. Load the latest version and try again.",
  "copy.4d9c0ce92710": "The request could not be safely repeated. Start the action again.",
  "copy.3a3c12e12293": "The same action is still in progress. Try again shortly.",
  "copy.a99421654cb2": "Some records in the list are no longer available. Refresh the list.",
  "copy.31bc0356a1f2": "The selected project was not found.",
  "copy.6dbd7caa28b9": "The project's target date cannot be before its start date.",
  "copy.55101a434922": "The routine's end date cannot be before its start date.",
  "copy.eb3c89088cba": "The end date cannot be before the start date.",
  "copy.c9f48253f21e": "The selected date range is too large.",
  "copy.d3da6ac68787": "A focus session is already running.",
  "copy.b2451eb290f2": "This focus session has already ended.",
  "copy.9f28c77266f0": "This record has already been converted into another item.",
  "copy.24b3417c7991": "Local data is out of date. Synchronization is required.",
  "copy.1bbfacaf52ac": "The table schema was updated elsewhere. Load the latest version and try again.",
  "copy.dfd828ce9648": "The schema change conflicts with the existing field contract.",
  "copy.d7c79850987c": "The schema draft you want to edit is no longer available.",
  "copy.d392ee8d6c5c": "This relation cannot be created between the selected record types.",
  "copy.9e38325184e6": "This record has reached the allowed number of relations.",
  "copy.2024ae73a2bc": "The same relation already exists between these records.",
  "copy.0f9c0f87258d": "More records were sent than a single action allows.",
  "copy.206c75ac5e79": "This application version is no longer supported. Update the application.",
  "copy.a66f1848dfd8": "The file is not a supported Exognitos backup.",
  "copy.30fe16bc36fb": "The backup file is damaged or incomplete.",
  "copy.6ddace0f7eca": "The backup file exceeds the allowed size.",
  "copy.72a99d31ccfc": "Restoring a backup requires explicit confirmation.",
  "copy.a17c324d6700": "Browser notifications are not configured on this server.",
  "copy.29d574450a54": "The period's end date cannot be before its start date.",
  "copy.e5fe4bc69ee9": "The record linked to this rationale was not found or is no longer available.",
  "copy.40fdeba4f745": "This replanning session has closed. Start a new session.",
  "copy.4b0fee1a08c2": "This deviation has already been resolved. Load the latest version.",
  "copy.8ec85d81583e": "The selected day falls within protected time. Choose another day or explicitly override the protection.",
  "copy.83e3c078ed2a": "The server could not be reached. Check your connection.",
  "copy.b4c203ba1d0a": "A server error occurred. Try again shortly.",
  "copy.7fad5c1a42c1": "The record was not found.",
  "copy.f30ce6821950": "The action conflicts with existing records. Refresh the page and try again.",
  "copy.74f1eed84c64": "Some information is invalid. Check the fields.",
  "copy.dc76c143a8bb": "The action could not be completed. Check the information and try again.",
  "copy.5ad34b7b9e46": "This field is required.",
  "copy.5331105d3b00": "Enter a valid email address.",
  "copy.1f29b340def0": "This password is too commonly used.",
  "copy.ddf3cd86eb73": "The password cannot contain only numbers.",
  "copy.03ec540fd4cc": "This value is invalid.",
  "copy.45a69c97967f": "The password must contain at least {{value1}} characters.",
  "copy.5800d22ccc2b": "The password is too similar to your personal information.",
  "copy.c60bd32ff1ec": "The value entered for this field is invalid.",
  "copy.7db8bd713a33": "The server could not be reached.",
  "copy.643f2c5b4ff3": "The action could not be completed.",
  "copy.87cbe59e5f41": "Task",
  "copy.7b321d627cb1": "Project",
  "copy.a3cb7fba638e": "Note",
  "copy.e3d25a0d55e8": "Routine",
  "copy.a3973f7cd7c0": "Goal",
  "copy.8310d07b9e6c": "Period",
  "copy.5ec70189e795": "Knowledge item",
  "copy.98396a60bb07": "Concept map",
  "copy.fa8ed0bdabdd": "Plan",
  "copy.4bacae8886aa": "Life area",
  "copy.2eeda58d5020": "Life table",
  "copy.c335f493996c": "Life record",
  "copy.5785a01da6e0": "Calendar",
  "copy.baae303c2a0f": "Day, week, month, and year planning",
  "copy.7d03cf59fb3b": "Tasks",
  "copy.58e16151b552": "All tasks",
  "copy.dd14cd6ede95": "Routines",
  "copy.aa6a83bfcde1": "Plans",
  "copy.2f4bf8602006": "Bring tasks, routines, and goals together over a time range",
  "copy.9cba11f2a318": "Workdesk",
  "copy.4068257604e3": "Work workspace overview",
  "copy.30bcb5bccd3e": "Projects",
  "copy.cf33e2c6e655": "Keep plans, tasks, routines, and knowledge together",
  "copy.959f1d1df29f": "Notes",
  "copy.e047cbc6ad0b": "Knowledge space",
  "copy.0603d7e36963": "See your collections and notes on one workspace",
  "copy.ee541d33413a": "Drafts",
  "copy.b634acc71119": "Archive",
  "copy.009e9385f1fb": "Trash",
  "copy.b377e5f91efa": "Life tracking",
  "copy.dda0b6d08a1c": "See moments and time-based life records together",
  "copy.549645665df6": "Knowledge",
  "copy.7796f329d977": "See knowledge items and their connections",
  "copy.11e580db2092": "Life areas",
  "copy.d1fed43771b2": "Build your own structure of tables, columns, and records",
  "copy.67ed883ba47d": "Life guide",
  "copy.4a6c03490a93": "Record your values, principles, thoughts, and boundaries in your own structure",
  "copy.6074721d9400": "Periods",
  "copy.961304f44e7c": "Analysis",
  "copy.2b0919f10d2e": "Find patterns and insights in your data",
  "copy.2d8c97defc9e": "Rediscover",
  "copy.d320a13654f8": "History",
  "copy.80ad54ad05fa": "Settings",
  "copy.e1a10bdd81df": "Planner",
  "copy.f86dcfafd6d1": "Plan, act, and focus",
  "copy.b061c83841e3": "Work",
  "copy.29a87f2ba4f6": "Contexts for creating and focused work",
  "copy.26dade3a1507": "Memory",
  "copy.0684f4eb38a7": "Capture, connect, and reuse knowledge",
  "copy.71317e48f579": "Life",
  "copy.6ba50b24e4ae": "Track, structure, and understand your life data",
  "copy.c46cfde0f057": "Find insights and patterns in your data",
  "copy.3fc29bcc049b": "Plan details",
  "copy.a5980e637f70": "Project details",
  "copy.4c4df10d00cb": "Task details",
  "copy.f03037978607": "Routine details",
  "copy.5b2983bb53d0": "Note editor",
  "copy.c9a1e072cd88": "Period details",
  "copy.9299e36c6bec": "Workspace",
  "copy.1c466db79243": "System",
  "copy.4c5c101be403": "Mon",
  "copy.59cc0fc7e93e": "Tue",
  "copy.6d46ddd615db": "Wed",
  "copy.89ac4dc9eddf": "Thu",
  "copy.5f9967713ae0": "Fri",
  "copy.36986d15c759": "Sat",
  "copy.3b4ca471d9af": "Sun",
  "copy.c7679d3a2c18": "Every day",
  "copy.425685711478": "Every {{value1}} days",
  "copy.a841b044d7ae": "Once a week",
  "copy.cd082065cfe1": "{{value1}} times a week",
  "copy.a561ec4066fd": "Independent",
  "copy.20d18d9e162a": "Shown everywhere",
  "copy.23752e864336": "Hidden in general lists",
  "copy.f015ffefb5c5": "Independent task",
  "copy.387c05650d00": "Next routine occurrence",
  "copy.29d2601c1cc3": "Later routine occurrence",
  "copy.374f93c061f6": "Visible because it has a date",
  "copy.46bc92eca915": "Next undated task in the plan",
  "copy.edca6b60ebec": "Visible after preceding open tasks are completed",
  "copy.7ffb404f5335": "Next undated task in the project",
  "copy.752080617cc8": "In completion history",
  "copy.dc009da85cbc": "In archive history",
  "copy.24093ff710a4": "There are {{value1}} open tasks before it.",
  "copy.f50ee96c17a4": "Visible in general lists",
  "copy.9c7970eec763": "Show everywhere · {{value1}}",
  "copy.b4403213c392": "Hide · {{value1}}",
  "copy.fc10d5f347e6": "Automatic · {{value1}}",
  "copy.532275a1cb66": "No data yet",
  "copy.03678eb372d7": "Very low",
  "copy.80b78d1e3818": "Low",
  "copy.e8d77d452a3b": "Moderate",
  "copy.eff9d592c1c0": "Good",
  "copy.573a921d8664": "Very good",
  "copy.1d71dba89fb1": "No records yet.",
  "copy.86cb1249fd5d": "Press Enter or Space to select a node. Press Escape to clear the selection.",
  "copy.83891e141c9c": "Press Enter or Space to select a node. Use the arrow keys to move it and Escape to clear the selection.",
  "copy.b87f6b1a3bf7": "The selected node moved {{value1}}. New position: {{value2}}, {{value3}}.",
  "copy.26da7e2e0e64": "Press Enter or Space to select a relation. Press Escape to clear the selection.",
  "copy.447cc1d4ba62": "Map view controls",
  "copy.c2655422772b": "Zoom in",
  "copy.2e4fb0e2949e": "Zoom out",
  "copy.0a8ac1e09e3c": "Fit map to view",
  "copy.a1b8c5c2b054": "Toggle map interaction",
  "copy.479249dedf9f": "Map overview",
  "copy.04e319632d00": "Connection point",
  "copy.ec3d96ac7b9e": "Data view controls",
  "copy.17233932ffda": "Search",
  "copy.71dd445d67c3": "{{value1}} records selected",
  "copy.132d75b59dc0": "records selected",
  "copy.ec8bffdf896f": "Clear selection",
  "copy.751b16b2e216": "Drag to reorder",
  "copy.1f1ec06befc3": "Page index",
  "copy.58673ce3348d": "Workspaces and application links",
  "copy.d1369c913096": "All pages",
  "copy.ce62513278b0": "Workspaces",
  "copy.55f65dccaf0e": "Life & thought",
  "copy.bc92d677c3c6": "Skip to content",
  "copy.b2b27ec9d43c": "An error occurred · Exognitos",
  "copy.fd2dd2868fa0": "The server could not be reached",
  "copy.7425beb94bea": "There is a server problem",
  "copy.984e2985dfba": "Something went wrong",
  "copy.84a6a839fa04": "Check your connection and try again. Your saved data is still there.",
  "copy.e2a5508d620d": "The problem is on our side. Try again shortly.",
  "copy.a07db22fd3a9": "This screen encountered an unexpected problem. Your data is still there.",
  "copy.0ce9380b07f8": "Try again",
  "copy.261b635999f7": "Back to Planner",
  "copy.239465761503": "Page not found · Exognitos",
  "copy.bbed3440afef": "This page does not exist",
  "copy.995ef3984833": "The link may be outdated, or the content may have been deleted.",
  "copy.e2400cb26b87": "Loading page",
  "copy.443f816b565c": "Minimized windows",
  "copy.d07d06d4e2a6": "Restore {{value1}} window",
  "copy.3ed7ccf473c8": "Untitled",
  "copy.c5a55750f2ce": "Back to Workdesk",
  "copy.203a1579c591": "Back to project plan",
  "copy.9bb92dc4d3ae": "Back to {{value1}} project",
  "copy.a88fc2d1c7ea": "Back to project",
  "copy.c5ab5d0dc391": "Back to plan",
  "copy.5dc3474f0711": "Back to task",
  "copy.f81caa6f480d": "Back to routine",
  "copy.9c81b243c51c": "Back to note",
  "copy.76741a32b1d4": "Back to period",
  "copy.8355265d008c": "Back to life record",
  "copy.34e1c0595af6": "Back to history",
  "copy.5aefae4377d6": "Back to analysis",
  "copy.49f596f88479": "Back to knowledge item",
  "copy.ca78b719f170": "Back to concept map",
  "copy.6cbfb2590062": "Back to projects",
  "copy.1dc4ec2e1967": "Back to plans",
  "copy.bb285b384f1c": "Back to tasks",
  "copy.03fabdadb999": "Back to routines",
  "copy.4f1c00ad874e": "Back to knowledge network",
  "copy.b24f012c1869": "Back to Life guide",
  "copy.64be65f73da2": "Back to notes",
  "copy.855e18b676c9": "Circular day planner",
  "copy.4e9016e6ce4a": "Place here",
  "copy.7524e44d4191": "Scheduled task",
  "copy.04a13eafafa1": "Moving",
  "copy.acda530e0d25": "Calendar item",
  "copy.2b7c2ee34693": "Afternoon",
  "copy.39a8d28c1c6b": "Cancel",
  "copy.b910012e68ff": "This action cannot be undone.",
  "copy.fbfceccd03c0": "Duration",
  "copy.6b16ec3bfae3": "No duration",
  "copy.7bd8b8264c4e": "Custom",
  "copy.81dfbc43b5dd": "Custom duration (minutes)",
  "copy.d0ae62b4ee81": "Neutral",
  "copy.3902002d5818": "Details",
  "copy.5ac8da480f5d": "No metadata",
  "copy.1279defd4dff": "{{value1}} more metadata fields",
  "copy.e7162b9c2884": "more metadata fields",
  "copy.7b31a9fc4816": "Close",
  "copy.c1fe2ecdff02": "Save",
  "copy.5914f47999f8": "You have unsaved changes.",
  "copy.7b294c635e76": "Back to editing",
  "copy.7696d78c4ec1": "Discard changes",
  "copy.8738e52615b2": "Record details",
  "copy.e462ec557398": "Minimize details",
  "copy.40a89eeb71ab": "Close details",
  "copy.a44a14bc618a": "Hide linked records",
  "copy.8d7a3495dbfe": "When the context filter is enabled, only records belonging to this context are shown.",
  "copy.11a9cad73496": "Theme",
  "copy.694af45beeaa": "Your choice is saved in this browser and applied to the entire interface immediately.",
  "copy.4c6b4fc770bb": "Choose {{value1}} theme",
  "copy.45957ab68170": "Active theme:",
  "copy.6b65f1920bb2": "Undo",
  "copy.fc2cbca9acbe": "Notifications",
  "theme.light": "Light",
  "theme.mint_breeze.label": "Mint Breeze",
  "theme.mint_breeze.description": "Cool mint and soft mist tones for a breathable, calm interface.",
  "theme.paper_glow.label": "Paper Glow",
  "theme.paper_glow.description": "Warm paper-like ambience with muted peach accents.",
  "theme.sandstone_rose.label": "Sandstone Rose",
  "theme.sandstone_rose.description": "Calming rose and warm clay hues with gentle texture depth.",
  "theme.sunset_amber.label": "Sunset Amber",
  "theme.sunset_amber.description": "Amber glow with a warm, low-noise atmosphere and clear contrast.",
  "theme.lavender_veil.label": "Lavender Veil",
  "theme.lavender_veil.description": "Soft lavender planes with bright, dreamy contrast.",
  "theme.ocean_mist.label": "Ocean Mist",
  "theme.ocean_mist.description": "Deep misty blue-green calm with crisp blue accents.",
  "theme.forest_night.label": "Forest Night",
  "theme.forest_night.description": "Dark forest greens for a grounded and readable evening palette.",
  "theme.midnight_cobalt.label": "Midnight Cobalt",
  "theme.midnight_cobalt.description": "Intense cobalt depth with energetic accent highlights.",
  "theme.copper_rust.label": "Copper Rust",
  "theme.copper_rust.description": "Rusty copper warmth with strong editorial contrast.",
  "theme.choice": "{{label}} theme",
  "language.label": "Language",
  "language.description": "Your language is saved on this device. It does not change your theme, timezone, or data.",
  "time.minutes_short": "{{count}} min",
  "time.hours_short": "{{count}} hr",
  "time.minutes_one": "{{count}} minute",
  "time.minutes_other": "{{count}} minutes",
  "time.hours_one": "{{count}} hour",
  "time.hours_other": "{{count}} hours",
  "time.just_now": "just now",
  "time.today": "Today",
  "time.tomorrow": "Tomorrow",
  "time.yesterday": "Yesterday",
  "time.day_after_tomorrow": "The day after tomorrow",
  "time.last_weekday": "last {{weekday}}",
  "time.days_overdue_one": "{{count}} day overdue",
  "time.days_overdue_other": "{{count}} days overdue",
  "time.due_today": "Due today",
  "time.due_tomorrow": "Due tomorrow",
  "time.due_on": "Due {{date}}",
  "time.good_night": "Good night",
  "time.good_morning": "Good morning",
  "time.good_day": "Good afternoon",
  "time.good_evening": "Good evening",
  "native.sign_in": "Sign in to Exognitos",
  "native.sign_in_description": "Connect to your Exognitos server. Your browser handles sign-in and asks you to approve access.",
  "native.server": "Exognitos server",
  "native.server_hint": "Use the HTTPS address of a server running API v4.",
  "native.local_server_hint": "This test build also accepts localhost for an isolated local server.",
  "native.connection_error": "Connection or authorization failed. Check the server address and its native OAuth configuration, then try again.",
  "native.waiting": "Complete sign-in in your browser, then return here.",
  "native.continue_browser": "Continue in browser",
  "native.retry": "Try again",
  "native.authority_notice": "Some account, search, collection, archive and review actions require the web application. This app follows your server’s access permissions.",
  "copy.699b4a551d76": "Overview",
  "copy.1d5b5f2fb570": "Trends",
  "copy.75cf28d95789": "Deviations",
  "copy.9b93ee902529": "Multiple deviations were recorded in the same context.",
  "copy.c0d83b327132": "Planned and actual time were measured together.",
  "copy.56106f8c3c04": "Routine continuity was calculated from actual occurrences.",
  "copy.1d39fe4c3871": "Numeric life records were summarized for this range.",
  "copy.42f02731387b": "Authored mood and energy records were included in the measurement.",
  "copy.ca07eb82fb55": "Dated life records were included in the measurement.",
  "copy.2db63f1d98f1": "No deviations were recorded in this range.",
  "copy.2ade08ae6b1a": "The same deviation condition was recorded more than once.",
  "copy.64769a49a981": "Some deviations have no recorded outcome yet.",
  "copy.0364504faab3": "Some deviations have no specified condition.",
  "copy.7f51bf511c20": "There is no active period for this date.",
  "copy.8381409980cd": "There is no active project link for this date.",
  "copy.0b28eaaa77e8": "There are no scheduled tasks for this date.",
  "copy.1009134016cb": "Planned time exceeds available time.",
  "copy.72de145888c6": "A task was rescheduled more than once.",
  "copy.2d1e1205df1c": "Very low",
  "copy.4e6fff651df2": "Very good",
  "copy.fd3d95cea97b": "Confidence",
  "copy.6d1683d52eef": "Distance",
  "copy.4601f9a1d3c4": "Knee pain",
  "copy.6b2c64c33c7d": "Page",
  "copy.4151250b6689": "Sleep duration (hours)",
  "copy.98a3d97c81d6": "Steps",
  "copy.696bcfffe839": "Water intake (liters)",
  "copy.f10033600f55": "Weight (kg)",
  "copy.d17e14562cbb": "Numeric field",
  "copy.484e8fa0f70a": "not recorded",
  "copy.3acbd1590a90": "The same context",
  "copy.8141adb3a99e": "Multiple deviations were recorded in the {{value1}} context.",
  "copy.f3d3bf8d2c18": "Deviations recorded in the {{value1}} context: {{value2}}.",
  "copy.519982f3d8bb": "Calendar time planned: {{value1}}; focus time recorded: {{value2}}.",
  "copy.84a19fe29091": "Routine continuity was measured from actual task occurrences.",
  "copy.96f9d2806fba": "Of {{value1}} occurrences, {{value2}} were completed; {{value3}} were skipped and {{value4}} are pending.",
  "copy.b449abf000ef": "records",
  "copy.14af565f2265": "{{value1}} records",
  "copy.ed2e844e2fae": "The measurement includes {{value2}} from the {{value1}} field.",
  "copy.3675817f5631": "The measurement includes {{value2}} from the {{value1}} field; average: {{value3}}.",
  "copy.14159b3c3448": "the selected day",
  "copy.ee6de1dbafb9": "written records",
  "copy.97fcd63cf9f0": "{{value1}} written records",
  "copy.8e415df86bf9": "On {{value1}}, {{value2}} were included in the measurement; no energy was recorded.",
  "copy.e6b4ee44bac5": "On {{value1}}, {{value2}} were included in the measurement; average authored energy: {{value3}} / 5.",
  "copy.344b7835a532": "Life record",
  "copy.f5b64ff49d36": "{{value1}} records were included in the measurement.",
  "copy.982c6f38d5d6": "{{value1}} {{value2}} records were included in the measurement.",
  "copy.5e4a238aadec": "{{value1}} exceeded its recorded time window.",
  "copy.70a9d46755bf": "{{value1}} exceeded its recorded time window by {{value2}} days.",
  "copy.ff03194dc047": "{{value1}} has not started although its recorded start window has passed.",
  "copy.eea14284812e": "{{value1}} has not started although its recorded start window passed {{value2}} days ago.",
  "copy.20577048b0e8": "There is no recently recorded activity in the {{value1}} project.",
  "copy.10951f1553bf": "The {{value1}} project has had no recorded activity for {{value2}} days.",
  "copy.2b44d498d4f1": "There is a measurable divergence in the {{value1}} context.",
  "copy.5c5336d36545": "A measurable divergence was found in the source records.",
  "copy.c949e5056385": "Calendar placement",
  "copy.9afc2661b32a": "Focus session",
  "copy.7e66fc1eda75": "Journal entry",
  "copy.5fd08a10a4ff": "Plan deviation",
  "copy.344c6690297b": "Unidentified source",
  "copy.3d843d6e3095": "Open {{value1}} source",
  "copy.8967bf5f1528": "This record type does not yet have a separate detail page.",
  "copy.5f9a33e8602e": "— no separate detail page",
  "copy.f7ac9438c7ac": "There is no individual source record available to open for this finding.",
  "copy.92c0ad8f65cb": "Evidence (",
  "copy.194083615c73": "records)",
  "copy.fe9500ac9e85": "Evidence for this finding",
  "copy.0c296d035246": "Evidence",
  "copy.e118d133ba8b": "No findings yet",
  "copy.3a5cf1bd20f0": "Measurable findings appear here when enough actual records are available.",
  "copy.063a8f65a3f6": "Analysis view and date range",
  "copy.296ccc7ac21e": "Start",
  "copy.b649bea15b42": "End",
  "copy.b7b6b66d6c2e": "Analysis view",
  "copy.eb85025f57e9": "Current context",
  "copy.a747cea0c329": "Canonical context as of {{value1}}",
  "copy.5e1e575acb6b": "No period or active project intersects this date",
  "copy.e230256f8ba5": "This is not a deficiency score; it only indicates that the recorded context is currently empty.",
  "copy.e3abcbedc634": "Data coverage",
  "copy.27d35a2e26a5": "Missing values are not converted to zero",
  "copy.af961eb8d285": "Observed rows",
  "copy.10e6f00b7502": "Recorded evidence",
  "copy.cd24803b7cff": "Sources with no records: {{value1}}.",
  "copy.b1f72c2a7760": "There is no apparent data gap in the measured sources for the selected range.",
  "copy.dbc593009c51": "Near future",
  "copy.b9474df99b17": "Periods starting in the next 30 days and dated tasks",
  "copy.3eefd413ee4a": "Further ahead",
  "copy.20fa3d48d99a": "Recorded periods starting within the next 12 months",
  "copy.259075025473": "Attention",
  "copy.41f396a42da5": "Observations derived from dates or placement status, without interpretation",
  "copy.09fe9088c99f": "No outstanding date-based observations",
  "copy.228217a1e3b8": "Guide links",
  "copy.cd91cdc72b84": "Only explicitly created relationships; no causal inference",
  "copy.57a8267df748": "No explicit relationships recorded",
  "copy.ea8a2740a284": "When links are created, their sources and targets appear together here.",
  "copy.cef049823785": "Growing record sets are loaded in pages.",
  "copy.fd7d07094dc1": "Load more records",
  "copy.573e90743b12": "No records in this horizon",
  "copy.0caf9a767222": "Open {{value1}} details",
  "copy.4784133a2fe1": "The recorded task date has passed",
  "copy.23dc5f94a13a": "The recorded task date is approaching",
  "copy.f6437feca11e": "Period not placed on the timeline",
  "copy.ca04b86cecd5": "Recorded observation",
  "copy.95a1a1eb1c15": "Planned time",
  "copy.88f63ff8f47f": "Focus time",
  "copy.6a43e17f4f05": "Completed tasks",
  "copy.d72fe8884788": "Recorded deviations",
  "copy.2b15be480619": "Completed routines",
  "copy.aec60a8ea768": "Average energy",
  "copy.5aef8bcda265": "Time trend",
  "copy.194b188bc9a3": "Planned time and actual focus time",
  "copy.72a4b79c5bf7": "Insufficient data",
  "copy.593d3fe06c7e": "More planning and focus records are needed in this date range to show a trend.",
  "copy.66b695b479e7": "The upper bar shows planned time; the lower bar shows actual focus time.",
  "copy.f1b7a9e2b978": "Findings",
  "copy.3687c5cb487d": "Routine continuity",
  "copy.61f0c68a3576": "Expected and actual routine tasks",
  "copy.ef196020d311": "{{value1}} skipped · ",
  "copy.c12aa0229d2a": "pending",
  "copy.9d506c74dd6c": "Numeric life fields",
  "copy.c87862b6bf93": "Measurements from dated life records",
  "copy.f217f705fd62": "records ·",
  "copy.0dd43d35b19a": "Average",
  "copy.fd54ce5b9748": "Mood and energy",
  "copy.8fdeeb6f88ef": "Only journal entries authored by the user",
  "copy.9c750b75af2e": "No energy recorded",
  "copy.c7719dae5c2b": "Life records",
  "copy.ac31649e2ee1": "Counts of dated records in this range",
  "copy.d324292349b1": "Planned and actual",
  "copy.51223baa29e4": "Missing durations are not counted as zero",
  "copy.f3f9b0259529": "No comparable durations",
  "copy.3eb8bbc406d0": "Calendar time or completed focus records appear here when available.",
  "copy.a82544bb3657": "Findings with sources",
  "copy.87458bca1155": "Deviations are derived from recorded facts",
  "copy.e4d81304ba80": "Recurring conditions",
  "copy.c3855400049f": "The order is neither a recommendation nor a score",
  "copy.1194b8be7571": "No recorded deviations",
  "copy.3c3d5749f0fe": "The distribution of causes appears here when deviations are recorded in Planner.",
  "copy.6317eac1d512": "Unspecified",
  "copy.316286aea87b": "No weekly time has been allocated to this period, so its work cannot be converted into a duration.",
  "copy.9468d201fb20": "Recurring work takes {{value1}} per week; ",
  "copy.a3bb29ba1318": "the weekly budget is {{value1}}. There is no room left for one-off work.",
  "copy.2910bab29902": "At the stated weekly pace, the estimated one-off work takes approximately {{value1}} weeks ",
  "copy.ca8a928aa918": "({{value1}} tasks with estimates).",
  "copy.d9c87f0b0151": "The window shown on the timeline is an exact interval of {{value1}} weeks.",
  "copy.48670957fdb8": "This is {{value1}} weeks less than the total work duration.",
  "copy.dff2ee89e800": "Tasks without estimates: {{value1}}; excluded from the totals.",
  "copy.f8df5456119a": "Routines without durations: {{value1}}; excluded from the weekly load.",
  "copy.354bfd95e5d0": "There is no active Life guide record; the broader context for this work has not yet been defined.",
  "copy.c74bd57b27ca": "No period covers {{value1}}; this day is not linked to a broader context.",
  "copy.afaf741ff611": "Work items scheduled for this day: {{value1}}, but no period includes the day; ",
  "copy.a2a4c1380a39": "the day's work cannot be linked to a longer-term context.",
  "copy.6323ec5ae9a0": "Nothing has been placed on the calendar for this day.",
  "copy.7851760053ab": "A period covering this day is marked as protected rest.",
  "copy.655acd482ec9": "None of today's work is linked to a Life guide record; ",
  "copy.16a5a0e0e929": "so the day's purpose is not recorded.",
  "copy.7b97c112fd51": "Today's scheduled work relates to: {{value1}}.",
  "copy.1e808629eebc": "The day is over capacity by {{value1}}.",
  "copy.11018460e9df": "The plan fits but leaves almost no free time.",
  "copy.92d79fac35b4": "Scheduled work items that no longer fit in the remaining day: {{value1}}.",
  "copy.3e667ff7256f": "Everything scheduled for today has been completed.",
  "copy.4eba3c1dbd69": "Work is scheduled inside a period marked as protected rest: {{value1}}.",
  "copy.e5db616b8247": "This day is inside a strict protected window: {{value1}}.",
  "copy.86b0c38656a8": "This day is already over capacity.",
  "copy.28c3342258ae": "Only {{value1}} is free; this work requires {{value2}}.",
  "copy.10a04d3b82e9": "Work items here that can be moved: {{value1}}; ",
  "copy.985fd90fbf9f": "moving them would free {{value1}}.",
  "copy.b7cff901f682": "Fixed commitments on this day that cannot be moved: {{value1}}.",
  "copy.a10aaa33ec2b": "A layer in this work's context chain is marked as protected; moving it would conflict with a prior decision.",
  "copy.7dfa9838ecea": "This work's rationale states that its timing is fixed.",
  "copy.2a341eb18771": "If not done: {{value1}}",
  "copy.6133f0807b52": "Minimum version: {{value1}}",
  "copy.81b65fd6c3cb": "No reason for this work is recorded anywhere in its context chain; ",
  "copy.9422ff8c3b16": "there is no recorded basis for weighing this move.",
  "copy.a7076ba728da": "There is no recorded plan deviation in this range.",
  "copy.1bc02f40bf84": "The most frequently recorded condition was '{{value1}}', recorded {{value2}} times.",
  "copy.26bc24b31e8e": "Deviations still awaiting a decision: {{value1}}.",
  "copy.b7e837ef59e8": "'{{value1}}' deviated {{value2}} times in this range.",
  "copy.a1b8e0fa4c5e": "Of {{value1}} deviations, {{value2}} have no recorded condition; ",
  "copy.a0408b5ebf7f": "they are therefore excluded from the counts above.",
  "copy.bec111a03f58": "There are no recorded Life guide entries yet.",
  "copy.b5245233af13": "Over the last {{value1}} days, of {{value2}} active Life guide entries, ",
  "copy.6fd14fb5ada1": "{{value1}} were not referenced by any scheduled work.",
  "copy.23a84669b07a": "Over the last {{value1}} days, of {{value2}} values, ",
  "copy.579cba010278": "Life guide entries not referenced by any rationale: {{value1}}; ",
  "copy.b5c3e0e0b20a": "so no work could refer to them.",
  "copy.a204852333db": "Values not linked to any work or rationale: {{value1}}.",
  "copy.3850d2f9d5b8": "Every recorded Life guide entry was referenced by a work item.",
  "copy.293d5b1aa033": "Every recorded thinking session has been distilled.",
  "copy.8a23cc20edef": "Thinking sessions not yet distilled: {{value1}}. The oldest began on {{value2}} ",
  "copy.c464c1ada355": ".",
  "copy.56ba1b4212e8": "Of these, {{value1}} were AI conversations; they leave no lasting record on their own.",
  "copy.b318dcb978db": "health",
  "copy.7e4f926c3ad8": "other work",
  "copy.02b15c6e3b82": "external demand",
  "copy.9529971f2657": "social pull",
  "copy.389dc4ac4cea": "interruption",
  "copy.f2800545f5c6": "unsuitable environment",
  "copy.a832ec323637": "unclear first step",
  "copy.eab25f465c20": "overloaded day",
  "copy.72c12a1bcb29": "impulse",
  "copy.fc0f08491017": "missed timing",
  "copy.0b43fef81114": "change of mind",
  "copy.6cceb6797962": "Other",
  "copy.74a138bb214e": "Starts on {{value1}}",
  "copy.1bc5d1757c18": "No date range",
  "copy.3e5935f82e60": "Project plans could not be loaded",
  "copy.38121313783e": "The roadmap is built from existing Plan records.",
  "copy.243127822c10": "This project has no execution path yet",
  "copy.709244e9bc0c": "Create a Plan or add the project's first task; the roadmap will form from these records.",
  "copy.f986b9614445": "Create plan",
  "copy.c91aba09216b": "Add task",
  "copy.dcd046ec2dbc": "Roadmap",
  "copy.a096c030358a": "plans ·",
  "copy.d1b13d4a8f86": "tasks",
  "copy.00d5877e44d8": "{{value1}} roadmap section",
  "copy.6e2a79f55473": "This plan has no tasks yet.",
  "copy.407e36e98956": "Unplanned tasks roadmap section",
  "copy.ff31f68d2e4e": "Tasks without a plan",
  "copy.57f71ccb1495": "Expand {{value1}} plan",
  "copy.e369bc68f28f": "Collapse {{value1}} plan",
  "copy.a5dad7f25733": "Add task to {{value1}} plan",
  "copy.9c8dc1cf5b36": "Expand {{value1}} section",
  "copy.1a8c381978b5": "Collapse {{value1}} section",
  "copy.b82be70f7b41": "Project tasks with no plan link",
  "copy.d9213c57bd8f": "Task without a plan",
  "copy.f7bbb5f5f938": "{{value1}} roadmap row",
  "copy.221b0d54eba1": "{{value1}} has a fixed order because it was generated by a routine",
  "copy.67ff73739d5f": "Move {{value1}} task on the roadmap",
  "copy.d95ff01826ea": "Complete",
  "copy.402abf10461d": "{{value1}} task options",
  "copy.3016b062babe": "Roadmap section",
  "copy.ee1cd50e9422": "Automatic",
  "copy.8ef99fb122d4": "Remove as next action",
  "copy.85d47e334f73": "Set as next action",
  "copy.73c20fa761c3": "Incubating",
  "copy.41d1408114e4": "Queued",
  "copy.9025b4af025a": "Waiting",
  "copy.358761a6d440": "Abandoned",
  "copy.863970dc7976": "Slow",
  "copy.03ce5e32d829": "Steady",
  "copy.d5fc8b35a698": "Strong",
  "copy.a7b0faa129e1": "Projects could not be loaded",
  "copy.a0c660e99ca9": "Your projects cannot be reached right now.",
  "copy.f89cb491abf6": "New project",
  "copy.c1d13d7c2006": "Pinned work context",
  "copy.de7a323e3316": "Pinned work context",
  "copy.a8a6638f858e": "Unpin",
  "copy.1470a04d04f5": "Pinned project not found",
  "copy.d5d743df7db3": "The previously pinned Project is not in the active list; it may have been archived, completed or removed. The pin has not been cleared automatically.",
  "copy.41c371264c71": "Clear old pin",
  "copy.4605a3f88446": "Project list",
  "copy.82a9662f058f": "Project list filters",
  "copy.8f93ad45246c": "Project view",
  "copy.f5f4274fb83a": "Grid",
  "copy.82bc3b799a70": "Project scope",
  "copy.f43a65ad8268": "All",
  "copy.db43eb3a415c": "Waiting",
  "copy.9f69ace7d31c": "Quiet",
  "copy.7aa2f0cd1743": "No projects yet",
  "copy.cff38bcaeb76": "Set up your work as a project and connect its context to your values.",
  "copy.5b1cbf5f0da1": "Create project",
  "copy.71f8ea0c4304": "No projects in this scope",
  "copy.ccf6d08b16aa": "The selected scope is currently empty. Choose All to see every project.",
  "copy.684b63183ab9": "Show all",
  "copy.6963914f2d1d": "Next task",
  "copy.442afc0cf1b8": "Resume step",
  "copy.d1ac5a241441": "Next step",
  "copy.1b3bff965d67": "Not set yet",
  "copy.172b7d4d339b": "No activity yet",
  "copy.fd0a1d3aca32": "Active today",
  "copy.922273f761ca": "Active {{value1}} days ago",
  "copy.57dc2f7e8008": "Ongoing",
  "copy.2202120a7050": "Pinned context",
  "copy.aa84ba71b83e": "On today's calendar",
  "copy.a8fccb947f36": "open tasks",
  "copy.5e2de63aa88b": "Work on {{value1}} project",
  "copy.2fa8031dc345": "Work",
  "copy.c8def36b1e87": "{{value1}} project actions",
  "copy.9427ff3c9348": "Pin as work context",
  "copy.d74672c7a485": "Reorder {{value1}} project",
  "copy.f5c3d31594e2": "open",
  "copy.d11adcf86204": "Rationale",
  "copy.551dcd000b65": "Target date",
  "copy.342e3acf41bd": "The record could not be saved. Your input has been preserved; you can try again.",
  "copy.17365728fdeb": "New goal",
  "copy.b3c4dd8fb911": "New decision",
  "copy.3db72c32a531": "Edit record",
  "copy.dde0156891d6": "The record could not be saved. You can try again.",
  "copy.c52a645e2e52": "The target date cannot be before the start date.",
  "copy.f08d0ac673b6": "Edit project",
  "copy.54bdf889f3b7": "New project",
  "copy.1cff8a95c840": "Type",
  "copy.5d2de8a024e9": "Project type",
  "copy.8b1d8ef85a5c": "Finite",
  "copy.b45241034f39": "It has an endpoint. Progress is shown as the percentage of completed steps.",
  "copy.df2e77d167d2": "It continues without an endpoint. Momentum is shown instead of progress because a percentage would be meaningless.",
  "copy.bfc1b3ab3841": "Start date",
  "copy.bcfa426cc696": "Optional.",
  "copy.2606f5319785": "Target date",
  "copy.b69c98ecf1ff": "Initial status",
  "copy.61bb51ce89c0": "What is this project?",
  "copy.11fa42d8d90f": "You will read this when you return months later.",
  "copy.18e58c7f199e": "A neutral color is used if left empty.",
  "copy.7c8913909479": "Preparing",
  "copy.bc54ef813b1f": "Abandoned",
  "copy.047c2449e34f": "Move to draft",
  "copy.07d3d48ca151": "Move to preparation",
  "copy.961372575881": "Queue",
  "copy.408ea7f6cf64": "Activate",
  "copy.f833e2ee282f": "Put on hold",
  "copy.2a095c3cabfc": "Complete project",
  "copy.33b676b0f6bc": "Mark as abandoned",
  "copy.3b160a96f171": "Project could not be loaded",
  "copy.afe760df18ad": "The project context cannot be reached right now.",
  "copy.d612732f3b38": "days without activity",
  "copy.3daf2fff2c2c": "Start working",
  "copy.191b0603d4f0": "Open focus",
  "copy.e1c82b244d81": "Hide inactivity notice",
  "copy.1ec7d153bbba": "Project archived",
  "copy.e06a6ae0d6e1": "Project status:",
  "copy.735cc1089609": " Last active {{value1}} days ago.",
  "copy.ee032de9519b": "Plan and tasks",
  "copy.abbbdafe41fa": "Knowledge",
  "copy.cafb2d991bbe": "Records",
  "copy.1ab7d4e05916": "Project panels",
  "copy.dc1584411506": "Project pulse",
  "copy.0da445e7ea0c": "{{value1}}% complete",
  "copy.88a93acfd287": "steps complete",
  "copy.91153b6dcd8d": "Ongoing momentum",
  "copy.0ecb87dea952": "Activity over the last 14 days",
  "copy.709f61be9264": "Open work",
  "copy.6b8109fda8f4": "Total focus",
  "copy.b285e093161c": "last 30 days",
  "copy.a7e8918bb093": "Last activity",
  "copy.1f77b946be71": "None yet",
  "copy.5f0449fb0881": "Last 14 days",
  "copy.d3a509cbb45a": "No recorded activity in the last 14 days",
  "copy.aaea24fd087c": "Active on {{value1}} of the last 14 days",
  "copy.45f1df635ca2": "No recorded activity",
  "copy.d67fd1eade7d": "days with activity",
  "copy.cc84ed58d30c": "Next step",
  "copy.55621d139e10": "The next concrete work item in this project.",
  "copy.49a045dce14b": "Marked as next action",
  "copy.ad20041b627c": "Next open step",
  "copy.c8ac517ad54a": "Start focus",
  "copy.e214951b92fa": "Next step has not been set",
  "copy.08b7076f76cb": "You can set a task as the next action in Plan and tasks.",
  "copy.7e6015a1e7fd": "Recorded focus: {{value1}}",
  "copy.450e34383453": "Focus sessions recorded for this project.",
  "copy.b3f4ab9d9353": "No focus recorded yet",
  "copy.d788d83a1661": "Start working opens this project in Workdesk, where you can begin a focus session.",
  "copy.69ee6c35cf67": "{{value1}} focus sessions",
  "copy.5ba42e6b3117": "Task focus",
  "copy.56a1b5e0a0a4": "Project focus",
  "copy.52fd74ad0e8c": "There are no scheduled time blocks for this project.",
  "copy.0f96e260e163": "Routines support practice, not progress tracking.",
  "copy.056888383259": "There are no routines linked to this project.",
  "copy.14f044ebc736": "Recent activity",
  "copy.1bd447ff7d11": "Execution flow",
  "copy.3ffe851b993c": "Recurring practices in this project. They are not included in the progress percentage.",
  "copy.17e65528e54c": "Add routine",
  "copy.087b5e1f5458": "No routines linked to this project",
  "copy.0d0e6b1179c4": "Set up a recurring practice as a routine; it runs separately from tasks.",
  "copy.9fe517066f83": "Plan flows",
  "copy.9c1e3e4e960c": "Plans are existing records; this area does not create a second Plan type.",
  "copy.88674a9343cb": "New plan",
  "copy.65b62fa2a97f": "This project has no plans yet",
  "copy.38ae071d3d47": "Create the first plan here, then add tasks and routines from its details.",
  "copy.92d52f5436f0": "routines",
  "copy.5961c82c4566": "Open flow",
  "copy.d7b10601ab66": "Project notes",
  "copy.bf8520b6670b": "The original note stays in Memory; it opens in the note window from here.",
  "copy.464553d5a5e5": "Open note window",
  "copy.c859ca9f6287": "No notes linked to this project",
  "copy.f9b6af81231d": "A note appears here when you link it to the project context in Memory.",
  "copy.f6e12c702775": "Use Workdesk to keep notes and maps open together; its note window supports up to ten tabs and can show two notes side by side.",
  "copy.74e539d03179": "The resume point could not be saved. Try again shortly.",
  "copy.186be30b87a9": "Where I left off",
  "copy.7398776fb04e": "May be outdated",
  "copy.b78b1dfbe6c9": "Edit context",
  "copy.ebb190623345": "Continue where you left off",
  "copy.58401602527e": "There is no context note for this project yet. Writing two sentences when you stop working saves the hardest part when you return.",
  "copy.8cb8ff0b6679": "Add context",
  "copy.d1d4842118a6": "Edit resume point",
  "copy.7a16ee08ad5d": "Record where you left off and the first step so you can quickly restore context when you return.",
  "copy.e80a64890ef6": "Where I left off",
  "copy.f7ffe853b913": "In your own words.",
  "copy.29a4b61730db": "Next concrete step",
  "copy.61c7d5146530": "The first thing you will do when you return.",
  "copy.4dc58bf18c71": "Your input is preserved.",
  "copy.229131437d95": "Goals and decisions could not be loaded",
  "copy.e507fff9b198": "The canonical record list cannot be reached right now.",
  "copy.e17ccb1e9466": "New",
  "copy.46a574f1e9f6": "No {{value1}} yet",
  "copy.37674e1e8aa6": "Create first record",
  "copy.81b1e645c2af": "Edit {{value1}} record",
  "analysis.source.planned_minutes": "planned time",
  "analysis.source.focused_minutes": "actual focus time",
  "analysis.source.completed_tasks": "completed tasks",
  "analysis.source.routine_expected": "expected routine occurrences",
  "analysis.source.routine_completed": "completed routine occurrences",
  "analysis.source.journal_entries": "journal entries",
  "analysis.source.average_energy": "reported energy",
  "analysis.source.life_records": "life records",
  "analysis.source.recorded_deviations": "recorded deviations",
  "analysis.source.unresolved_deviations": "unresolved deviations",
  "analysis.source.unplaced_period_dates": "periods without placement dates",
  "analysis.cause.energy": "Not enough energy",
  "analysis.cause.sleep": "Poor sleep or oversleeping",
  "analysis.cause.health": "Health",
  "analysis.cause.mood": "Emotional state",
  "analysis.cause.motivation": "Lack of motivation",
  "analysis.cause.competing_work": "Other work took the time",
  "analysis.cause.external_demand": "Someone else needed the time",
  "analysis.cause.social_pull": "Chose people over the plan",
  "analysis.cause.interruption": "Interrupted",
  "analysis.cause.wrong_environment": "Unsuitable environment",
  "analysis.cause.missing_input": "A dependency was not ready",
  "analysis.cause.unclear_next_step": "Unclear next step",
  "analysis.cause.underestimated": "Work was underestimated",
  "analysis.cause.overpacked_day": "Overpacked day",
  "analysis.cause.impulse": "Followed an impulse",
  "analysis.cause.lost_track_of_time": "Lost track of time",
  "analysis.cause.travel": "Travel or absence",
  "analysis.cause.changed_mind": "Changed my mind",
  "analysis.cause.not_recorded": "Not recorded",
  "copy.006ac77b363e": "Default",
  "copy.51382faca61a": "Accent",
  "copy.7186643b6973": "Positive",
  "copy.5f2dc55f3010": "Attention",
  "copy.56cbcafc5dc7": "Critical",
  "copy.8b57b7c3fc93": "Series 1",
  "copy.088c74357a15": "Series 2",
  "copy.5072edd2c9da": "Series 3",
  "copy.df4c30dad96c": "Series 4",
  "copy.9b1b06de1912": "Series 5",
  "copy.e9efb97603ed": "Series 6",
  "copy.5aed93824f10": "Health",
  "copy.b6e1d2675f6a": "People",
  "copy.be44001fbb93": "Measurement",
  "copy.46cdb4c6b7de": "Observation",
  "copy.74a0c4ce3e49": "Work",
  "copy.724f88c86b7c": "Inspiration",
  "copy.e281bb7cdf8c": "No icon",
  "copy.7ab8389a3c35": "Technical management",
  "copy.3a0c546bc9b0": "Life areas could not be loaded.",
  "copy.e5f3a083f846": "No life areas yet",
  "copy.71dcf8feeb8f": "A Life area groups tables that belong together. The system does not add predefined areas or sample records; you decide what to track.",
  "copy.fe3471c3dbaf": "Create first area",
  "copy.af56db355d8d": "{{value1}} · Technical management",
  "copy.37639fea53ab": "Area structure, tables and archive actions",
  "copy.a15d45f7923b": "Life technical management",
  "copy.32c8e9ea4f00": "Relation dictionary and advanced data structure",
  "copy.416fd8570eed": "Data structure",
  "copy.406314516701": "Create new areas and tables only when you want to change the structure.",
  "copy.24eac4a6e498": "New area",
  "copy.79a3ab411803": "This life area",
  "copy.460246b08dcd": "{{value1}} area.",
  "copy.f3504972b527": "Permanent area page",
  "copy.c92458d5623d": "Edit area",
  "copy.1cc822887fbf": "Technical information",
  "copy.43decee4ab33": "Section",
  "copy.38ae403eca98": "Creation channel",
  "copy.e030216f29c1": "Revision",
  "copy.05366b6aeaa9": "Tables",
  "copy.fbfc8d3aa100": "Add table",
  "copy.10561ce0320d": "Area tables could not be loaded.",
  "copy.d620f98f53dd": "This area has no tables yet",
  "copy.a78a501abf78": "You can set up the record structure after restoring the area.",
  "copy.e031fc67e4ba": "Start recording by defining the first table and its columns.",
  "copy.79bfffb0e9da": "Create first table",
  "copy.e966fdffbd55": "Primary",
  "copy.986fce6a1bd1": "Columns",
  "copy.7597deca31f0": "Restore area",
  "copy.885132eda3a7": "Archive and destructive actions",
  "copy.9e4ac22ebc68": "The area and its tables will be reactivated.",
  "copy.2a2e038322d1": "The area and all its tables will be archived. Records are not deleted and can be restored.",
  "copy.6aae37e5c497": "Archive area",
  "copy.66bbebdd96c0": "Life areas and tables",
  "copy.edd76b71ac69": "Collapse {{value1}} tables",
  "copy.bf7ca3035a97": "Expand {{value1}} tables",
  "copy.e35aa22be2b8": "Reorder {{value1}} area",
  "copy.4066bc5087a5": "tables ·",
  "copy.2100a9fbe962": "records",
  "copy.8f42f21e0861": "Quick-add record to {{value1}} area",
  "copy.57213045df0f": "{{value1}} options",
  "copy.0545ee0386ea": "Technical management",
  "copy.2b94cca1a1f8": "Tables could not be loaded.",
  "copy.05c5cf40b2d8": "Reorder {{value1}} table",
  "copy.92e5629c0438": "Quick-add record to {{value1}} table",
  "copy.90b8aff0a702": "Table settings",
  "copy.4c6fda4c2194": "Manage area",
  "copy.c3b523e02788": "Latest record {{value1}}",
  "copy.d670f9a15e01": "No records yet",
  "copy.81ead8d21995": "Day details",
  "copy.6ded619e99ac": "Back to {{value1}}",
  "copy.26a6c053dd52": "Back to day",
  "copy.9ccad9eb93d7": "Day could not be opened",
  "copy.0a2bead0e5a2": "Moments and Life records cannot be combined right now.",
  "copy.cf12a060f399": "No records for this day",
  "copy.eace9b4a752c": "The record may have been removed or archived.",
  "copy.7ec2e922e10b": "Day flow",
  "copy.e057379d19c8": "Moment without text",
  "copy.f3a263703afc": "Unnamed record",
  "copy.10a6934fd767": "Open / edit",
  "copy.2fbb343f76d3": "Child records",
  "copy.3e84a55be4d4": "Unnamed child record",
  "copy.d684417157c4": "All day",
  "copy.db1fc6fe932b": "Life area",
  "copy.038fa350cfbe": "Loading area and tables…",
  "copy.13143fd5adf9": "Loading life area",
  "copy.693196b298a6": "Back to areas",
  "copy.51d0a3039515": "Life area could not be opened",
  "copy.3d722e895669": "The record was not found or does not belong to this account.",
  "copy.ce7d1d42560a": "Back to guide",
  "copy.27a1b49c7c8a": "Quick add",
  "copy.01a1d73626ce": "Technical settings",
  "copy.88e8d06e084f": "Area view",
  "copy.bc9507f1119e": "There is no short description for this table yet.",
  "copy.969541f3a9be": "Open →",
  "copy.e92f6f072935": "Manage",
  "copy.57a735d1bc50": "Life table",
  "copy.d1ef4bd752a1": "Loading table and records…",
  "copy.b629dbd292f4": "Loading life table",
  "copy.d18900b873ac": "Life table could not be opened",
  "copy.aa6a7497da41": "The table was not found or does not belong to this account.",
  "copy.01ebf76b1587": "Record table for the {{value1}} area.",
  "copy.fe63913f462d": "This life table",
  "copy.b3d96f45800f": "Loading record details…",
  "copy.e472e7591201": "Loading life record",
  "copy.d444ab9de681": "Life record could not be opened",
  "copy.1e0c515a265c": "Record details in the {{value1}} table.",
  "copy.71a5d0434330": "Edit record",
  "copy.62eadbcde5a1": "This life record",
  "copy.fb36b18b09f8": "Record information",
  "copy.f727def4d3ea": "There are no active columns to display in this table version.",
  "copy.59987d013169": "Fields from an older version · {{value1}}",
  "copy.6ff8021ebc21": "Date",
  "copy.6e3182c4323e": "Occurrence",
  "copy.450aa8b43828": "Record provenance and technical information",
  "copy.fe59abe12ce9": "Channel",
  "copy.d49a6b6a9911": "Table version",
  "copy.6b85f191c37d": "View structural and semantic relationships together and create a new link.",
  "copy.9d119cdc2fad": "Show",
  "copy.edd22bd7915c": "Direct semantic links and canonical structural relationships are shown together.",
  "copy.09de32e78e2f": "Hide",
  "copy.641572dd08ef": "Add link",
  "copy.033adbaccbdf": "The relationship graph could not be loaded.",
  "copy.51a38ddad35d": "The graph was shortened at a safe limit. You can choose a smaller depth.",
  "copy.1894aabd94da": "No links yet",
  "copy.a3169a401651": "Link this record to another canonical record with a semantic relationship.",
  "copy.b9f70be342e0": "Show connection path",
  "copy.73c829609fde": "Indirect connection paths",
  "copy.8ff3ebd85597": "These are indirect paths reached through the graph, not direct links.",
  "copy.3c6e69792734": "Connection path depth",
  "copy.223a655159bd": "2 steps",
  "copy.af1aeec2f531": "3 steps",
  "copy.f44f4335ee0f": "Hide connection path",
  "copy.c3d3b2d2aadb": "Connection paths ·",
  "copy.2b9656ceb8e1": "steps",
  "copy.c4761e6f458e": "No indirect path was found at this depth.",
  "copy.69f2de3366f0": "The definition determines which records are candidates and sets the cardinality rule.",
  "copy.d898e93fefc5": "Create link",
  "copy.588d6e54daa7": "Create link · step {{value1}} / 3",
  "copy.62fc44108e2e": "Relation",
  "copy.fa5a09428e34": "The relation dictionary could not be loaded.",
  "copy.1f30ff52f9d5": "Try again",
  "copy.b3dbf14c3cfe": "No compatible relation definition",
  "copy.be53ebbf9188": "Create a relation rule that can start from this record type.",
  "copy.5e122dc318bd": "Create relation definition",
  "copy.1b4e8bd48759": "Choose relation",
  "copy.33aa5d6245fa": "Manage relation dictionary",
  "copy.ca4cfb5ac261": "Search candidates",
  "copy.aa084b75ae58": "Link candidates could not be loaded.",
  "copy.dd59623b6ec2": "No targets match this search",
  "copy.e2ace8039e2c": "No available link targets",
  "copy.2f5cfabecf65": "Change the search term or check the target type rules.",
  "copy.91b001f14534": "The relation definition found no compatible target for this record.",
  "copy.45d6a88358b2": "The link could not be created. It may already exist, or the cardinality rule may not allow it.",
  "copy.a0c505de95cf": "Unknown record",
  "copy.f60f95cd8833": "Relation field",
  "copy.0b687eb7efea": "Structural · read only",
  "copy.b34f5aa1e5cf": "Remove link",
  "copy.b305d2edd361": "Connection path",
  "copy.7916c8f0474b": "Link",
  "copy.a931270430aa": "Add column",
  "copy.e37f0d7a676d": "Unnamed column",
  "copy.9a7c94a5811c": "issues",
  "copy.bcb71bbc0918": "Column settings",
  "copy.285bc2afc213": "A published column's key and type are fixed; you can change its other properties in a new version.",
  "copy.3b3be9720106": "The key cannot change after publication.",
  "copy.1ec68d7b1270": "Move column up",
  "copy.ab4fb90fc778": "Move column down",
  "copy.2b4964d75877": "Remove column",
  "copy.2afbc15a4f89": "Column name",
  "copy.f420a172db2c": "Stable key",
  "copy.10a469da1596": "Column type",
  "copy.9cdc77349ec2": "Help text",
  "copy.a0394ceabdea": "Required",
  "copy.336355b87746": "Running focus session",
  "copy.6b0622af7e2a": "Minimized focus tool",
  "copy.0fdd6fe86763": "Show focus session",
  "copy.4f07c3435a02": "Restore focus tool",
  "copy.38e6169082e7": "Free focus",
  "copy.a1f7017325e2": "Minimized",
  "copy.3aa182dd7f4d": "Continue",
  "copy.60e5c559bebb": "Open the window to end focus",
  "copy.e4d33a7ed882": "Thought",
  "copy.a5dc85625c13": "External factor",
  "copy.ed36dab58b62": "Loading focus session",
  "copy.0d589a59bbce": "Could not load focus status",
  "copy.ab48e1b2ded5": "Check the connection again to avoid starting a new session while one is active.",
  "copy.1eb709f11f91": "You are focusing",
  "copy.2cf3944afc10": "planned {{value1}} · {{value2}} over",
  "copy.9ff3cfd0230d": "Finish",
  "copy.7a98ee8218f8": "Record interruption",
  "copy.b3723e02de60": "Interruptions",
  "copy.f560a85f28c0": "Add",
  "copy.7dcb8d8a1f44": "Could not load interruptions.",
  "copy.d43b28a96543": "· returned",
  "copy.6c9b2ee8e169": "I'm back",
  "copy.1767a9911a15": "Do not keep this duration",
  "copy.b475943ff92b": "The session is not paused; only the interruption is recorded.",
  "copy.7983505ec7a7": "Short note",
  "copy.9dfaf42e8c5a": "Another task came to mind…",
  "copy.acd3087a9623": "Could not save the interruption. You can try again.",
  "copy.cbf490822ecf": "Delete this duration?",
  "copy.5fd236031438": "The record is removed completely; Analysis and estimate calibration will no longer include it.",
  "copy.06d437fdb1ec": "Record deleted",
  "copy.f698e9b40f9f": "Delete",
  "copy.a709665e24c1": "An unfinished session is useful information too; you can finish it instead of deleting it.",
  "copy.20fd3324e83d": "{{value1}} saved",
  "copy.76be2ff67ec5": "Finish session",
  "copy.236be6c08fc6": "Finish and save",
  "copy.0a48283dfb4b": "Actual",
  "copy.01e23f52e395": "Planned",
  "copy.abe27110bf41": "Both are kept. The difference is not a shortcoming; it is real evidence for improving future estimates.",
  "copy.c7acd66b8b1f": "Session note",
  "copy.e82bdabda759": "What did you do, and where did you get stuck?",
  "copy.4372d5a5bae6": "Also complete this task",
  "copy.c04930fdbdaf": "Could not load project context",
  "copy.402dcf53a405": "To preserve where you left off, the session cannot end until its context has loaded.",
  "copy.2b852c38b7dc": "Loading project context",
  "copy.40623d6cb92c": "What would you like to find when you return?",
  "copy.34a6e5830b53": "Could not save the session. Your input is preserved; you can try again.",
  "copy.ae00bb8257d7": "Select a task",
  "copy.bbe177d05785": "Select a project",
  "copy.697017f40e1b": "What are you focusing on?",
  "copy.37d32bded40e": "Record time directly against a task",
  "copy.b433a33b7a78": "Link focus to project progress",
  "copy.be10f7dfff22": "Record independent work time",
  "copy.2d0befbb0034": "open-ended",
  "copy.be32d1d067c2": "Session duration",
  "copy.0b90e5e7c067": "Free",
  "copy.519d3e7b2439": "Focus context",
  "copy.cbf2d4ee6b34": "Task to focus on",
  "copy.3a5225cf13b3": "Select task",
  "copy.b3ed047212a6": "Project to focus on",
  "copy.7a56642b9b4e": "Select project",
  "copy.3aaf784e61e6": "Could not load task details",
  "copy.e97500323136": "Name for free focus (optional)",
  "copy.e84ca90d27cc": "Focus name",
  "copy.788ed0399e53": "Start",
  "copy.756ea4145328": "sessions",
  "copy.d0e801668500": " · today",
  "copy.d184b6486c45": "Edit session note",
  "copy.a3d459cbea3d": "Delete focus record",
  "copy.ad10a3d997bb": "Delete this focus record?",
  "copy.a801162aa7e9": "This duration is also permanently removed from Analysis and estimate calibration.",
  "copy.2f19a67aefd5": "Delete permanently",
  "copy.75faff011bd7": "Focus record deleted",
  "copy.61c4f34ff837": "Session note updated",
  "copy.b206bfcb333a": "The duration and task or project relation stay unchanged; only the session note is updated.",
  "copy.4ac04bae2047": "Could not update the session note. Your input is preserved; you can try again.",
  "copy.fc9a20fc1741": "Focus linked to a work session",
  "copy.ad5f7f339e2e": "Opened in task context",
  "copy.7ff707e28284": "Opened in project context",
  "copy.df9dbf7ef489": "Start a free or linked session",
  "copy.cacf66669d10": "Minimize focus tool",
  "copy.8d46d6726f04": "Close focus window; any active session continues",
  "copy.3f214a88c36c": "Fixed — the date itself matters",
  "copy.f45f695ba882": "Anchored — moves only with a reason",
  "copy.d8acc1aa2fc4": "Movable — flexible within the period",
  "copy.a3bc7f7df94f": "Droppable — missing this occurrence costs little",
  "copy.1448aa633fde": "What it is for",
  "copy.3d4502c278e5": "One sentence. It will appear alongside this item everywhere.",
  "copy.a6b077a5d4a1": "Why this duration",
  "copy.7fa5f589348c": "Why one year instead of four months? This is what you will read if you want to stop in month five.",
  "copy.69910eaaea39": "Why now",
  "copy.e80320352083": "Why it belongs in this part of your life. Later, this will answer whether you can move it to autumn.",
  "copy.283d53287910": "What happens if it is not done",
  "copy.35d5ce90f9e0": "Be honest. 'Not much' is a valid and reassuring answer too.",
  "copy.560b06c0a4da": "What you gain when it is finished",
  "copy.723127c3156d": "How you will know it is working",
  "copy.8b59fcdc559a": "Signal to stop",
  "copy.a1aa7cbb61f6": "A commitment without an exit condition can become a life sentence.",
  "copy.dc670a4b67f8": "Minimum version on a difficult day",
  "copy.1e56d2f4528f": "Flexibility",
  "copy.39dbc0fbb0d7": "Sacrifice order",
  "copy.11a1820cb7cf": "1 goes first, 5 last. This is your instruction, not a calculated value.",
  "copy.963fc6a7cda9": "Protected",
  "copy.070901e9ffeb": "Automatic adjustments do not change this.",
  "copy.db03659a642a": "Could not save the rationale. Your input is preserved; you can try again.",
  "copy.57a2348d770b": "No rationale has been written at any level above this item. What you write here will be the entire chain.",
  "copy.e8c89ef26df6": "Inherited from higher levels",
  "copy.bd9095d3dd77": "Back to where I left off",
  "copy.1d3e2b0e8bc0": "Return to the open context without making a new decision.",
  "copy.0cf7aee6c1fc": "Put what is on your mind into the journal as it is.",
  "copy.b12be1e247c3": "Choose the smallest task",
  "copy.0277ee4e1eab": "See one candidate that fits low energy and limited time.",
  "copy.f17dbd1265af": "Rest intentionally",
  "copy.34edef8ab700": "Choose a short break without changing the plan.",
  "copy.50f2a1b041f6": "Return to open context",
  "copy.4de9b6a2e754": "Write a brain dump in the journal",
  "copy.cfd5195e2c90": "Open the smallest suitable task",
  "copy.bf0dcfc3d815": "Rest intentionally for ten minutes",
  "copy.44cc547f3928": "Selected through the I feel scattered flow.",
  "copy.cccfa77e9fb2": "Just the next step",
  "copy.4d54b8e1a767": "You are not expected to make a plan right now",
  "copy.82b994f7ebd6": "← Back to options",
  "copy.e8dd7ab46696": "Return to focus session",
  "copy.b3fe8f40dc61": "Return to today's open context",
  "copy.b4816d84781e": "Your open session and saved context are preserved.",
  "copy.5dec85d562b9": "See today's plan again without adding new work.",
  "copy.b7e193af9550": "Go back",
  "copy.97c8955d0a2d": "Returned to the focus session.",
  "copy.74001fd02bd4": "Opened the daily plan.",
  "copy.db9f2db062e9": "Write it in the journal as it is",
  "copy.e9284333b7e8": "You do not need to organize it or turn it into a task.",
  "copy.085c7ec71b1c": "Opened the journal for a brain dump.",
  "copy.ac89735730db": "No candidate found",
  "copy.48bb85678fcc": "The first record that fits limited time and low energy. Your plan has not changed.",
  "copy.197f42744f7a": "Open task",
  "copy.7d1ac7685702": "Opened the suggested smallest task.",
  "copy.ca82585fdd38": "No small candidate is available right now",
  "copy.a3544bf9d826": "You can clear your mind without creating a new task.",
  "copy.f3c1e63c3076": "Open journal",
  "copy.606fce172095": "No suitable task was found; opened the journal.",
  "copy.ca14d38b2291": "Ten-minute intentional break",
  "copy.f43babd41101": "This choice does not change any task or calendar record.",
  "copy.191a6f516185": "Start break",
  "copy.e74e95928b16": "Started intentional rest.",
  "copy.c481a4f87d86": "Unavailable project context",
  "copy.4d25a65559b0": "Independent work",
  "copy.a83ca4087283": "Clear the unavailable work context",
  "copy.1881e2853f90": "Keep this project context across Work pages",
  "copy.45bff68a213b": "Only one project context can be pinned",
  "copy.8cea46171ea6": "Clear context",
  "copy.c3e683cb28a7": "Pin context",
  "copy.78f21b12f64e": "The selected project is not in the active list; it may be archived, completed, or removed. Clear the work context to continue.",
  "copy.2ae781a94b58": "Could not load work contexts",
  "copy.2ebe2eba26b2": "Workdesk tools",
  "copy.3ace95a91811": "Open without disrupting the session context",
  "copy.ac0de2f4c3c0": "Free focus",
  "copy.106d3b1fd00a": "Open independent focus; use the work surface for focus linked to a session.",
  "copy.4209e914bfa4": "Work with notes",
  "copy.227a769972c1": "Bring another note from Memory into the window.",
  "copy.8d84e0bd50b7": "Connect concepts",
  "copy.2034123c9ab1": "Arrange knowledge in a concept map.",
  "copy.3180a1d06ffe": "Concept map · Independent work",
  "copy.f9737968b2fd": "Could not load project workspace",
  "copy.141f8139077d": "The project may have been removed, or this work context may be inaccessible.",
  "copy.565175276319": "Note window",
  "copy.cd86f37c386e": "Now",
  "copy.7d5b7402fc6e": "Concept map · {{value1}}",
  "copy.2704572c3ed8": "Work context saved",
  "copy.f94aa1a5150e": "Could not save work context",
  "copy.70587a8dabc5": "Where you left off",
  "copy.d6aacedbd609": "Context note",
  "copy.de5062658026": "Where were you, what were you solving, and what information mattered?",
  "copy.c9428f99c477": "Next concrete step",
  "copy.8a6a591578f8": "What will you do first when you return?",
  "copy.1d76f1e324b8": "Next tasks",
  "copy.6a22bf323242": "This project's open tasks; their saved order is managed in the project plan.",
  "copy.65e1ad711cdf": "Arrange new steps in the project's Plan and tasks area.",
  "copy.a8a69edcaa9e": "Could not load plans",
  "copy.f390637dec72": "This project has no plans. Create them from the project's Plan and tasks area.",
  "copy.867b4bf4357a": "min",
  "copy.ed7b0597bb11": "focus in the last 30 days ·",
  "copy.82e70c1d179f": "total sessions",
  "copy.6494487127f0": "Work surface opened",
  "copy.57a32adc7c50": "Session note created",
  "copy.5ababb6998c0": "Session note opened",
  "copy.b168edcd36d4": "Main task changed",
  "copy.04e44151b88b": "Work context changed",
  "copy.f0038635fd40": "Focus started",
  "copy.956e30081540": "Focus completed",
  "copy.86cab14e0fd7": "Session closed",
  "copy.1cfcb0e0c346": "Sessions",
  "copy.9a5d00963277": "Your saved work contexts",
  "copy.082c5b661bba": "New work session",
  "copy.31b9fad3e754": "Could not load sessions",
  "copy.a75340f85217": "The session appears here with your first meaningful note.",
  "copy.ef11f29168da": "Load more sessions",
  "copy.f32b8c72d580": "Session log",
  "copy.c91b9e0ca122": "Load older log events",
  "copy.65412e20f50b": "Work {{value1}}",
  "copy.a23c43279ed8": "Could not start work session",
  "copy.16c8bf942416": "Your writing remains on this surface; you can try again when the connection returns.",
  "copy.1530bf14426b": "Creating session and note…",
  "copy.3fd84e87bf4c": "The session note is no longer available",
  "copy.9f676ce9434f": "The session starts with your first meaningful input",
  "copy.8b7b77b78bef": "Could not change main task",
  "copy.326d955eb7ac": "The work context remains on the previous task.",
  "copy.6d3683dbfe92": "The session has not closed yet",
  "copy.a98b9baf338b": "Try again after the note has finished saving.",
  "copy.ed7b6d4d6bc3": "Could not close work session",
  "copy.5be192e2b90f": "Active work surface",
  "copy.1cda7a55f788": "Where your thinking begins",
  "copy.b49b642f4da3": "This session is closed; you can edit its note in Memory.",
  "copy.0e4bacc79b6a": "Try again",
  "copy.a88b4fa851d1": "New session",
  "copy.f57f8c39267f": "Open session focus",
  "copy.d00e6e559b1c": "Close session",
  "copy.922115e9e92a": "Could not load work session",
  "copy.38fe1543561e": "Main task",
  "copy.e62667b9b9c8": "Not linked to a task",
  "copy.f5366701e102": "Work title",
  "copy.6b29008972a4": "What are you trying to understand or create?",
  "copy.f1a7b8a84677": "Work note",
  "copy.0b1711443289": "Write your first thought. The note and work session are created together in one transaction…",
  "copy.bd95ddbb7282": "Context ready",
  "copy.fa17e1d1883f": "When the session starts, its note, focus, and activity appear together on this surface.",
  "copy.4d17100a71c9": "Searchable",
  "copy.875bb07be1ea": "Show in summary",
  "copy.1ba822cc0684": "Options",
  "copy.ceec807c6551": "Enter one unique option per line.",
  "copy.588aae6aafd4": "Minimum",
  "copy.cc3dcc99e516": "Maximum",
  "copy.edfe404908a0": "Measurement unit",
  "copy.831ffef779b4": "For example: kg, km, ml.",
  "copy.fc4293f14ae2": "Currency",
  "copy.283563914155": "ISO code, such as TRY, EUR or USD.",
  "copy.a671ef3bf83a": "Maximum characters",
  "copy.9846864fe8ed": "Relation definition",
  "copy.0e42058692eb": "The field uses this definition's candidate and cardinality rules.",
  "copy.06e2c0165d52": "Relation definitions could not be loaded.",
  "copy.ad5707c31404": "The upper limit cannot be lower than the lower limit.",
  "copy.60d6891f17a7": "Yes by default",
  "copy.46964fd8474c": "Default value",
  "copy.d520c328db39": "No default",
  "copy.6d15debcee9c": "Default selections",
  "copy.d2f234c495f7": "Add the column options first.",
  "copy.526f8ad89a9d": "Default date and time",
  "copy.c005e3ef8c5b": "Default duration (minutes)",
  "copy.b98832f7da8f": "Option 1",
  "copy.7cf555385842": "A parent record is required.",
  "copy.a822bf0070b3": "Cannot add record",
  "copy.f8d08535fbf5": "This table has no published column structure.",
  "copy.cf18882186be": "Add {{value1}} record",
  "copy.11a639de4e23": "Update record",
  "copy.e8d1493bfe8b": "Create record",
  "copy.5950aa34aa20": "Active record",
  "copy.e0d9a7decf57": "New record",
  "copy.7fbcae4ad3d9": "columns · published v",
  "copy.515170d938a6": "This record is archived. You can edit its fields or reactivate it.",
  "copy.a8e9ba13c3e8": "Open permanent record page",
  "copy.0d560aad7f5b": "Parent record",
  "copy.436740d4eccb": "Parent records could not be loaded.",
  "copy.6f891e8e4afc": "Choose parent record",
  "copy.92b0222f6306": "Record fields",
  "copy.4c62d67a8041": "Reactivate this record?",
  "copy.3152b9d97443": "The record will be archived; it can be restored later.",
  "copy.fcd7700e64bf": "Unarchive",
  "copy.c6d04422e361": "Move to archive",
  "copy.dc5fc533111f": "Record date",
  "copy.6d0830c1e983": "Occurrence time",
  "copy.525f19e832a6": "The end cannot be before the start.",
  "copy.6caa06b138cc": "Choose",
  "copy.276cd1b7e5b5": "One target can be selected",
  "copy.2c9c3bcc5b32": "Multiple targets can be selected",
  "copy.b99c6204f1b9": "Multiple links",
  "copy.11f80f8cf5b1": "Remove link",
  "copy.c48e820e9b6c": "No links selected yet.",
  "copy.0d364098bf4b": "This relation allows one target. Remove the current link to choose another.",
  "copy.4688865cdf49": "Only candidates allowed by this relation definition are shown for a new record.",
  "copy.a3555e1aa356": "Loading candidates…",
  "copy.969eccd7e467": "No other candidates match this search.",
  "copy.d9d28c3fe620": "There are no other candidates available for this relation.",
  "copy.2685c287900e": "Link candidates",
  "copy.0b6a2e657a9d": "Make at least one selection for {{value1}}.",
  "copy.f339524cbafa": "{{value1}} must be a nonnegative whole number of milliseconds.",
  "copy.b1b1da5a51e8": "{{value1}} must be a valid number.",
  "copy.32e88fc5f837": "{{value1}} must be a whole number.",
  "copy.c6c40d117da9": "{{value1}} cannot be less than {{value2}}.",
  "copy.001a863d4b0e": "{{value1}} cannot exceed {{value2}}.",
  "copy.3e3318af512f": "{{value1}} must be a valid date and time.",
  "copy.d3955395c9c9": "Record date is required.",
  "copy.1dbaa5054f97": "Occurrence time is required.",
  "copy.967f23d70ff8": "Start and end times are required.",
  "copy.aff516febe59": "The record could not be saved. Check the information and try again.",
  "copy.659793dbb28a": "Guide record",
  "copy.cb8ec45f8ad3": "Entity",
  "copy.673e4e36fd5b": "Timeless",
  "copy.a7616ceae060": "Interval",
  "copy.e58573219562": "Timeline",
  "copy.97e99d15be1d": "Short text",
  "copy.52fdce9b9ec0": "Long text",
  "copy.6288e89d4851": "Integer",
  "copy.3633af0adabd": "Decimal",
  "copy.c7df4b07d57c": "Yes / no",
  "copy.c17048e6ca9a": "Date and time",
  "copy.6fcfc21a7061": "Single choice",
  "copy.74b57a1aad86": "Multiple choice",
  "copy.27b840ea8759": "Web address",
  "copy.9f2f4d66fa86": "Related record",
  "copy.100a8d1ce8b6": "Field {{value1}}",
  "copy.61448e841093": "Field name is required.",
  "copy.0768df1f8197": "The key must use lowercase letters, numbers, underscores or hyphens.",
  "copy.dea7bef37790": "Add at least one choice option.",
  "copy.e01d8c9f37bd": "Measurement unit is required.",
  "copy.ca9d31f6d5bd": "Currency code is required.",
  "copy.ad1e311e3c89": "Choose a relation definition.",
  "copy.0f20c2b1dd0d": "The minimum cannot exceed the maximum.",
  "copy.65829f044732": "The minimum must be a whole number.",
  "copy.37a4b19c9a81": "The maximum must be a whole number.",
  "copy.e303c5ad58bf": "The default value cannot be below the defined lower limit.",
  "copy.ddffa1123b1f": "The default value cannot exceed the defined upper limit.",
  "copy.53c363caf4c7": "The character limit must be at least 1.",
  "copy.1681512ce8ef": "The default text exceeds the character limit.",
  "copy.d6336058bf2a": "The default selection must be one of the options.",
  "copy.f0b2b189c6be": "Default selections must be unique and chosen from the defined options.",
  "copy.7eedb6ffc46e": "The default duration must be a nonnegative whole number of milliseconds.",
  "copy.8370cffa685e": "The default date and time must use RFC 3339 format.",
  "copy.b8059304da02": "The contract must contain at least one field.",
  "copy.4a7ceb5a6005": "The key “{{value1}}” is used more than once.",
  "copy.636fdb5eafeb": "The record title field must be one of the existing columns.",
  "copy.13dd5f66b411": "A relation field cannot be used as the record title.",
  "copy.cac400c7ec07": "No",
  "copy.c1ea630641d7": "{{value1}} links",
  "copy.12f5b9657481": "No available tables in this area",
  "copy.23153e137765": "The archived area has no active table. Restore the area before creating a new table.",
  "copy.3f89d405ca85": "Create the first table to define the record structure.",
  "copy.6a31c0c610b2": "Create table",
  "copy.0f1ec9f644e2": "Record table",
  "copy.43e460e9f515": "Full page",
  "copy.d4e50a9507fa": "Record view",
  "copy.140827893f56": "New view",
  "copy.2371d635aa7d": "Edit view",
  "copy.9cbbce1b2fdf": "Search records",
  "copy.ee262830ab0b": "Search records…",
  "copy.fc38cc582bb7": "View type",
  "copy.63393830d702": "Table",
  "copy.c0234ded5a1c": "Card",
  "copy.7293b181ae7d": "Flow",
  "copy.1aa857883362": "Filters and layout{{value1}}",
  "copy.544ecff7c397": "Sort order",
  "copy.7cc13871889f": "Newest",
  "copy.6bd60b2c4146": "Oldest",
  "copy.e25e294bd346": "By name",
  "copy.3be6b46e60ae": "Group records",
  "copy.72c093cbd94c": "No grouping",
  "copy.7070a81abb53": "Filter field",
  "copy.5a98aabe37e5": "No filter",
  "copy.060cb5de9135": "Filter operator",
  "copy.ff02062be742": "Contains",
  "copy.0b5a458a5347": "Equals",
  "copy.4387da82d5a8": "Is not empty",
  "copy.16e5d938d19e": "Filter value",
  "copy.d801b37b3a25": "Filter value…",
  "copy.46421177d26f": "Show archived",
  "copy.92dfa17d1f40": "Reset layout",
  "copy.062b17469b60": "matches, of which",
  "copy.6ef1a9248bf5": "are shown. Search, filters, sorting and grouping apply to all matches on the server.",
  "copy.f4b5c7e0e2f3": "Life records could not be loaded.",
  "copy.479bfe7bd93c": "No records match this view",
  "copy.0e333f240a2c": "Change the search term or clear the active filter.",
  "copy.5ce588ad6970": "Start by adding the first record using the published table structure.",
  "copy.9cd93a2b25b1": "Clear search and filter",
  "copy.425ce7a0b289": "Add first record",
  "copy.c0db40e859f1": "Load more records",
  "copy.405a2eb6e36d": "Life records table; scroll horizontally for more columns",
  "copy.461903c31fd4": "open page",
  "copy.42e8d6751cfb": "edit record",
  "copy.26df4c031ec1": "links",
  "copy.35916465da8e": "Filter value is required.",
  "copy.2ac1e3d6eb57": "Filter value cannot exceed 500 characters.",
  "copy.e5b97c24ed71": "Edit record view",
  "copy.4f52e9bdab2a": "Create record view",
  "copy.8e6bb24be8b8": "Columns, filters, sorting and grouping are saved on the server; the same view can be read by other clients.",
  "copy.bc161950c700": "Update view",
  "copy.32e7ce8f0ed2": "Create view",
  "copy.16cd586772ea": "View name",
  "copy.90a257d504b0": "Record search",
  "copy.91426b4dc742": "Search term used when this view opens",
  "copy.27bc2b348074": "Fields, sorting and filter",
  "copy.70f7b8b381e3": "Fields to display",
  "copy.8ba6ca75b0af": "Grouping field",
  "copy.350512a50f2c": "Set as default view",
  "copy.346d8dd12fee": "The view could not be saved. Check the field selection and try again.",
  "copy.8a003516a94a": "This view will be archived; records are unaffected.",
  "copy.9ef30226f4c0": "Archive view",
  "copy.0d3caafbd239": "Many to many",
  "copy.2e541ac8ec28": "One to many",
  "copy.258c11864172": "One to one",
  "copy.a5503e701959": "Relation dictionary",
  "copy.8293474593b5": "Shared, user-defined rules for life area columns and all semantic links.",
  "copy.d81c6876f344": "Define relation",
  "copy.d2d887d89da6": "No link rules yet",
  "copy.e35ece82e967": "Define the allowed source and target types before using a relation column or record link.",
  "copy.0de750b7b91a": "Define first relation",
  "copy.c6a30b14472d": "All source types",
  "copy.b3697435c490": "All target types",
  "copy.9587d48e6522": "Edit relation definition",
  "copy.d4d1b191bbb7": "Archive relation definition",
  "copy.e8c3e0322839": "” link rule will be archived. Existing links are not deleted.",
  "auth.registration": "Registration",
  "copy.f59ac551f57f": "Search or go to a page",
  "copy.f38bb94bc826": "Search tasks, projects, notes, routines…",
  "copy.eec61f6c4c28": "Could not search",
  "copy.4f864d921594": "Your query is preserved; try again when the connection returns.",
  "copy.ce201cb1375d": "” has no results.",
  "copy.ec1cfccba261": "Open global focus tool",
  "copy.86c1fce4925a": "navigate",
  "copy.87c0823f8b31": "capture",
  "copy.6d06affe96b7": "Delete this draft?",
  "copy.39d0c84b44db": "Create draft",
  "copy.7512b239d6b6": "Could not load drafts",
  "copy.1c72b13df135": "No drafts yet",
  "copy.cd193d755ba5": "Capture a thought with {{shortcut}}; decide its type and location later.",
  "copy.83bbc896e0b0": "Pending drafts",
  "copy.878933c7d3e8": ". draft ·",
  "copy.f010d2fb4dc7": "Previous draft",
  "copy.7f68e932a6f0": "Next draft",
  "copy.b34349abf096": "Convert",
  "copy.2e1e6aba9879": "More actions",
  "copy.ef4220e5af6c": "Draft added",
  "copy.2bd4cadb228f": "It will wait for you to decide what it is when you process it.",
  "copy.007e26c6418a": "Inbox draft",
  "copy.7e64bc3e17ff": "Capture the thought now; choose its type and location when processing it.",
  "copy.b4ad6c920f5e": "Save draft",
  "copy.a307e848f85b": "Draft text",
  "copy.83456a81e6d9": "You do not need to choose a project, date, or type.",
  "copy.5605187daf88": "The thought on your mind…",
  "copy.8a0390b85b4f": "Edit draft",
  "copy.100d490b8ba7": "Edit the raw text before converting it.",
  "copy.1f650f02db64": "A concrete task to do once and finish.",
  "copy.31ced9c28638": "Information worth keeping.",
  "copy.e685a979e293": "Work with multiple steps.",
  "copy.5ed90abde0ed": "An activity that will repeat.",
  "copy.3ec77b2c6110": "A distilled, atomic piece of knowledge that can be connected.",
  "copy.791eded9df4a": "Converted",
  "copy.27d3a7739ea1": "What should it become?",
  "copy.62179c14e2a0": "Quick task date",
  "copy.a239fe49ae00": "If empty, it is placed on the day without a time.",
  "copy.cba25d1c84f9": "The draft's first line is used if left empty.",
  "copy.1d436c8fdcd0": "Short statement",
  "copy.304d29dca6e9": "Knowledge distilled into one sentence",
  "copy.60209ab3d033": "Convert to a Note if you need longer content.",
  "copy.b6efe3e72d36": "Project color",
  "copy.a4fe32a75621": "Edit the details later on the routine screen.",
  "copy.923151ae4b79": "Specific days",
  "copy.21db5263d05b": "Day interval",
  "copy.b94cb47a3530": "Weekly quota",
  "copy.4e0bbee63aba": "Recurrence days",
  "copy.244915edb65f": "Every how many days?",
  "copy.4ad756eca365": "How many times per week?",
  "copy.9e34e8d58b88": "{{value1}} thoughts added to Drafts",
  "copy.25aa86d86c3f": "You can classify them later.",
  "copy.9199ed6be96c": "Captured",
  "copy.91b856f8bfe6": "Clear your mind",
  "copy.5e4146ed7823": "Decide what it is later.",
  "copy.017eefd3a09d": "Each line becomes a separate item. There is no need to sort or organize them first.",
  "copy.714807d9ead7": "One thought",
  "copy.3e4862b7eda3": "lines",
  "copy.3c269e0591f0": "Thought to capture",
  "copy.3ffc056ff075": "Thoughts on your mind",
  "copy.27099f50adb0": "What's on your mind…",
  "copy.8229e2067826": "Write everything on your mind, one line at a time.\nIt does not need to be ordered or organized.",
  "copy.8165e1751b03": "separate drafts will be created. They will wait in Drafts; you do not need to decide anything now.",
  "copy.bd55afa192cb": "Permanently delete “{{value1}}”?",
  "copy.7e91bbcdd436": "It is also removed from Archive and cannot be restored.",
  "copy.5d43b831c2b8": "Archive record type",
  "copy.58833783a7d0": "Restoring returns the record to its previous workspace.",
  "copy.a8c365081193": "Could not load archive",
  "copy.347508cd2511": "No archived {{value1}}",
  "copy.8740913ebf1a": "Records placed here are not deleted; restore them whenever you want.",
  "copy.325d8474bd73": "Record and context",
  "copy.4a1729bec425": "Archived",
  "copy.543e1e2b1b30": "Archived {{value1}}",
  "copy.c85698aff1af": "Restored",
  "copy.75cd572a9f22": "archived notes",
  "copy.970a95f7e5a9": "Could not load more archived notes. You can try again.",
  "copy.2caeeb05616c": "Archive date unknown",
  "copy.1dc7472b3156": "Delete permanently?",
  "copy.b58104b1b96a": "Long period",
  "copy.6fad8d09bd08": "Short period",
  "copy.8b7c60d9a23d": "All records",
  "copy.dc6458c155c6": "Life tables",
  "copy.7243719b1672": "Life views",
  "copy.e5084b3d7f53": "Record restored",
  "copy.5c45ef0b0452": "{{value1}} records restored",
  "copy.1bff0d467a01": "Could not restore records",
  "copy.7e43776d39bc": "These records cannot be moved to Trash",
  "copy.f2f05727eafe": "Record moved to Trash",
  "copy.85bb4b7b4200": "{{value1}} records moved to Trash",
  "copy.bcdc2ea2a3cf": "You can restore them within 30 days.",
  "copy.c9481516ef38": "Could not move records",
  "copy.be2fac37f500": "No archived records in this view",
  "copy.fdafc18b1eae": "Archived content is not deleted; restore it from here whenever you want.",
  "copy.abc78ab6cac5": "This record cannot be permanently deleted",
  "copy.24cabd671054": "The history of {{value1}} must be preserved. Restore the record and review its relations.",
  "copy.5aa54c2af353": "This record",
  "copy.bdb20024bae6": "Permanently delete {{value1}} records?",
  "copy.d7187a2f212a": "Along with the selected records, {{value1}} linked child records or relations will also be affected.",
  "copy.c7069dd6a3e1": "The selected records will be permanently removed from Trash.",
  "copy.6727a116935d": "Record permanently deleted",
  "copy.68c16b76c9dc": "{{value1}} records permanently deleted",
  "copy.9d7de68bccbb": "Could not complete permanent deletion",
  "copy.77aef723beaa": "Trash is empty",
  "copy.932aaa5c7e56": "Deleted records appear here from oldest to most recently deleted.",
  "copy.8ac21a9cabb2": "Record search and type filters",
  "copy.7fee5d58c7da": "Record type",
  "copy.0fabc7f67a53": "{{value1}} records selected",
  "copy.fa34472f76eb": "Select the first {{value1}} visible records",
  "copy.facf08d75d96": "Select all visible records",
  "copy.c01ed86409d1": "You have reached the selection limit of {{value1}} records.",
  "copy.3ef6f67a68aa": "Select up to {{value1}} records for a bulk action.",
  "copy.019ca1b70c96": "Select records for a bulk action.",
  "copy.2b96339a744e": "Could not load records",
  "copy.593703de1db6": "deleted",
  "copy.5412471b7fc4": "Automatic deletion is waiting for a safe dependency state",
  "copy.5d6938f2ba9e": "automatically deleted",
  "copy.53e727197f13": "Returns to Archive when restored",
  "copy.ec4bdb8ab67b": "Show more",
  "copy.1f872f173f4c": "when its retention period expires",
  "copy.6132e88dcede": "in {{value1}} days",
  "copy.b5d5656e5c0f": "Too many records selected",
  "copy.d020fa270189": "A single bulk action can process up to {{value1}} records.",
  "copy.16e0cd0b2878": "Memory collections can only be restored from Archive; their notes are not deleted or moved to Trash.",
  "copy.2781e5ac5672": "Drafts can only be restored from Archive; they cannot be moved to Trash.",
  "copy.92a521b5fc10": "Drafts and Memory collections can only be restored from Archive; they cannot be moved to Trash.",
  "copy.d87591c967d9": "Untouched for {{value1}} days",
  "copy.1dbded6f67f7": "Never reviewed",
  "copy.25f22ae5f0c0": "Still open after {{value1}} days",
  "copy.698e3f961ac4": "Captured {{value1}} days ago, not processed",
  "copy.6ef56e918637": "You asked to see this again",
  "copy.60d5f262aca4": "Next week",
  "copy.991a8309369b": "Next month",
  "copy.b99719aeeee0": "Someday",
  "copy.4c033acaadc1": "This is your first review.",
  "copy.dd61fabdb46b": "Since the last review,",
  "copy.4c6a4b7471c7": "days have passed.",
  "copy.ddcd9fab4d42": "items have not been opened for over a month.",
  "copy.1a27744cbf0b": "Weekly reset",
  "copy.6d97f0018bd7": "Deck",
  "copy.924255972b30": "Forgotten items",
  "copy.72bb05e8e781": "Could not load review deck",
  "copy.095adb049560": "Retry the connection to load the deck.",
  "copy.244b6886c071": "Deck complete",
  "copy.45ae05564f67": "Nothing has been waiting for over a month",
  "copy.491a9dae240a": "Nothing to show right now",
  "copy.f828bb795dc7": "You reviewed {{value1}} items. They will not return for a week.",
  "copy.279a03385f54": "Recently reviewed items do not return for a week.",
  "copy.ad164ae80dbc": "Last touched",
  "copy.8f38e98697e7": "When",
  "copy.43c20da85fe5": "Seen",
  "copy.55ddd44cd2d1": "Show later",
  "copy.e8e58f9e91e8": "Previous card",
  "copy.325a4f757c71": "Next card",
  "copy.c75d5b5a50a3": "Card source archived",
  "copy.fffc44606371": "The source record is moved to Trash and can be restored. Choose Seen to remove it only from the deck, or Archive to keep it while removing it from active lists.",
  "copy.5fa7808f21d9": "Source record moved to Trash",
  "copy.0d5aa5d8ca2b": "Draft converted to task",
  "copy.7a64b8f8bbe5": "Draft converted to task and placed on the date",
  "copy.c178f2e4b3a9": "Task placed on the date",
  "copy.15ed364115d3": "Card actions",
  "copy.3d4ed4f3f713": "Set date",
  "copy.fc1feb9caa5e": "Convert to task",
  "copy.189accbafa61": "The draft is converted to a task and placed on your selected day without a time.",
  "copy.f72beda5977b": "The task's date moves to your selected day; its time and duration are preserved.",
  "copy.bdd466141565": "The task is placed on your selected day without a time.",
  "copy.585227e698bc": "Place on date",
  "copy.ce98b504980d": "The task's current date could not be read. Try again to avoid creating a second date.",
  "copy.8e2e500a5b51": "days since last touched",
  "copy.f5c3b8f2b6a4": "more records.",
  "copy.dd2cf338bef0": "Decision area",
  "copy.ccb1b66b9cd0": "Unfinished work",
  "copy.7fe1f25cf50c": "Pattern",
  "copy.09533afe9cfe": "Next week",
  "copy.d3b634b9c241": "Thoughts you captured but have not yet converted.",
  "copy.3f56dfb9884a": "Commitments without a plan. Each has a way forward.",
  "copy.f8861196c93b": "Work planned for this week that has not been completed.",
  "copy.b1f0345aec0e": "Projects that have gone quiet or have no next step.",
  "copy.14b123249cbe": "How did routines go this week? There is nothing to act on here, just observe.",
  "copy.28749557e31d": "Planned and actual time. A comparison, not a judgment.",
  "copy.08924cb29c7e": "Things already committed for next week.",
  "copy.b6f9ff4bcd18": "Could not load weekly reset",
  "copy.352f27fd1f67": "Open loops cannot be brought together right now.",
  "copy.ea5809745de5": "Week reset",
  "copy.ffaee03cdda3": "Nothing changed in this round. Reviewing is a decision too; you may have chosen not to move anything.",
  "copy.9bc36de238aa": "items resolved. Remaining:",
  "copy.1b9cbdc3bab6": "items; they will be here next week too.",
  "copy.c148c2d92fe6": "Back to daily calendar",
  "copy.fcc5dbfdb00a": "Back to Rediscover",
  "copy.907bd6b287d0": "nothing awaiting a decision",
  "copy.119361552a5f": "{{value1}} items remaining",
  "copy.90a817d58d50": "Steps",
  "copy.b68a3150ea85": "Back",
  "copy.844da8e8d489": "Finish reset",
  "copy.b91950d23ded": "Continue",
  "copy.eddb7bfb8697": "Overview",
  "copy.a2f6cf4a30e2": "Consistency",
  "copy.3573f3639f9a": "The two numbers sit side by side; neither is a target for the other. Their difference is real evidence for improving future estimates.",
  "copy.1159e7bd858c": "Next week on the calendar",
  "copy.bf455167c946": "View next week",
  "copy.0b37a6968a9b": "Inbox is empty",
  "copy.431f051dff63": "days ago",
  "copy.9123f5b6da31": "Process in Drafts",
  "copy.33d1b4d34e9c": "No undated open tasks",
  "copy.3458e38301bc": "Every project has a next step",
  "copy.0d0701dd4242": "Quiet for {{value1}} days",
  "copy.fa5e27df9b4d": "No next step defined",
  "copy.b03603f65e2d": "The relation definition could not be archived. Check the links and try again.",
  "copy.c60029bdd3f2": "Create new link rules, update existing user definitions or archive them.",
  "copy.bccc27de3b81": "Source and target types are chosen from a controlled list; candidate search follows these rules.",
  "copy.f63044f8dff1": "Save changes",
  "copy.4612d0b22e56": "Create relation",
  "copy.9006ce1450a2": "Link name",
  "copy.c9b98c9096d8": "Reverse name",
  "copy.8a24e4e6296f": "Semantic category",
  "copy.26bfbbe247de": "The meaning of a published category is fixed.",
  "copy.2d9fb7e34965": "Cardinality",
  "copy.968d3d7d6bb8": "Allowed record types · {{value1}} → {{value2}}",
  "copy.a17187c568ca": "all",
  "copy.6fde6111d2d6": "Source record types",
  "copy.c425b1f9c7b3": "Target record types",
  "copy.fef46aba9f28": "Restrict to a specific Life table",
  "copy.701c51b66812": "Optional. When empty, all allowed Life records are candidates.",
  "copy.45c465e4ade6": "Life tables could not be loaded.",
  "copy.c2cddfaeaa32": "All Life tables",
  "copy.7ef9daa37b69": "Current target table",
  "copy.9046e6e95efa": "Allow the record to link to itself",
  "copy.a65e091829b2": "The relation definition could not be saved. Check the type and cardinality rules.",
  "copy.066d6e58e8db": "An empty selection allows all linkable types.",
  "copy.8e9f14a0daa0": "{{value1}} · Table studio",
  "copy.6a4dfec17637": "Published table version {{value1}}",
  "copy.2245aa49ed89": "Publish new version",
  "copy.6e71d85d9727": "Table information",
  "copy.2f342c2f309a": "Table name",
  "copy.c3217baf903c": "Save table information",
  "copy.cb49b1a90671": "The primary table cannot be archived independently of its area.",
  "copy.159c97b94b6a": "The table and its records will be archived.",
  "copy.9307ebd33494": "Archive table",
  "copy.d82fcf185dee": "Publication workflow",
  "copy.452953bae789": "Records are written only with the published column structure. Draft changes do not affect existing records until published.",
  "copy.c285d4d31ef1": "No version",
  "copy.7e2b18dbac6b": "Draft ready",
  "copy.d62779cb6647": "New draft",
  "copy.8ae1c64a4552": "Looking for draft",
  "copy.cd0de2724a68": "Table publication steps",
  "copy.09456abb31a5": "Published",
  "copy.ac1d5a2e4fc8": "Unsaved",
  "copy.0f3133690dd9": "Validation",
  "copy.970dbbd01996": "Ready",
  "copy.764dc2c1c245": "Needs correction",
  "copy.38a23c50f075": "Technical contract summary",
  "copy.61fce33c56cc": "Record title field",
  "copy.793553198477": "Automatically select the first suitable field",
  "copy.68e9401f6d6f": "Checking draft column structure…",
  "copy.6f5817e083bf": "Fix before publishing",
  "copy.271ca82210f7": "Contract validated",
  "copy.22ff3717a8cd": "Contract could not be validated",
  "copy.46a3df3e8376": "The draft does not meet the table rules.",
  "copy.4e8b339e360e": "Validate",
  "copy.0d6f1fa66a0c": "The action could not be completed. Check the contract and try again.",
  "copy.04ecad6d68e6": "Life guide could not be loaded",
  "copy.0f2a8cb32d3a": "Guide sections cannot be reached right now.",
  "copy.584cdb264fb5": "Your Life guide is empty",
  "copy.934059f89377": "Create your first section and table to keep frequently used information in view.",
  "copy.ae89d6527ab4": "Create first section",
  "copy.1676ecedfef4": "Section structure, tables and archive actions",
  "copy.46d1d9343679": "Guide technical management",
  "copy.b00161b761dd": "Guide structure",
  "copy.1dba8cbb49d6": "Create new sections and tables only when you want to change the guide structure.",
  "copy.341a597b790c": "New section",
  "copy.93e14ad49287": "Life area name is required.",
  "copy.5c03c6a017b1": "Guide section name is required.",
  "copy.37445df2ff1f": "The first table name is required.",
  "copy.84b770b3cd9a": "The first table cannot be a child component.",
  "copy.261c7540aec3": "Create guide section",
  "copy.d43ef6864841": "Create life area",
  "copy.58eb21d61454": "{{value1}} and its first published table are created together in the final step.",
  "copy.772e527bf179": "Guide section",
  "copy.8b03bcbfe02f": "Next",
  "copy.b67770da4471": "Guide section name",
  "copy.b3398d737675": "Life area name",
  "copy.029bcd4d8716": "Section description",
  "copy.2d6881c4cc50": "Area description",
  "copy.519248ffd903": "This",
  "copy.743c0fc065bf": "guide section's",
  "copy.edd0394ed3ce": "life area's",
  "copy.f3fbe80ac981": "first record table needs a name.",
  "copy.4a041b84dc79": "First table name",
  "copy.3d0c2647c7ae": "Stable table key",
  "copy.23a676000f40": "It stays unchanged in API and import workflows.",
  "copy.895db68fc4dc": "Table description",
  "copy.d4c6f53bcf95": "Define how records behave and appear in the day view.",
  "copy.67c0eff09485": "Table type",
  "copy.50684197d101": "Time model",
  "copy.2a801af9df3e": "Default:",
  "copy.0ef12a5feae7": "Guide record · Timeless",
  "copy.bdfa5100770c": "Record · Dated",
  "copy.e925de1d7606": "Used to name the record in lists.",
  "copy.fbd385992fa5": "Choose automatically",
  "copy.5aeb95963477": "First table",
  "copy.661cbe609a69": "Type and time",
  "copy.4ccc9faad342": "Summary",
  "copy.8388c5c8329a": "Creation steps",
  "copy.e53130a9b5f3": " · completed",
  "copy.70d9341ebe2d": " · current step",
  "copy.459a85c9febb": "Icon",
  "copy.708170f044f8": "Color",
  "copy.90d85f17f926": "Technical key",
  "copy.ec7eb3211ca1": "Column",
  "copy.2009fb1f0202": "{{value1}} columns",
  "copy.bab645e5c03d": "Record title",
  "copy.0295a00221ed": "After creation, you can edit the column structure as a draft, validate it and publish a new version.",
  "copy.a3ec194b754f": "The new table is published with its initial column structure and accepts records immediately.",
  "copy.3b876bbf1cd1": "Edit guide section",
  "copy.5a0ce35faa68": "Edit life area",
  "copy.3133a3c28333": "Section name",
  "copy.9f714c45abd0": "Area name",
  "copy.3579a5b8dce0": "Table behavior and advanced information",
  "copy.9d713a223446": "Parent table",
  "copy.bb0b15dd1edc": "Choose parent table",
  "copy.8bcb09b0bcbd": "The technical identifier used by API and import workflows.",
  "copy.8b0c7ea640c5": "Add Moment",
  "copy.b439385a6437": "Manage areas",
  "copy.c4784b0418f3": "Life tracking filters",
  "copy.0efe3ec5aabf": "Journal only",
  "copy.74550c419675": "Life records only",
  "copy.8323692324bd": "AI",
  "copy.b281ae2e796d": "Imports",
  "copy.0059bfc57922": "Area",
  "copy.d54bcd05c8f3": "All areas",
  "copy.8bf3a6d0df60": "All tables",
  "copy.45bddbcb6875": "Day view",
  "copy.c40f7d0950e0": "Life tracking could not be loaded",
  "copy.285b1875cfbb": "Moments and Life records cannot be grouped by day right now.",
  "copy.2918a5654af6": "No recorded days in this range yet",
  "copy.8999cbfc0da5": "Your day card appears here when you write a Moment or add your first Life record with a time model. No predefined areas or sample data are added.",
  "copy.87c7502c13ef": "Add first Moment",
  "copy.43dee155316c": "Load older days",
  "copy.fbd92ea86a82": "Open {{value1}} day",
  "copy.0075c6e1e9a0": "There are no Moments with text for this day.",
  "copy.031bba4c548c": "No Moments with text",
  "copy.a3b7164d7c6a": "{{value1}} active · {{value2}} archived",
  "copy.8587f70236da": "No areas yet.",
  "copy.f70cdb62bf29": " · Archived",
  "copy.9000af688106": "Tracking area",
  "copy.c97f66731503": "is archived. Content can be read; new records and structural changes are disabled.",
  "copy.5467d01eb6a7": "Relations",
  "copy.d7f5fdb60cc9": "Evidence",
  "copy.858a9be12c12": "Contradictions",
  "copy.a23213933cdb": "Sources of inspiration",
  "copy.90cc7f4dc17e": "Structural links",
  "copy.7a420f3e332d": "Calendar placement",
  "copy.ced8500c67fe": "Concept map",
  "copy.1db88548e667": "Support session",
  "copy.739b8cd2f14e": "Time interval",
  "copy.b2049dcb8a3c": "Belongs to plan",
  "copy.a6ea09d691c9": "Linked to project",
  "copy.e3837823e3c2": "Contains task",
  "copy.47e669e7ff32": "Contains plan",
  "copy.b0dbf6a93fd4": "Contains routine",
  "copy.28fbadb82823": "Places on calendar",
  "copy.19d47c06250d": "Has calendar placement",
  "copy.e557fbaab0bf": "Generated from routine",
  "copy.ee92528df6be": "Generated task",
  "copy.a337c65b08e5": "Contains decision",
  "copy.0f7528e72bf3": "Is component of",
  "copy.ccadf68fa051": "Contains component",
  "copy.5442d9060293": "Semantic link",
  "copy.dd72880443c1": "Structural link",
  "copy.38002356a18d": "Core",
  "copy.7d8abd0da909": "Maintenance",
  "copy.2eea40cbb218": "Opportunistic",
  "copy.7af4c349fb9d": "Could not open period",
  "copy.78f04cf3e9eb": "The period may have been moved to Trash, or the connection is currently unavailable.",
  "copy.0abf4b7a8fc8": "Move this period to Trash?",
  "copy.1a8b07ef8509": "The period is moved to Trash and can be restored. Linked Project, Plan, and Goal records stay unchanged.",
  "copy.92927aa3ef87": "Period moved to Trash",
  "copy.16f3f595bbcd": "Edit rationale",
  "copy.3aa06f43ba21": "Defined dates, visual layer, and the period's position relative to today.",
  "copy.88e8dd312c7e": "Projects and plans",
  "copy.364e8742ce26": "Work structures carried out within this period.",
  "copy.c1cf91466150": "Link",
  "copy.4c1fb80b2c23": "No linked project or plan",
  "copy.cb0dff93af92": "Link the Projects and Plans that belong in this period here.",
  "copy.1a65304d7bbf": "Link project or plan",
  "copy.300e07fc2cae": "Linked projects and plans",
  "copy.86b532cacc4d": "Period actions",
  "copy.d5f884547452": "Active",
  "copy.6911d0495ff2": "Open start and end",
  "copy.e0f706a9fb97": "Open start",
  "copy.ab8c2f45b191": "Open end",
  "copy.8cee198fd0e8": "Complete date range",
  "copy.d0c0e63c1d17": "Period overview",
  "copy.5a7da2d1e277": "Period type",
  "copy.0a1f9917215a": "Timeline layer",
  "copy.304db21f017c": "Layer",
  "copy.ffef64f0fede": "Layers affect visual placement only",
  "copy.f674ff6c1716": "Date definition",
  "copy.c4d301935fdf": "Linked structures",
  "copy.fd7c6fe87254": "Start and end can each be left empty. The period appears on the timeline when both dates are defined.",
  "copy.855dd841aecb": "Visual placement: Layer",
  "copy.9d464093c415": "Actual:",
  "copy.d344e67ff4af": "Ongoing",
  "copy.bd3283c11c1a": "Defined date",
  "copy.6a627696616d": "No date specified",
  "copy.b60d30a533c6": "Period rationale",
  "copy.052f64253f7f": "Where this period fits in your life's direction and why it matters now.",
  "copy.5170c7e2b097": "Define",
  "copy.3515d148a822": "Purpose",
  "copy.7fa0b48ea5dd": "This period's purpose has not been defined yet.",
  "copy.e8c2527e6f34": "Why now?",
  "copy.c015baf3b1c6": "No scheduling rationale has been written yet.",
  "copy.9ba5599dc0cc": "Relation unavailable",
  "copy.b9a09af98f64": "The record is not copied here; the same Project or Plan appears in this period.",
  "copy.0f3e725ce1e0": "Search by title or description",
  "copy.1e77d1f6af90": "Loading records",
  "copy.e581e06e0f6e": "Load",
  "copy.fb9f51fe9250": "Role",
  "copy.929f9d605996": "Supporting",
  "copy.3a8ae4aa6cee": "could not be loaded.",
  "copy.cc7b5c053839": "Could not create the relation. Your selection is preserved; you can try again.",
  "copy.7f0a8a67ae79": "Goals",
  "copy.79e7ec232ff0": "Canonical Goals; link them to this period through the shared Relations panel.",
  "copy.272ee08c0fe3": "No goals yet",
  "copy.39ca63b48f14": "Create your first canonical Goal, then link it through the shared panel.",
  "copy.79cbfb691685": "Create your first goal",
  "copy.346035bbb822": "All periods span {{value1}} years. A {{value2}}-year window nearest to today is shown for smooth navigation.",
  "copy.14229a90f7e0": "Could not change the layer count. Check period placements and try again.",
  "copy.b431c281c054": "Previous range",
  "copy.68301023374a": "Next range",
  "copy.b5ad9573bff2": "Fit all",
  "copy.c32257eb5cbc": "Time scale",
  "copy.14ebad4d1610": "Layer count",
  "copy.ee3c3652d518": "Remove layer",
  "copy.5bef49e1db50": "Add layer",
  "copy.beee11d3fc80": "Load more periods",
  "copy.eb919147f805": "Not yet placed",
  "copy.43ddef184c3f": "{{value1}} unplaced period",
  "copy.b83684a6a002": "· Layer",
  "copy.cc3f40f85ca4": "Place",
  "copy.a5b0558447b9": "All {{value1}} layers are occupied in this date range. Placement was not changed.",
  "copy.d0e13459fdd1": "Could not update placement. The timeline has been reloaded.",
  "copy.f3afc42428d6": "All {{value1}} layers are occupied in this drop area. Placement was not changed.",
  "copy.298cc3007f8c": "Period timeline",
  "copy.3505736508ac": "Invalid drop area: no layer is available in this date range.",
  "copy.452f7fb9e112": "Aligned: {{value1}} → {{value2}} {{value3}} · {{value4}} · Layer {{value5}}",
  "copy.05af2bb52072": "another period",
  "copy.28622351a58d": "Drag: date and layer · Shift: precise movement · Edges: start/end · Arrow keys: accessible alternative",
  "copy.763e2d30091d": "Show as list",
  "copy.4a1848d0ed11": "Period list",
  "copy.bf5abe9b8e8f": "Open start",
  "copy.ad54d5052bba": "Open end",
  "copy.483992a9e2d1": "Edit placement",
  "copy.b946c04bbc9a": "Change the start of {{value1}}",
  "copy.d8a599e9eb42": "{{value1}}, Layer {{value2}}. Move with arrow keys.",
  "copy.f4c19f8840c1": "Change the end of {{value1}}",
  "copy.36d21936edf3": "Invalid date range",
  "copy.563085d157bd": "open start",
  "copy.4a8cd3bc5a73": "open end",
  "copy.22becce5badd": ", {{value1}} open tasks",
  "copy.e1ffcba16869": "Edit period",
  "copy.380e872bea1f": "Create period",
  "copy.02f15b581054": "Update its dates, visual layer, and life scale.",
  "copy.abc934a19a5e": "A part of life with a purpose. It is not executable work; it gives meaning to the work within it.",
  "copy.929f8fa2f9da": "Scale",
  "copy.afdb7a6fcfd2": "Timeline layer",
  "copy.13b3f7bf6cc0": "Commitment",
  "copy.4a9625a3ae32": "Exploring — it may not happen",
  "copy.3f0f9c402640": "I intend to",
  "copy.d4ae18405e3f": "I have committed",
  "copy.fd399bcf7c0f": "The end date cannot be before the start.",
  "copy.e088fc7be49e": "Dates can be left empty. The period is placed on the timeline when both dates are complete.",
  "copy.998e50bbb7e3": "Goals are linked from the details page after the period is created; execution capacity and rest rules remain in Planner.",
  "copy.6af8624b8d50": "Complete the start and end dates to place it on the timeline.",
  "copy.791889afdf62": "Could not update placement. Your information is preserved; you can try again.",
  "copy.0f7acb876fe6": "Update the start, end, and visual layer together. If another period overlaps, it is moved to the nearest free layer.",
  "copy.a5fd2c3893bd": "A layer affects only visual placement; it does not change the period's meaning.",
  "copy.139a10264cf2": "Plan not found",
  "copy.c10489842ab5": "This link has no plan identifier.",
  "copy.8d1529342457": "Could not load plan",
  "copy.80e402eb3665": "The plan may have been deleted, or the server is currently unavailable.",
  "copy.e74052e88611": "at least one task or routine",
  "copy.a49636c72799": "Could not change the plan's status.",
  "copy.e7b434a9b167": "No description has been written for this plan yet.",
  "copy.8304853ab5b4": "Move to draft",
  "copy.0286d7cad515": "To activate, add",
  "copy.db2984dc76b6": ".",
  "copy.97e79018f0d8": "Ordered task flow",
  "copy.69af571f32a7": "For undated tasks, only the next step appears in general lists. All steps are visible within this plan.",
  "copy.43a3d58e4b71": "No tasks in this plan",
  "copy.8d74eec05124": "The task flow appears here when you add your first actionable step.",
  "copy.b9cf1e4871cd": "Add the first task",
  "copy.3eb7270bd052": "Routines are added to this context after the plan is created.",
  "copy.aea035b02ae3": "Manage routines",
  "copy.68f4f4b9a87f": "No routines in this plan",
  "copy.96bcecce0e8c": "Link recurring actionable steps here later.",
  "copy.df4a8c3db38c": "Plan overview",
  "copy.6f3c27d67821": "Independent plan",
  "copy.5ed83639ab41": "Task progress",
  "copy.a3742b9734ab": "No tasks yet",
  "copy.0c2deb578739": "No occurrences yet",
  "copy.daebc159a763": "{{value1}} task order",
  "copy.3366af89311d": "{{value1}} is ordered by its routine",
  "copy.9dc9cb81d6d7": "Unknown status",
  "copy.1ffa720fef90": "In general list",
  "copy.a0b136334423": "Only in plan",
  "copy.f81a270ad5c1": "{{value1}} list visibility",
  "copy.cdd55786e02a": "Edit schedule for {{value1}}",
  "copy.59ac3cf98517": "No planned duration",
  "copy.03a3be428311": "Planned duration {{value1}}",
  "copy.9882025b673c": "The plan has no date boundaries",
  "copy.bfd2e9ec35ed": "The routine has no date boundaries",
  "copy.bdbbed71e904": "Active range in this plan: {{value1}} · Routine's own range: {{value2}}",
  "copy.e0b05c8d7324": "Could not save the plan. Try again.",
  "copy.623e519ea5b9": "A plan name is required.",
  "copy.518fad2c1a39": "Start and end must be selected together.",
  "copy.8b1b196e813d": "Edit plan",
  "copy.6d1ecad349c8": "Define the plan's scope and work range. Add tasks and routines later from plan details; semantic relations are managed in the shared Relations panel.",
  "copy.ef34af7a1d51": "Plan without a project",
  "copy.b5fa2e4a903c": "No date range set",
  "copy.ba34b2fd646c": "No date boundaries",
  "copy.73aa2d75c533": "Routine's own range: {{value1}}",
  "copy.f9882d2541a4": "Active range in this plan: {{value1}}",
  "copy.8a0b7c83e9aa": "Could not save routine links. Try again.",
  "copy.6dcea34e6d37": "Manage plan routines",
  "copy.34a7272e65f4": "Link routines and set the date range during which this plan uses them. These dates do not change the routine's own definition.",
  "copy.db792ab5ced3": "Save routines",
  "copy.a79c68f74b2d": "Search routines",
  "copy.bc3482cf26e7": "Plan routines",
  "copy.349a08c7a711": "An empty link date uses the Plan's start or end date. The routine still does not generate occurrences outside its own date range.",
  "copy.a9a9c9e16159": "Could not load other routines",
  "copy.0bfae90fadc6": "You can view or remove existing links; reload the list to add a new routine.",
  "copy.0ae9722fb298": "No routines available to link",
  "copy.4fb4a17e274e": "Create a routine on the Routines page first.",
  "copy.c560d2492775": "No routines match your search",
  "copy.56751f567f26": "Try another title or context.",
  "copy.fb8d508c1376": "Linked",
  "copy.899f7ab0a013": "Link dates in this plan",
  "copy.c39af090ea2f": "Active range:",
  "copy.59075d4fa3fe": "Clear link dates for {{value1}}",
  "copy.011d55aefcd7": "Clear dates",
  "copy.b3dc8ba4aff4": "{{value1}} link start date",
  "copy.64071ccb610e": "{{value1}} link end date",
  "copy.0b55754c7340": "Routine's own range:",
  "copy.93312536225b": "An archived routine cannot be saved again. Deselect it or restore it from the Routines page before changing other links.",
  "copy.27b4eefdef1f": "Filter by plan status",
  "copy.67ef93689230": "All statuses",
  "copy.4a16a8e1275f": "Active plans",
  "copy.14a803d9acaf": "Paused",
  "copy.a44b1c556989": "Completed",
  "copy.b642eadf7f02": "Canceled",
  "copy.3236ea169953": "No plans yet",
  "copy.43c803ce46ea": "No plans with this status",
  "copy.daa03929678c": "A plan shows its time range, ordered tasks, and routines active within that range together. Semantic relations such as Goals are linked through the shared Relations panel.",
  "copy.4251c7b23585": "Create your first plan",
  "copy.73ac916651d6": "Reorder plan {{value1}}",
  "copy.7b0d5cffae67": "Scope",
  "copy.19a48a60f80e": "Task status",
  "copy.bd03ca7dad02": "project",
  "copy.5f4fc24534ee": "Open details",
  "copy.0e8b8adf29a2": "Personal space",
  "copy.8d3acf9bc42d": "All day",
  "copy.cdbb6c818fc5": "{{value1}} scheduled records overlap protected time by a total of {{value2}}.",
  "copy.97cd70bd8c6f": "Scheduled and protected time exceed the remaining awake time by {{value1}}.",
  "copy.6e01fa30ba57": "This day has {{value1}} of protected time.",
  "copy.148afd948550": "There is {{value1}} of open time outside scheduled and protected time.",
  "copy.ce6182e5a852": "A potentially relevant pattern was found in this day's records.",
  "copy.6ee0f005f655": "Protected life time",
  "copy.9caccd9df722": "Time for rest, enjoyment, and relationships that you want to keep outside the plan.",
  "copy.6ee0d295bf76": "Add protected time",
  "copy.c20ca4db5102": "has no protected time defined.",
  "copy.98a00fa412c1": "Protected time",
  "copy.2b7c80cc9b5c": "Planning observations",
  "copy.aa955a174652": "AI observation:",
  "copy.ee85a93741e6": "Delete “{{value1}}”?",
  "copy.99b1bdef2437": "This time will no longer be protected in the daily capacity calculation.",
  "copy.6bf9e0080742": "Protected time deleted",
  "copy.1a669f572aaa": "Could not delete protected time",
  "copy.88b26571e318": "These areas appear separately from planned work in daily capacity; they do not move tasks automatically.",
  "copy.953e891c543b": "Add time",
  "copy.8da662775cf2": "Could not load protected time",
  "copy.3f612249c199": "No protected time yet",
  "copy.a7f80051b068": "Keep sleep, rest, meals, movement, or personal time visible outside the plan.",
  "copy.040cffe162d6": "Edit time {{value1}}",
  "copy.a84b95a3a8ab": "Delete time {{value1}}",
  "copy.ef626a1f4110": "Enter a name for the protected time.",
  "copy.c069738b0c08": "Choose the start and end times together.",
  "copy.d0b870c1c55a": "The end time must be after the start time.",
  "copy.5c946d4870ed": "The last valid day cannot be before the first day.",
  "copy.6485ee83fa7b": "Protected time added",
  "copy.601ded68bff8": "Protected time updated",
  "copy.c53c184d76a2": "Could not save protected time. Check the fields and try again.",
  "copy.326c0cde5770": "Add protected time",
  "copy.da76dfd3e3c0": "Edit protected time",
  "copy.d9ed1ead0888": "This record shows only the meaning and placement of time; it does not change tasks.",
  "copy.1d97c9fec35a": "Name",
  "copy.1968988727dc": "e.g. Evening rest",
  "copy.0834ffadb2fd": "Days",
  "copy.072a779858ba": "Recurring days",
  "copy.31565069849f": "Applies every day if no days are selected.",
  "copy.68a01c9826c4": "Validity and visibility",
  "copy.8d04adbd691f": "First day",
  "copy.b51cb4cab2c8": "Last day",
  "copy.403b54e5bad3": "Why it is protected",
  "copy.5a66003ed8be": "Describe what this time protects for you, if you like.",
  "copy.e7cbf5c7729e": "Highlight overlaps",
  "copy.8d85780e3da3": "An observation appears when a scheduled task overlaps this time.",
  "copy.2b77c37eabf0": "Include in capacity calculation",
  "notes.filtered_title": "No notes match these filters",
  "notes.filtered_description": "Try clearing search and filters, or create a new note.",
  "notes.clear_filters": "Clear filters",
  "copy.4be9e99a2c39": "Moved to {{value1}}",
  "copy.45cc224f3d80": "Time and planned duration were preserved.",
  "copy.2428ea8c2ccd": "Could not move calendar record",
  "copy.e6c4207d9f13": "The current schedule is preserved; you can try again.",
  "copy.0e34d0419e45": "Remove the task's date? The date and time are removed; the task remains.",
  "copy.b88019aa289e": "Remove",
  "copy.72f0b2814f11": "Remove time only",
  "copy.8db3815f273a": "Remove date",
  "copy.e5c5555013e4": "{{value1}} before",
  "copy.ad281cacd4cb": "Quick move",
  "copy.f7f801432011": "One day earlier",
  "copy.baa86253b900": "One day later",
  "copy.a31a3d5209b8": "This block crosses midnight",
  "copy.a18692783a0c": "Open task details",
  "copy.3a428a31e175": "Week",
  "copy.c85a3445186c": "Month",
  "copy.7a3d5c66c512": "Year",
  "copy.567d2861e924": "Untitled task",
  "copy.4969f1984525": "Calendar scheduling area",
  "copy.c59d374175b7": "Calendar range and view",
  "copy.68684cad283f": "overlaps",
  "copy.d1b88dc70ce7": "Go to date",
  "copy.c57487f54670": "Go to date",
  "copy.64b89017e71e": "Calendar view",
  "copy.435aa213b79a": "Previous range",
  "copy.34288f4523b4": "Next range",
  "copy.2ea0ab5cf924": "Could not load calendar",
  "copy.f5d1384a3532": "Your calendar tasks are currently unavailable.",
  "copy.8b39f318881d": "Calendar tasks ·",
  "copy.4194b609427e": "overlapping records",
  "copy.0ae0df91657c": "No overlaps",
  "copy.323f88bce5fc": "Select to edit · Drag to move on desktop",
  "copy.094e329c373a": "Task added to calendar",
  "copy.9d209943b397": "Could not add task to calendar",
  "copy.11b0a0f5a4b4": "The task remains undated; you can try again.",
  "copy.e5dd861fed38": "Task moved on calendar",
  "copy.e4ae77e21aa9": "Could not move calendar record",
  "copy.d36596a5bad3": "The current date and time are preserved; you can try again.",
  "copy.a4de876fc31d": "Moved to the calendar for {{value1}}",
  "copy.23d364bbcf30": "The task was dropped in the untimed area.",
  "copy.04628d31520b": "Time and duration updated.",
  "copy.0123c78626eb": "The previous date and time were restored.",
  "copy.028381aafdcf": "Task added to selected date",
  "copy.254d2c4ef745": "Could not schedule task",
  "copy.09c509a72b8c": "The current plan is preserved; you can try again.",
  "copy.6dc5b1b6637f": "Task date removed",
  "copy.eb3f061ed1e9": "The calendar date and time were removed; the task is preserved.",
  "copy.fa2f5bb50075": "Could not remove task date",
  "copy.34736a99c8f5": "The current calendar record is preserved; you can try again.",
  "copy.02b0326d5995": "Untitled task",
  "copy.121ec13991c7": "Tasks to schedule",
  "copy.765289e9da60": "Undated tasks drop target",
  "copy.65a45ef05ebf": "Drag to remove date",
  "copy.3ad2c522a011": "Drag tasks to a day or time.",
  "copy.e548d2b67eba": "{{value1}} · {{value2}}. Select to add to {{value3}}, or drag to a day or time on the calendar.",
  "copy.bf9c3c011d51": "{{value1}} · {{value2}}. Add to selected date.",
  "copy.cfcaa4fe24c1": "No tasks to schedule.",
  "copy.a0f11fd3836c": "{{value1}} time range",
  "copy.1ee05cadf5e6": "Untimed tasks",
  "copy.8df6ec34132f": "On this day, awaiting a time",
  "copy.05df844d9f2d": "{{value1}} untimed task area",
  "copy.d086b15fde52": "No untimed tasks have been placed on this day.",
  "copy.e05143c2dc77": "· Today",
  "copy.62d546f04e0c": "Untimed",
  "copy.3159a7fbc91b": "untimed",
  "copy.df3c2a61209e": "{{value1}} timed task area",
  "copy.a80c6803c5b3": "Duration changed to {{value1}}",
  "copy.46fd03c54674": "Could not change task duration",
  "copy.23db35574d60": "The previous duration was restored.",
  "copy.846f0ac09a53": "Time overlap",
  "copy.34ad4b19462d": "Open calendar item {{value1}} · {{value2}}",
  "copy.84315466a95a": "Change duration",
  "copy.97a4891899f5": "{{value1}} · Open day plan",
  "copy.7f2193270b7f": "more records",
  "copy.d4271592aa66": "{{value1}} · {{value2}} records",
  "copy.65fdaf5aa32f": "{{value1}} · {{value2}} records{{value3}}",
  "copy.eddaa78d27e9": " · plan the day",
  "copy.524d77f07472": " · plan the empty day",
  "copy.922970e0dc97": "Schedule preserved",
  "copy.32cb50ba8a7a": "The task was dropped in the day's tasks area; its date and time did not change.",
  "copy.955ee8d107f2": "Day plan",
  "copy.c2c0c5e32e96": "Day plan view",
  "copy.811f29689449": "Circular flow",
  "copy.d11a92bd9f4a": "Time grid",
  "copy.da6b786b2bcc": "Could not load day plan",
  "copy.bf3935864545": "Calendar records for the selected day are currently unavailable.",
  "copy.4db5ed5675f0": "Day plan scheduling drop targets",
  "copy.06218a631907": "Drop the task in one of these areas",
  "copy.36525fb3546f": "Remove time only drop target",
  "copy.f64d1be8a5c0": "Date is preserved",
  "copy.b44940cd7eec": "Move to next day drop target",
  "copy.70cd0bcfca5f": "Move to next day",
  "copy.cff7d599fef0": "Time is preserved",
  "copy.5930c5536cb1": "Remove date drop target",
  "copy.ab72d2b2af60": "Date and time are removed",
  "copy.9a5e325a9623": "Day's tasks",
  "copy.866753ea0a6c": "No tasks have been placed on this day yet.",
  "copy.32700da22c1a": "Awaiting a time",
  "copy.544e3ddadc82": "Open calendar item {{value1}}",
  "copy.f55ed15e7068": "Notifications, {{value1}} unread",
  "copy.bf8e8e9e5f41": "Reminders delivered in this session",
  "copy.22103a46d24d": "No notifications yet",
  "copy.fefb442f15a2": "Reminders delivered while this tab is open appear here.",
  "copy.8e5b0b3db3d7": "Recent notifications",
  "copy.ead388599a02": "Browser notifications are enabled",
  "copy.564e9113da50": "Show reminders in the browser too.",
  "copy.d1b502d5bc18": "Requesting permission…",
  "copy.0de3ec9400c0": "This browser does not support system notifications; in-app notifications appear here.",
  "copy.9015c3eda7fb": "Browser permission is disabled; in-app notifications continue to appear here.",
  "copy.1edbe5d0d161": "Delivered",
  "copy.156f054c5d19": "Day capacity",
  "copy.e3ff6c057763": "remaining free time",
  "copy.ffb3343777bb": "free time",
  "copy.62c1abea616b": "Scheduled and protected time in the remaining day",
  "copy.84c49fe82a6d": "end time — extends into the next day.",
  "copy.86cda89bf510": "scheduled",
  "copy.2e5ae066befc": "protected",
  "copy.9e583f76b263": "awake",
  "copy.aa833a0bd7bf": "Open time ranges",
  "copy.028f50732ae1": "Open ranges",
  "copy.e5ceb645a780": "Scheduled and protected time exceed the remaining awake time by",
  "copy.d1b53062af38": ".",
  "copy.7c590a630796": "There was no work on today's calendar",
  "copy.0f0415606643": "Everything you placed here is complete",
  "copy.9031bd5e5eac": "Today's calendar work is complete",
  "copy.60b9577bcda2": "A few decisions remain open",
  "copy.ac23d768bb65": "A day without a schedule is still a day. There is no schedule to reconcile.",
  "copy.d54b023b7bbc": "No decisions remain pending. You can close the day.",
  "copy.901df9adda50": "Other things are awaiting decisions, but they are not today's work.",
  "copy.89b7dfdcabc5": "Some work you linked to today is still open.",
  "copy.60347f9d0b0c": "Calendar work",
  "copy.ec4c3940cafb": "Recorded focus",
  "copy.3378237f49d0": "Pending decisions",
  "copy.883dbaa94e8d": "Next commitment",
  "copy.b92e5120e9a5": "Day closed",
  "copy.a52ece1329ab": "Close day",
  "copy.79c4b04b6ee8": "Done",
  "copy.d089deff4e75": "No pending decisions.",
  "copy.6b93617606da": "You can still close the day; nothing is deleted.",
  "copy.4ddec81a8054": "Could not load day reconciliation",
  "copy.ae7431c5ad30": "The day cannot be closed until the plan's status is verified.",
  "copy.011c6e5ef854": "Until bedtime:",
  "copy.9e89e4826d45": "of free time remains.",
  "copy.d9441d91da97": "Note (optional)",
  "copy.00782a540398": "Something you want to note about today…",
  "copy.5469858dcc53": "Everything you placed here is accounted for. The rest can wait until tomorrow.",
  "copy.172099767158": "This day is closed.",
  "copy.70e8fb4fae39": "calendar tasks",
  "copy.523294ebb6b2": "reopen this day",
  "copy.df9f4b74bc0c": "Could not load current context",
  "copy.85bb10ea023f": "The schedule, period, and latest status records could not be read together.",
  "copy.31884e949336": "Current context",
  "copy.01ad6ba43265": "active periods",
  "copy.91bfc2b7ef5b": "active projects",
  "copy.8a5db2e94a0a": "remaining tasks",
  "copy.78ea7fdf394d": "remaining schedule",
  "copy.7345e60c81aa": "Ends in {{value1}}",
  "copy.d70974e70320": "Starts in {{value1}}",
  "copy.5f820fa37979": "No tasks are waiting to be completed today.",
  "copy.cc760ec022c0": "Active direction",
  "copy.9640929920ab": "No active period or project.",
  "copy.bd7cf36cf2be": "Upcoming",
  "copy.76f4d3fa4845": "No upcoming project dates.",
  "copy.09b39d3a25eb": "overdue tasks",
  "copy.8f1aed8fecc4": "open drafts",
  "copy.03f3621b3140": "Focus is running",
  "copy.78c9c070ec98": "Drag to the day flow to change its time",
  "copy.3f5bfafe54a5": "No time selected",
  "copy.467ed1a61153": "Drag to a time",
  "copy.6a51ba2a4c79": "Now",
  "copy.06942e808a97": "Passed",
  "copy.83893db25b56": "Remind {{value1}} min before",
  "copy.5c3f46032c57": "Reminder set",
  "copy.69a3d194baa8": "No undated tasks",
  "copy.92001100eca6": "No visible open tasks are without a date.",
  "copy.22748dcebc7f": "free",
  "copy.871e490c3da8": "after",
  "copy.79777ba97d30": "Now {{value1}}",
  "copy.05663d97d4ed": "Getting started",
  "copy.fdd029276778": "Exognitos takes care of remembering so you can keep thinking.",
  "copy.548cc182668c": "You can leave everything you are keeping in mind here. One rule: you do not need to decide while capturing; consider what it is later.",
  "copy.4df9fa6e0f2b": "Capture something on your mind",
  "copy.da2535304a18": "A task, an idea, a sentence you do not want to forget. Classification comes later.",
  "copy.c0f848957280": "Create an area and a project",
  "copy.8064b8ebb97d": "An area is an ongoing part of your life, such as university or health. A project is work that ends.",
  "copy.3126e14f2045": "Go to Organize",
  "copy.f8ce84ed4d50": "Add one thing to today's calendar",
  "copy.f07e4b1a435a": "Drag a task from the undated list to a time. Day capacity shows how much room remains.",
  "copy.a6c2ff64f0bf": "No next task for today.",
  "copy.473acc1fd33b": "Tomorrow's and undated tasks are not promoted into this card.",
  "copy.6a98ba6759ef": "Coming up",
  "copy.183896bdd9c4": "Task completed",
  "copy.2477007bad7e": "Time information",
  "copy.89f8e5676026": "start time",
  "copy.338b15bb3ad7": "Next task actions",
  "copy.506fb0c58f9d": "What now?",
  "copy.2969d21826b2": "Complete task",
  "copy.5f6769fd00eb": "Unprocessed draft",
  "copy.1f588431fe4d": "Important, not on calendar",
  "copy.613e6d93b76f": "No next step",
  "copy.d7e693d58a3e": "Could not load pending decisions",
  "copy.a0f2d38d2933": "An empty view does not necessarily mean there is no data.",
  "copy.949d313bac52": "No commitments are missing a plan or decision.",
  "copy.f60f7e41e4f6": "Open loops are drafts, tasks, or projects that still lack a plan or decision and continue to occupy your attention.",
  "copy.88da7c754722": "more awaiting decisions",
  "copy.e1becffa59af": " · {{value1}} days",
  "copy.156d843f1117": "Task scheduling drop targets",
  "copy.6879dbd9f7d3": "Actual focus",
  "copy.0654294bbd2f": "Could not load week view",
  "copy.e92e98582d3f": "Could not retrieve the plan and focus summary for this range.",
  "copy.972e3131cb1b": "items",
  "copy.4eece1005539": "This week",
  "copy.20e352b074a6": "planned,",
  "copy.072cd074faf8": "focus recorded.",
  "copy.d248747f7370": "Could not load month view",
  "copy.f475ea7072b8": "The calendar summary is currently unavailable.",
  "copy.45fd575db625": "1 hour before",
  "copy.279bedb85334": "Could not save the schedule. Your information is preserved; you can try again.",
  "copy.207ee1b4fd46": "Save schedule",
  "copy.6b2e51ccbd5b": "A date is required.",
  "copy.0afcaf7e8ba5": "If left empty, the task appears on this date without a time.",
  "copy.678617918c97": "Available only for tasks with a specified time.",
  "copy.1e64449a0aab": "Task time removed",
  "copy.b54cee1d05c2": "The date is preserved; the task now has no time.",
  "copy.39bcc93a77b7": "Could not remove task time",
  "copy.539731aa1bb7": "Task moved to next day",
  "copy.e0e274d7db42": "The time was preserved.",
  "copy.274186eea66f": "Could not move task to a later day",
  "copy.0c887af84ab0": "Date and time were removed; the task is preserved.",
  "copy.b3f2c677de5b": "The task was dropped in the task box; date and time did not change.",
  "copy.53a1a38c4b64": "Next",
  "copy.e8697e13892a": "Create task",
  "copy.f1d48e85474e": "Previous",
  "copy.ffe6922f5329": "Next",
  "copy.8563f1a3e765": "Could not load the day's schedule",
  "copy.1b4218323223": "The timeline is currently unavailable.",
  "copy.6c5b950cdabd": "Day flow",
  "copy.6f067d3d2a06": "timed",
  "copy.320bbb51ca6c": "Overdue",
  "copy.2755cbdb10d5": "No tasks added to this day",
  "copy.ba19f680628f": "Use Add task to create one directly for this day.",
  "copy.dc6bbd7e39f1": "No open tasks have a past date or have passed their planned end time.",
  "copy.ca91214c14b4": "Calendar details",
  "copy.c44bfda2d42d": "{{value1}} untimed tasks · {{value2}} overdue · {{value3}} undated",
  "copy.7a0236f9b07b": "Calendar details",
  "copy.a7caf0331a44": "Agenda",
  "copy.7b1ff8940b18": "Day capacity",
  "copy.041b04b13dd8": "Open loops",
  "copy.1df768b69f7a": "What should I do now?",
  "copy.9b946942b0e0": "Back to today's plan",
  "copy.d16975e3682b": "Selected day overview",
  "copy.8baf2bd56c8d": "Day closed",
  "copy.a517fd9ccd5e": "Selected day",
  "copy.1367d164d3de": "No open tasks for this day",
  "copy.bbff3cc44852": "total",
  "copy.972f55dfde4d": "on the calendar now",
  "copy.c43fadb32d41": "starting soon",
  "copy.b41304448c97": "past its time",
  "copy.be0d4d7a11b0": "today's routine",
  "copy.31c67cc7d301": "fits the time",
  "copy.30e4f975a6db": "Ordered by the resources you have",
  "copy.429cfaae4507": "How much time do you have?",
  "copy.f0af7abef99b": "Any",
  "copy.7431192d0860": "How is your energy?",
  "copy.4962e8ad77d5": "Include routines",
  "copy.888fdc89e9bb": "Could not load suggestions",
  "copy.7a40fc5340cd": "Your selections are preserved. Check your connection and try again.",
  "copy.e95be2508a09": "Nothing matches these conditions",
  "copy.d920fadb0297": "Try allowing more time or including routines.",
  "copy.7a2c6f3cc690": "No pending work is visible right now.",
  "copy.fb62ef2f7f99": "If it all feels like too much",
  "copy.6bdceb20bea9": "Sometimes the difficulty is a full mind, not which task to choose.",
  "copy.99dec6f1fe61": "Could not load year view",
  "copy.bbc1ce402c1d": "The annual activity and project summary is incomplete, so it is not displayed as zero.",
  "copy.b7fd9da06d85": "Measure",
  "copy.4b19a5512c11": "Active days",
  "copy.997a63cd3cea": "{{value1}}% of elapsed days",
  "copy.79028a6a0938": "not started yet",
  "copy.30ea21e2b1fb": "Longest streak",
  "copy.6a443fe02638": "Year heatmap",
  "copy.950979c16ee9": "recorded focus duration",
  "copy.b639cf07f7a3": "completed task count",
  "copy.f77cc3558af2": "{{value1}} completed tasks",
  "copy.df8c91e0cb09": "Projects active this year",
  "copy.f9bc6ea72598": "by latest activity",
  "copy.f0159e35020a": "There are no open projects. The year view is not a planning surface; having nothing to show here is also an answer.",
  "copy.9ab725a48080": "neglected",
  "copy.ffd6025ead4a": "{{value1}} days ago",
  "copy.9c0ada37bf74": "less",
  "copy.bac07d9099f7": "more",
  "copy.4d87bf4a4f86": "Undo",
  "copy.d48d2105e0de": "open",
  "copy.5bcfa78d10bb": "Estimated duration",
  "copy.52631b805293": "Knowledge type",
  "copy.b5a5f13a5a99": "Project type",
  "copy.1602666d69e6": "Try again",
  "copy.cc3a034f37ac": "Life areas",
  "copy.da066049de59": "archived",
  "copy.254bb97b57f1": "notes",
  "copy.03db18f5e980": "Timeline",
  "copy.fef9549d3b6c": "Remove relation",
  "copy.0549f9596210": "Record type",
  "copy.d469d789b381": "start",
  "copy.cb2f38934e37": "end",
  "copy.29640274b07e": "Back to {{value1}} project",
  "copy.16610570205e": "Back to plans",
  "copy.99f96301643e": "Save changes",
  "copy.982883a3ffc7": "Completed task",
  "copy.bff2f01c32e8": "Routine details",
  "copy.baf2e1b17246": "Task details",
  "copy.c1fc8fefe11e": "days",
  "copy.64879f7d6b96": "planned",
  "copy.77d8cdbe3a1c": "focus",
  "copy.d2ad57acc9b2": "Now",
  "copy.189fca6d12be": "Next task",
  "copy.1350e9df4f9a": "Capture",
  "copy.a568461fb985": "Nothing awaiting a decision",
  "copy.201ebd24501b": "Open source routine",
  "copy.829baf39688d": "Next week",
  "copy.49f9a444a20e": "completed",
  "copy.66b72e853724": "overdue",
  "copy.81af230f2a77": "high priority",
  "copy.5b09d3fe7430": "today",
  "copy.816d65211cc4": "Work context",
  "copy.cd670e8f865d": "open tasks",
  "copy.093575e59d1c": "Select note",
  "copy.df461377a4b8": "No notes linked to this project",
  "copy.1b0d554a536f": "Notes from Memory appear here when linked to this project context.",
  "copy.1bae74831f56": "Modern Light",
  "copy.735c05e384d9": "Clean, balanced, and suited to daylight.",
  "copy.66e1c11b287a": "SaaS Navy",
  "copy.c5d975e18199": "Exognitos's layered navy appearance.",
  "copy.3af07dceb19d": "OLED Black",
  "copy.88dbcb2b0903": "Pure black surfaces with minimal light output.",
  "copy.87477d444bd6": "Nordic Cold",
  "copy.8de5e0a8a700": "A cool, clear, and calm workspace.",
  "copy.320515b8209b": "Solarized Light",
  "copy.a4830d3dd2fd": "Gentle warmth for long focus sessions.",
  "copy.af30a45d7674": "Monokai",
  "copy.b195b5c41545": "A readable dark color palette.",
  "copy.faf73cec0083": "High contrast",
  "copy.331e054eab13": "Clear boundaries and strong accessibility.",
  "copy.a565583a03f2": "Pastel minimalist",
  "copy.13b7ae63ab89": "A calm appearance with gentle pastel layers.",
  "copy.12d74372034a": "Sepia / Focus",
  "copy.42e50ee6cccf": "Low-glare tones for reading and writing.",
  "copy.84ad688ed1e8": "Cyberpunk",
  "copy.76e9049df535": "A dark surface with neon accents for night work.",
  "copy.72505bef1243": "Close {{value1}} window",
  "copy.38ed0d380a85": "Window",
  "copy.cba3f60c03a3": "planned",
  "reorder.moveUp": "Move up",
  "reorder.moveDown": "Move down",
  "reorder.previousCollection": "Previous collection",
  "reorder.nextCollection": "Next collection",
  "memory.recent": "Recently used",
  "memory.unfiled": "Unfiled",
  "notes.open_count_one": "{{count}} note",
  "notes.open_count_other": "{{count}} notes",
  "window.moment": "Moment",
  "window.note": "Note",
  "records.columns_one": "{{count}} column",
  "records.columns_other": "{{count}} columns",
  "copy.a33a25f4d3e2": "Nutrition",
  "copy.f3821eae3e3a": "Coffee",
  "copy.819b1dd8e6d1": "Sleep",
  "copy.1d8412f6c563": "Exercise",
  "copy.4afe6f98a42d": "Reading",
  "copy.1e99298c6679": "Activity",
  "copy.2d88a3a2842e": "Water",
  "copy.bc462b2ecd4b": "Mind",
  "copy.086f264fd79b": "Home",
  "copy.d48ba7f37166": "Rest",
  "copy.a8372e80d2c0": "Meal",
  "copy.96c3fdb57013": "Movement",
  "copy.229f48383140": "Enjoyment",
  "native.settings_scope": "Account security, planning preferences, notifications and backup management require browser sign-in. Theme and language are saved on this device.",
  "native.theme_saved": "Theme saved on this device.",
  "native.first_party_only": "This action requires the browser session. Sign in on your Exognitos server in a browser to continue.",
  "copy.55717dfa8365": "sleep",
  "copy.a0afc8df4fba": "mood",
  "copy.1885d0e630e3": "low motivation",
  "copy.9f7ed878b7b6": "missing input",
  "copy.4b11b17f565f": "underestimation",
  "copy.3711561cf43c": "travel",
  "copy.2257c79ccb2c": "Physical",
  "copy.14fae0715e36": "Digital",
  "copy.32b335d50f71": "{{value1}} · Technical settings",
  "copy.0a456b7b2bd9": "Table v{{value1}} · {{value2}}",
  "copy.8db4d93dad5f": "{{value1}} (minutes)",
  "copy.a355f1e38138": "Rating",
  "copy.237b14cbb480": "Money",
  "copy.bd1865998b12": "Supporting items",
  "copy.d457637e75b3": "References",
  "copy.10678047e8c1": "Decisions",
  "copy.b90ce029f217": "Close {{value1}} tab",
  "copy.3d83a8d317a1": "Search {{value1}}",
  "copy.906d37bd6ca1": "{{value1}} — Lane {{value2}}",
  "copy.e8981f05ef10": "Stalled",
  "copy.32ba741f788e": "Pending",
  "copy.810cbf5caace": "{{value1}} progress {{value2}}%",
  "copy.e3a882374659": "Part {{value1}} title",
  "copy.f234713b8ba6": "Part {{value1}} description",
  "copy.90468135b048": "Part {{value1}} estimate",
  "copy.8e42dc2f2a0a": "Light",
  "copy.04eb32d1dad7": "Balanced",
  "copy.0145e636965f": "Full",
  "copy.c498427f0fd2": "{{value1}} focus",
  "copy.c68b57d25e86": "{{value1}} min focus",
  "copy.e6cf2b3feab3": "{{value1}} series",
  "copy.67d8b8f89953": "Component",
  "copy.00e9738b77c7": "Yes",
  "common.yes": "Yes",
  "time.minute_unit": "min",
  "focus.planned": "planned",
  "count.records_one": "{{count}} record",
  "count.records_other": "{{count}} records",
  "count.routines_one": "{{count}} routine",
  "count.routines_other": "{{count}} routines",
  "count.entries_one": "{{count}} entry",
  "count.entries_other": "{{count}} entries",
  "count.notes_one": "{{count}} note",
  "count.notes_other": "{{count}} notes",
  "count.open_tasks_one": "{{count}} open task",
  "count.open_tasks_other": "{{count}} open tasks",
  "count.links_one": "{{count}} link",
  "count.links_other": "{{count}} links",
  "count.expected_repetitions_one": "{{count}} expected repetition",
  "count.expected_repetitions_other": "{{count}} expected repetitions",
  "project.kind": "{{kind}} project",
  "plan.completedTasks": "{{completed}}/{{total}} completed",
  "plan.taskCount_one": "{{count}} task",
  "plan.taskCount_other": "{{count}} tasks",
  "plan.routineCount_one": "{{count}} routine",
  "plan.routineCount_other": "{{count}} routines",
  "plan.projectContext": "{{project}} project",
  "plan.activationNeeds": "To activate, add {{requirements}}.",
  "plan.dateFrom": "From {{date}}",
  "plan.dateUntil": "Until {{date}}",
  "copy.3cb899cfe418": "Table contracts and field structure",
  "copy.e79aeddc061d": "The lower bound cannot exceed the upper bound.",
  "copy.42e6814599b4": "A table must have at least one column.",
  "copy.3c45dd397ac5": "A table name is required.",
  "copy.5bdd8a1922d7": "A table key is required.",
  "copy.9a6c607b6579": "Select a parent table for the component.",
  "copy.c8374ff9d987": "Create table",
  "count.tables_one": "{{count}} table",
  "count.tables_other": "{{count}} tables",
  "capacity.finish": "The plan ends at {{time}}.",
  "capacity.finish_next_day": "The plan ends at {{time}} the next day.",
  "common.saved": "Saved",
  "common.save_failed": "Could not save",
  "draft.position": "Draft {{position}}",
  "draft.awaiting_decision": "awaiting a decision",
  "lifecycle.archived": "Archived {{relative}}",
  "lifecycle.deleted": "Deleted {{relative}}",
  "lifecycle.purge": "Automatically deleted {{relative}}",
  "lifecycle.loaded_one": "{{loaded}} / {{count}} record",
  "lifecycle.loaded_other": "{{loaded}} / {{count}} records",
  "lifecycle.in_hours_one": "in {{count}} hour",
  "lifecycle.in_hours_other": "in {{count}} hours",
  "lifecycle.in_days_one": "in {{count}} day",
  "lifecycle.in_days_other": "in {{count}} days",
  "settings.token_description": "For external clients and personal automations that use the Exognitos API. A key is displayed only once; the server stores only its hash.",
  "settings.token_example": "Personal automation",
  "copy.5f7a7234cadc": "{{value1}} · existing time retained.",
  "copy.37ef45dfecb9": " · {{value1}} planned",
  "copy.3af257399a40": "{{value1}} planned",
  "copy.463f6b36181b": "{{value1}} over",
  "copy.d465c2470b9b": "{{value1}} under",
  "copy.1129e6f195d9": "exactly on plan",
  "copy.8056fa473913": "{{value1}} — its purpose and flexibility",
  "copy.8bd64f0953c4": "no key",
  "copy.e27b15bdd6b4": " · Primary",
  "copy.1d2171dfa528": "No icon",
  "copy.ee788f265d93": "{{value1}} · Layer {{value2}}",
  "copy.ffc83b12853f": "Not set",
  "copy.8fd6cbabf5c7": "Not specified",
  "copy.0ada951030d2": "Point",
  "capacity.no_protected_time": "No protected time is defined for {{date}}.",
  "graph.moveLeft": "Move left",
  "graph.moveRight": "Move right",
  "graph.moveUp": "Move up",
  "graph.moveDown": "Move down",
  "graph.positionControls": "Move selected item",
  "common.done": "Done",
  "calendar.starts_at": "Starts at {{time}}",
  "copy.0ed1d2d09021": "Saved",
  "copy.4a758db5ca03": "Application Preferences",
  "copy.6659fe1e3d47": "Organise your applications, pages and sections connected to your existing data.",
  "copy.a8d781429ae5": "These preferences are stored for future clients; they do not change your records or this application's appearance.",
  "copy.43d6dcf757ac": "Preferences saved.",
  "copy.3bb53e9680a2": "Configuration version",
  "copy.688beea357c1": "Unsaved changes",
  "copy.0c2c51e4661f": "Save Preferences",
  "copy.fc5c50ef318d": "Loaded the server version.",
  "copy.a50a4d15fe6e": "Discard Draft and Load Latest Version",
  "copy.99b3483f6523": "Your edits remain on this screen. Load the latest version to review changes saved elsewhere.",
  "copy.856bc41534c9": "Applications",
  "copy.5f31a25fcaf7": "Add Application",
  "copy.9eb7f9f64a25": "Untitled application",
  "copy.44e12f10ded1": "Define your first application",
  "copy.822c3a81d828": "Each application has its own theme, navigation and pages.",
  "copy.28eb7fffb49b": "Application Settings",
  "copy.e084b5eea7a9": "Remove Application",
  "copy.2853b96ba748": "Application title",
  "copy.45eeba145e0d": "Application icon",
  "copy.96f7afcd5c27": "For example: layout, book or calendar.",
  "copy.a5461f4c0529": "Inherit from system",
  "copy.28cf21da3f15": "Navigation",
  "copy.0c5f3b1bd7a8": "Tabs",
  "copy.5c79a1eab176": "Sidebar",
  "copy.a5dcca48cc57": "Application order",
  "copy.e4fe8d0e28b4": "Pages",
  "copy.7b2663103076": "Add Page",
  "copy.5d06b118097b": "Untitled page",
  "copy.5106bdff196a": "Create a page to add sections.",
  "copy.5a53946315f9": "Page title",
  "copy.7b4d62143b9e": "Page icon",
  "copy.e642a7b048b0": "Page order",
  "copy.7cd9551f12bb": "Add Section",
  "copy.83c3c3ffb201": "Remove Page",
  "copy.87aff7711fbd": "Chart",
  "copy.2e0e960ab320": "Form",
  "copy.27cfdaca01d9": "New section title",
  "copy.db5146cb3e89": "Section type",
  "copy.bf9c6aa8ddb6": "Add Section",
  "copy.3204886cf413": "Remove Section",
  "copy.58b36ae862b2": "Section title",
  "copy.055e31886669": "Section order",
  "copy.722321b13e12": "The connection is retained if its source is unavailable. You can choose to change or remove it.",
  "copy.772ee7942483": "Add field preference",
  "copy.fa1d29624e38": "Select field",
  "copy.e124590b234d": "Field title",
  "copy.2f9e6238fbcd": "Field order",
  "copy.6f91491cdecd": "Field width",
  "copy.6fae3b65e2fd": "Narrow",
  "copy.55d67233d4f2": "Wide",
  "copy.d790f77977be": "Field visible",
  "copy.0dd8979879a6": "Remove Field Preference",
  "copy.f0871d080fa8": "Unavailable connection · {{value1}}",
  "copy.8307feac4930": "Source Life area",
  "copy.5ac4d3202695": "Source table",
  "copy.78dfebdbad89": "Select table",
  "copy.f9351deabcef": "Section data source",
  "copy.e6b81cb9ab09": "Metric",
  "copy.a70227f2b004": "select",
  "copy.ca875b810113": "Could not load sources. The existing connection is retained.",
  "copy.9a52b79184fb": "New application",
  "copy.28042b224c01": "New page",
  "copy.7ccfa7dc3a8b": "The configuration exceeds the 32 KiB limit.",
  "copy.2d36b3af02e3": "An application title is required.",
  "copy.ba7a621542ac": "A page title is required.",
  "copy.fd34e632182a": "Page IDs must be unique.",
  "copy.179d1617ca60": "Choose a section title and data source.",
  "copy.09352c277bc0": "Section IDs must be unique.",
  "copy.67d62e0cf37c": "You can save up to 100 distinct source connections.",
  "copy.1f85b0be8bfb": "Cycling",
  "copy.f96f0d389edb": "Track rides with their actual start and finish times.",
  "copy.705478b22b47": "Ride",
  "copy.96adcb9014db": "Loading rides…",
  "copy.fe7117237b93": "Could not load ride status.",
  "copy.b42bc8f68e62": "Record the time when you start. Enter the distance when you finish.",
  "copy.3d4346eaa5f8": "Start Ride",
  "copy.c645f5cc33cf": "Ride History",
  "copy.bf31b9eebeb3": "In Progress",
  "copy.1539053a4448": "km ·",
  "copy.733c2ee7d8e1": "Duration unknown",
  "copy.a99857a976ec": "{{value1}} minutes",
  "copy.583e845fb2b9": "No rides yet",
  "copy.bb848390ff47": "Your first ride will appear here when you start it.",
  "copy.e8b9af762b47": "More Rides",
  "copy.6605b4fc99c1": "Started:",
  "copy.2be1cc81940d": "Distance travelled (km)",
  "copy.d07d8cb7a13f": "Ride note",
  "copy.3849fa116307": "Finish Ride",
  "copy.a2fb4a244d23": "Cancel Ride",
  "copy.c1d7321c99af": "My weekly cycling goal",
  "copy.0900d63069c3": "Weekly Distance Goal",
  "copy.51e4f1661693": "Goal name",
  "copy.f4bec7617fa3": "Weekly distance (km)",
  "copy.23c4811424e0": "Prepare a notification rule for reaching the goal",
  "copy.e91a7e3e77e2": "The rule is created as a draft. Review its condition and permissions before activating it.",
  "copy.2cb542d1c5e8": "Create Goal",
  "copy.5ad83ee1934c": "Goal and distance metric created.",
  "copy.fe6635052630": " The notification rule is awaiting activation.",
  "copy.8d4d1ebe70cb": "Device Tracking",
  "copy.418e405cc78f": "Usage summaries from connected sources and details you have explicitly authorised.",
  "copy.d972535b7dfd": "Sources",
  "copy.917c4296a86b": "Source name",
  "copy.38794d3950b0": "For example, your phone or desktop computer.",
  "copy.5d98ea8091dc": "Connect Source",
  "copy.12f45de44b90": "connection details",
  "copy.bb4778423f88": "This key is shown only now. Add it to the connection settings in your source application.",
  "copy.3ca6ac67a497": "Source key",
  "copy.2f926e1823f1": "Source ID",
  "copy.9ce9962b8f3a": "Summary submission URL",
  "copy.23bae416da8c": "Submissions also require an authenticated session or access credential for your account.",
  "copy.e4e61b2226e3": "I Saved the Details",
  "copy.d69f95702ca8": "No connected sources yet",
  "copy.0b6dfe21167b": "Connecting a source does not start automatic collection. Summaries come from the application you connect.",
  "copy.9b81681880bd": "More Sources",
  "copy.0a135e8ffef7": "Source revoked",
  "copy.499bf7692c68": "Last report: {{value1}}",
  "copy.a445342a6684": "Awaiting the first report",
  "copy.e285643805c5": "Raw Records",
  "copy.690417ea5fc6": "Usage summaries contain application names and durations. The following details require separate permission and are retained for up to 7 days.",
  "copy.97e0ab438911": "Accept full web addresses",
  "copy.9f5ba294e9a9": "URLs of visited pages.",
  "copy.ef01003113c6": "Accept location data",
  "copy.7671c675d53f": "Coordinates and accuracy information, if available.",
  "copy.18a5fc1c6918": "Accept sensor measurements",
  "copy.a847672fc372": "Measurement name, value and unit.",
  "copy.2a4442e7766b": "Save Permissions",
  "copy.0a91e47db9f7": "Revoke Source",
  "copy.27d86f3453a6": "Application Usage Summaries",
  "copy.53a81625aa1e": "Could not load summaries.",
  "copy.21e5fcde743a": "Application summary",
  "copy.9494ff896e95": "minutes",
  "copy.ceed4effcbad": "No usage summaries received yet",
  "copy.a74a2416ab5f": "Reports appear here when a connected source sends an application name, date and duration.",
  "copy.478d989276b0": "More Summaries",
  "copy.2e8f0cd5002a": "{{value1}} · Last 7 Days",
  "copy.aa9df4372465": "· Retained until:",
  "copy.edd6b90b35fc": "No stored raw records",
  "copy.747a5170f6ad": "More Records",
  "copy.ed1636e9edb4": "Open metrics and rules in the Life table",
  "copy.0086705bf008": "Could not load extension status.",
  "copy.6efdba1e3b49": "Extension paused",
  "copy.f6ebaf5fe861": "Extension unavailable on this server",
  "copy.1e5a48393cf5": "Start by installing the extension",
  "copy.0abbccd05656": "Manage installation and data connections on the Extensions page.",
  "copy.667cf9262cd4": "Go to Extensions",
  "copy.5d0ff2924cf9": "The operation could not be completed. Your information is retained; you can try again.",
  "copy.10f2b815b3e8": "Read connected Life records",
  "copy.7ecad28739c2": "Add Life record",
  "copy.3386c3f4990d": "Update connected Life records",
  "copy.037a80749a2c": "Create metric",
  "copy.bea39ec71bc6": "Create note",
  "copy.9ca03fe880be": "Create task",
  "copy.8e8e0e19a97f": "Create automation rule",
  "copy.98dc109ccd4f": "Manage device sources",
  "copy.29c548ae35f9": "Manage application preferences",
  "copy.639aef43290a": "Read friendships and shares",
  "copy.331a5174ee15": "Manage friendships and shares",
  "copy.2c8d8cd444eb": "Extensions",
  "copy.8c7c945d91c8": "Choose the tools you need; keep your Life tables and records in their own areas.",
  "copy.b28ee640545f": "Could not load extensions.",
  "copy.b3e770b31603": "Version {{value1}} · ",
  "copy.e046fde19b35": "Unavailable on this server",
  "copy.52359bff7a01": "Not installed",
  "copy.fcb56964b290": "Manage the installation when the package becomes available again.",
  "copy.75ed829a8997": "Prepare Installation",
  "copy.0ac834fe8fb1": "{{value1}} installation",
  "copy.9818e2a138ff": "Installation version",
  "copy.9d43a2409cfb": "· Configuration",
  "copy.1b1c77b22442": "The extension's permission to run will be revoked. Your Life tables, records and independent notes will be retained.",
  "copy.36428c193647": "Remove Extension",
  "copy.83d9740654be": "Granted permissions",
  "copy.323bb127f585": "Data connections",
  "copy.935b502585dc": "→ Life table",
  "copy.25b1fe3f0719": " · {{value1}}",
  "copy.60ff93f4c166": " · Required connection",
  "copy.e7e4e49676d4": "This extension does not require a Life table connection.",
  "copy.ccf19139a978": "Package unavailable",
  "copy.5b1528d7eaef": "Access your existing Life data through Life Areas.",
  "copy.6fe37c3bdfe3": "Create a new area for each connection or explicitly select your own table and columns. Preview the structure before installing.",
  "copy.d92b326973e4": "Permissions to grant",
  "copy.21c83a3764e1": "Preview Installation",
  "copy.aa18ef3838f0": "Installation preview",
  "copy.9d7072cd5d3f": "New area: {{value1}}",
  "copy.6789aeb3d8e8": "Will connect to the selected Life table",
  "copy.811c45f9d941": " · Required",
  "copy.7aad969cd5cd": "View:",
  "copy.1496e196745c": "Metrics:",
  "copy.a1eb87a8ee12": "Rules:",
  "copy.faed1c91a9cf": "Install This Configuration",
  "copy.369b830913df": "Data area",
  "copy.358adcf132f1": "Create a new Life area",
  "copy.d73ccb3bcbd6": "Connect to an existing table",
  "copy.1d2e0afe73eb": "New area name",
  "copy.cb5b6f8ecbf3": "Select area…",
  "copy.b6ea434ba347": "Select table…",
  "copy.ae6ed6c2b574": "{{value1}}{{value2}}",
  "copy.87e58e822bce": " (required connection)",
  "copy.951eb471ccab": "Select column…",
  "copy.34a46bf73ec9": "Music profile",
  "copy.e9007ad9184a": "Display name",
  "copy.a36362d47352": "Experience",
  "copy.b57b778343eb": "Just starting",
  "copy.1c84c913b43a": "Learning",
  "copy.30cdff931539": "Experienced",
  "copy.2c7ae4aaa2ca": "Interests",
  "copy.a6af5a04d4b5": "Separate entries with commas.",
  "copy.6325dea6c244": "Save Profile",
  "copy.fd3b91f48bcf": "Music",
  "copy.e15ab1b0024c": "Lessons",
  "copy.ac84369bcfc5": "Social",
  "copy.9b021253b62b": "API Keys for Automation",
  "copy.c992cca4bbe8": "Choose only the permissions your scripts and automations need. Mobile applications use user-approved OAuth and PKCE.",
  "copy.14ebc8f336bc": "Key created. Your selected permissions and validity period appear below.",
  "copy.4826a4d6d841": "Weekly task report",
  "copy.1b61c02832b4": "Validity period",
  "copy.c17be279a432": "7 days",
  "copy.7f6561d2dcc3": "30 days",
  "copy.cefd7e103aef": "90 days",
  "copy.92e13c747aca": "1 year",
  "copy.a60cc5698432": "Set number of days",
  "copy.b5494a373a33": "Validity (days)",
  "copy.1e0e5b7693f5": "Enter a whole number of days from 1 to 3650.",
  "copy.f57dfa8706e1": "Permissions ·",
  "copy.4d67b1a83350": "selected",
  "copy.99f091d467cd": "Read, write and permanent deletion are separate permissions. None are selected automatically.",
  "copy.1cec1d05e0a4": "Could not load permissions",
  "copy.9bc1d2827060": "Sensitive data access",
  "copy.67b7baabf5bc": "The operation could not be completed. Your selections are retained; you can try again.",
  "copy.5adf087a5d38": "Create Key",
  "copy.50c68b000177": "This key is shown only now. Store it in your automation's secure credential store.",
  "copy.2c9b3940a44a": "New API key",
  "copy.b64f22a34976": "Key copied.",
  "copy.2639a19c47c0": "Automatic copying is unavailable; select the key to copy it.",
  "copy.f3a3ab8b7554": "Key display closed.",
  "copy.6e76d65010a3": "Hide Key",
  "copy.abe5087cfa97": "Last used {{value1}}",
  "copy.75c85fb1b572": "Never used",
  "copy.6cf114b274f2": "Revoke the “{{value1}}” key?",
  "copy.2e766eb55fc9": "Automations using this key will lose access immediately.",
  "copy.b2e46ff48b43": "Revoke Key",
  "copy.ca7577d56ebc": "{{value1}}: {{value2}}",
  "copy.45bdb76025c4": "Expired",
  "copy.e730651f6ff6": "Expires",
  "copy.f71518fbed39": "Legacy key without expiry",
  "copy.0aa789557e43": "Full account access — legacy key without scope restrictions",
  "copy.dbd3b3d5eec7": "Track lesson sessions, accepted transcripts and assignments together.",
  "copy.b7f3cb802463": "Back to Lesson Sessions",
  "copy.ec893839bbfd": "Manage Lessons",
  "copy.3abe87489ce4": "Could not load lessons.",
  "copy.9b6625ca3c1a": "Record Lesson Session",
  "copy.136935360f24": "Lesson",
  "copy.7b5cbd5295e7": "Select lesson",
  "copy.64d30660d82b": "Session topic",
  "copy.95461782840f": "Accepted text / transcript",
  "copy.a6cf41d5fbc2": "Saving creates this text as an independent Memory Note.",
  "copy.031af18cbbf7": "Enable the Note permission in the installation to create notes.",
  "copy.d5b31d35f977": "Assignments",
  "copy.0d20cc37cf49": "Each line creates one task. You can add up to 20 tasks.",
  "copy.55ad188fd85d": "Add up to 20 tasks.",
  "copy.3412f27fc553": "1 Note",
  "copy.1d482808af49": "No note will be added",
  "copy.c5802f9a400f": "tasks will be created",
  "copy.8a05a67d8c44": "Save Session",
  "copy.214618a6447d": "Add First Lesson",
  "copy.de29d8cc5255": "Lesson History",
  "copy.34bdb1f6aa69": "Could not load lesson history.",
  "copy.fa7b378b0145": "Lesson record",
  "copy.22d5d99695b5": "Lesson Note",
  "copy.caed731365a4": "Assignment",
  "copy.c1804d0700fc": "No lesson sessions yet",
  "copy.caf99cf67701": "More Sessions",
  "copy.93945bcbe03a": "More Lessons",
  "copy.6a042122c9b5": "Your Lessons",
  "copy.220b6079b8bf": "Lesson name",
  "copy.60ae12bd8819": "Lesson description",
  "copy.f6cd5f1d9b36": "Add Lesson",
  "copy.a82b78619a75": "Add to notification inbox",
  "copy.5af333aa331b": "Create Life record",
  "copy.c1ef3d9b851a": "Update a specific Life record",
  "copy.5a5ac0e40ef6": "Create text note",
  "copy.9edbc70310ee": "Action to perform",
  "copy.64cd2520f628": "Target Life area",
  "copy.5e0c55ccadef": "Target table",
  "copy.cad5b8c7192f": "Connected table ·",
  "copy.6b2bf84ef3f5": "UUID of the record to update",
  "copy.eb344064f7e5": "The fixed values you enter here will be used. Preview validates them against the current table definition.",
  "copy.bc9e28d56fd2": "Could not open the target table.",
  "copy.674b96f88f1c": "Content",
  "copy.2dae389a126e": "Also send this notification to connected devices",
  "copy.446d8455cad1": "The notification is always saved to the inbox. External delivery requires an active notification subscription.",
  "copy.505845aefef7": "Start instant",
  "copy.d8193729233a": "End instant",
  "copy.f58ce3124b7e": "Occurrence instant",
  "copy.e84ac40c7b97": "2026-09-05T10:00:00+03:00",
  "copy.b80bca0f8cfc": "Full date and time including the time zone offset.",
  "copy.b78b92cac81b": "Equal",
  "copy.5ee26309ac48": "Not equal",
  "copy.8e11577c8ad8": "Greater than",
  "copy.29150002bc1b": "Greater than or equal",
  "copy.2369172f664e": "Less than",
  "copy.69ba5abe07fe": "Less than or equal",
  "copy.6bf936ffe8c6": "Condition",
  "copy.3ae15d8ae058": "Subcondition · level {{value1}}",
  "copy.c036f1855d16": "Condition type",
  "copy.91d386bb210c": "Compare two values",
  "copy.e562b1bb7e41": "All true (AND)",
  "copy.c31d80fdd2ab": "At least one true (OR)",
  "copy.7bc104cccc02": "Inverse (NOT)",
  "copy.6a1a25093722": "Left value",
  "copy.3de740d7f47c": "Comparison",
  "copy.d408fcb27258": "Right value",
  "copy.963ec26bec36": "Remove subcondition {{value1}}",
  "copy.94f5ea5a3be5": "Add subcondition",
  "copy.81c70eab8f54": "{{value1}} source",
  "copy.3e50031b3919": "Fixed number",
  "copy.6c5c281c636e": "Metric result",
  "copy.27efeed1f6e1": "Personal parameter",
  "copy.bd61590cb01a": "An empty value means unknown. It is not treated as zero.",
  "copy.acf847765a5c": "Select metric",
  "copy.efddcbb1d387": "Select parameter",
  "copy.d2988c56e56e": "Connected source ·",
  "copy.064b47456f4c": "Could not load sources.",
  "copy.7568a87aa273": "The operation could not be completed. Check the details and try again.",
  "copy.54a1ffa89e8b": "Creation",
  "copy.49ef9aa594d6": "Update",
  "copy.f083ca59254a": "Archiving",
  "copy.6fc44ff00346": "Restoration",
  "copy.73640dd07f8f": "Edit rule",
  "copy.5beefee35741": "Create rule draft",
  "copy.9f61b3143665": "Save and review draft",
  "copy.ff16e0956bbc": "Rule name",
  "copy.e8b55c4a6440": "Changes pause the active rule. Review and reactivate the new draft.",
  "copy.df9f6afd1768": "When should it be evaluated?",
  "copy.dbffd0d5f991": "When records in this table change",
  "copy.7cfe6753dbb3": "At regular intervals",
  "copy.a1862de3c67f": "When run manually",
  "copy.32c9f037a092": "Evaluation interval (minutes)",
  "copy.21513bd8a354": "/32 conditions. Missing values make the result unknown and do not trigger actions.",
  "copy.5d27ccf49443": "When the condition is met",
  "copy.9ca611f7b87e": "Only when it first becomes true",
  "copy.ff0d043a7f84": "At every evaluation where it is true",
  "copy.ccf543146995": "Minimum seconds between actions",
  "copy.7a679fdd8b9c": "Actions when the condition is true",
  "copy.95baf5e2c127": "Remove action {{value1}}",
  "copy.6c4c014c0b88": "Add action",
  "copy.e9af5e757542": "Source unavailable",
  "copy.793e99d63039": "Rule actions",
  "copy.90aeae7ab952": "Create rule",
  "copy.da948d8a9364": "Show all my personal rules",
  "copy.e19620ee82f2": "Rules are saved as drafts first. Review the actions and required permissions before activation.",
  "copy.e6653ad658f0": "Could not load rules",
  "copy.4ba1e9696011": "No rules yet",
  "copy.7f538a0793a7": "Compare a metric with your goal and define a personal notification or record action.",
  "copy.5be328049bdb": "Create your first rule",
  "copy.af6ccd214f24": "Record change",
  "copy.918567637ef5": "Every {{value1}} minutes",
  "copy.2046bd8bde18": "Manual run",
  "copy.d6f18add81d9": "Edit {{value1}}",
  "copy.2f13ac074c7d": "{{value1}} run history",
  "copy.546ba7afcb8f": "Archive {{value1}}",
  "copy.d8a7bae75ccb": "Evaluate now",
  "copy.3c55dab34b65": "Preview and activate",
  "copy.fba220891e80": "Last run:",
  "copy.80b606aa2888": "Next 10 rules",
  "copy.64aa5a127dfe": "Evaluation queued. Follow the result in the rule's run history.",
  "copy.b1083eb54ddf": "Review and activate rule",
  "copy.d7dbb07cdde5": "Authorise and activate",
  "copy.4828c199d392": "Preview current state",
  "copy.7285152e54fc": "The condition is currently:",
  "copy.1c5b653893e8": "Unknown",
  "copy.8cae5ab460c1": "True",
  "copy.9520c878eaac": "False",
  "copy.83c3d10a3638": ". Preview does not execute actions.",
  "copy.0227d3052adf": "Target table:",
  "copy.22e129ecb19a": " · Record: {{value1}}",
  "copy.2b130af50743": "Values to write",
  "copy.d8e1ce802374": "Empty",
  "copy.f2887fd2471d": "External notification delivery to connected devices is requested.",
  "copy.efcb6e0b7db9": "Required permissions",
  "copy.0aa77f135c5b": "I authorise this rule to perform the actions above in the background with these permissions.",
  "copy.ea56a32dc22e": "Pausing the rule revokes authorisation. Changing its definition requires a new review and authorisation.",
  "copy.a2087f6f574b": "Activation requires a current preview.",
  "copy.a94ad4193279": "{{value1}} · Run history",
  "copy.7ab98b0a27d0": "No runs yet.",
  "copy.f0873175a881": "Failed",
  "copy.cd660348fb64": "No action taken",
  "copy.84b523fa6286": "action receipts",
  "copy.1381d8087b77": "Latest 30 runs. Refreshes every 15 seconds while this screen is open.",
  "copy.8161663dd432": "Execution authorisation was revoked. Review and authorise the rule again.",
  "copy.d304325b47a6": "A record or metric used in the condition is no longer available.",
  "copy.bf38537161c3": "Check the metric, parameter and units in the condition.",
  "copy.837a6342b6ed": "Check the action target and current field definitions.",
  "copy.878a5cd5651e": "The action could not be completed; no partial changes were saved.",
  "copy.f02667770bbd": "The rule could not be evaluated. Review its condition and permissions.",
  "copy.69b4a13f3c97": "Target source",
  "copy.858e6e74d13f": "Named parameter",
  "copy.f866486b9fc5": "Specific Life record",
  "copy.5d4e16126dfe": "Parameter",
  "copy.9b97e83c0c57": "unitless",
  "copy.32a3a3a8afc3": "Connected parameter ·",
  "copy.0f2dc78ad026": "Record UUID",
  "copy.69437c7daba7": "The permanent identifier of a specific record in this table.",
  "copy.84f304ae4c07": "Target value field",
  "copy.77dd0edafbb7": "Edit metric",
  "copy.517fd966cd3d": "Save metric",
  "copy.9e33b457f0b9": "Metric name",
  "copy.b0bad6a5ddee": "For example: Total expenses this month",
  "copy.e5711c7874c8": "Calculation",
  "copy.0c9788eb412a": "Value field",
  "copy.ffedbbbf7a18": "Unit:",
  "copy.7251ac3be22a": "Unitless",
  "copy.3280406063df": ". Different units are not converted automatically.",
  "copy.2d4d2412bc85": "All time",
  "copy.6da72c631645": "Calendar day",
  "copy.5c74c2b567c5": "Calendar week",
  "copy.e18c37057ae0": "Calendar month",
  "copy.339ebfc38349": "Rolling hourly window",
  "copy.6c14b2c85f0b": "Number of hours",
  "copy.29fcb1a7c513": "Previous window offset",
  "copy.41e21ccf8efa": "0 means this window; 1 means the previous window.",
  "copy.abda4de2f16c": "Group by period",
  "copy.219c8cd71833": "Single value",
  "copy.abc3e615d675": "Weekly",
  "copy.e055e06d7581": "Monthly",
  "copy.c4d256aeb821": "Ratio denominator",
  "copy.7edb93959c4c": "Record filters",
  "copy.38c7ee983495": "Filter {{value1}} field",
  "copy.2021b8cf444a": "Has a value",
  "copy.4cfa2b03d54b": "Value",
  "copy.7f8cc282d6fa": "Remove filter {{value1}}",
  "copy.7ed953e0d2cc": "Add filter",
  "copy.4a3a2fbba2ac": "Preview calculation",
  "copy.a6b34e5c8b31": "Preview the current result before saving.",
  "copy.ecf9288e8869": "values ·",
  "copy.017db41e7cab": "missing ·",
  "copy.3d0d0d9d5db9": " · {{value1}} records use a different unit",
  "copy.2f043780332e": "Metric by period. Exact values are in the table below.",
  "copy.4b5eb7dd702a": "Exact values · {{value1}} periods{{value2}}",
  "copy.e3ac94324068": " · first 100 periods",
  "copy.71ce76802c3f": "Exact metric values by period",
  "copy.97b04c9ea0bc": "Metric actions",
  "copy.8e00a424a181": "· Live calculations",
  "copy.434b7895c486": "Could not load metrics",
  "copy.4df981e50c45": "No metrics for this table",
  "copy.1a3c24f23aaf": "Define a total, average, difference or ratio from your own records. Your records stay where they are.",
  "copy.100bbf4569d8": "Create your first metric",
  "copy.8bea6c5a8b26": "Next 10 metrics",
  "copy.3f625500d504": "Personal displays",
  "copy.9e0ea1a034a2": "Your saved number, chart and budget views.",
  "copy.c7ee250906e5": "Add display",
  "copy.28de1833cf55": "Could not load displays",
  "copy.4279d5e9593b": "No saved displays yet.",
  "copy.493d6f1b003a": "Edit {{value1}} view",
  "copy.5e7e7b0bddca": "Archive {{value1}} view",
  "copy.851a5e85dfa7": "More displays",
  "copy.445ba7390098": "Personal parameters",
  "copy.77e80ba20a60": "Values you set manually, such as budgets and goals. An empty value differs from zero.",
  "copy.fc96b4177021": "Could not load parameters",
  "copy.fd6852601b2c": "Edit {{value1}} parameter",
  "copy.63bb756623a8": "Archive {{value1}} parameter",
  "copy.ae5c659e2bcb": "No parameters added yet.",
  "copy.c7ea4006b6c0": "Could not calculate the result",
  "copy.052fb79017ec": "Could not calculate the display",
  "copy.8e793367275a": "Goal:",
  "copy.54f52cea860b": "{{value1}} goal ratio",
  "copy.5d370119c989": "The goal ratio cannot be calculated.",
  "copy.3cbaf83e32b5": "Edit parameter",
  "copy.df7d69d55f54": "Create parameter",
  "copy.dbf69d0e78ca": "Save parameter",
  "copy.edbeaeec1c98": "Leave this empty if you have not decided yet.",
  "copy.ef0128065b4d": "Unit",
  "copy.7fee1ba34326": "For example: km",
  "copy.0e5fdb87c713": "For example: TRY",
  "copy.7b0cb1b9bf1d": "Edit display",
  "copy.555145c29f85": "Save display",
  "copy.5fe96d8de190": "Metric calculation",
  "copy.c3a9ace8b58a": "Previous connection ·",
  "copy.a456e7e1d8ea": "Display format",
  "copy.b371799342cd": "Number",
  "copy.7875a41964bd": "Line chart",
  "copy.4b7c0c945fc4": "Bar chart",
  "copy.db1699cd5eae": "Budget / goal",
  "copy.59412766be52": "Group the metric into daily, weekly or monthly periods to display a chart.",
  "copy.20a487a93c7b": "Record count",
  "copy.47589f98e0c2": "Minimum",
  "copy.eba58f447104": "Maximum",
  "copy.da86d4567881": "Latest value",
  "copy.7cbb69c268be": "Difference between last two values",
  "copy.94ee9687ccdd": "Current",
  "copy.73a971055c89": "No value yet",
  "copy.01bb3fbfd910": "Unit or currency has changed",
  "copy.414af0c2e405": "Denominator is zero",
  "copy.3f343590a0f8": "First version",
  "copy.1060cd601e71": "Record history",
  "copy.1ce69d3fa7bd": "Close history",
  "copy.2867f3bf2289": "Show previous versions",
  "copy.baf843d557ef": "Previous values retain their field definitions, units and times from that version.",
  "copy.54f73814cd51": "Could not load record history",
  "copy.5f54997110a2": "Record version",
  "copy.721f5ae1e295": "· Table v",
  "copy.a5fd3322a923": "Review restoration",
  "copy.7aa5f8e5da31": "Values and provenance for this version",
  "copy.e3f04aa2f2ee": "No previous versions for this record.",
  "copy.29781104c3ca": "Previous 10 versions",
  "copy.16c790a6c5f3": "Restore previous version",
  "copy.9dc488748585": "Record version {{value1}} → current table v{{value2}}",
  "copy.539a77efb00b": "Restore reviewed values",
  "copy.76d1e37c64f1": "This creates a new record version. The values below are validated against current field definitions; historical versions are retained.",
  "copy.63fc67871798": "fields have changed type, unit or currency. Old numbers were not carried over; enter values with their current meaning or deliberately leave them empty.",
  "copy.e384fa7c7685": "Times to restore",
  "copy.5f4b6a76f178": "YYYY-MM-DD",
  "copy.7f09eb76a7bd": "I reviewed the values and times using the current field meanings.",
  "copy.22345147d3aa": "Restoration could not be completed. Your values are retained; you can try again.",
  "copy.beb634051c8c": "Your practice, repertoire and personal goals.",
  "copy.63707abb877b": "Music sections",
  "copy.dd20c603d44a": "Practice",
  "copy.3f91b8da2708": "Instruments",
  "copy.27434a3a59ca": "Could not load instruments.",
  "copy.8c0667f80052": "More Instruments",
  "copy.e60b18bba3fa": "Instrument",
  "copy.4ce77ca1e717": "Select instrument",
  "copy.9b04278da509": "Record Practice",
  "copy.ca305a452df4": "Practice duration (minutes)",
  "copy.1a62f3a5ff78": "Reflection",
  "copy.e0b2187c0b19": "Optionally describe what went well and your next practice session.",
  "copy.2f4860940db1": "Save Practice",
  "copy.6438f59868e2": "Practice History",
  "copy.b6812043caaf": "Instrument practice",
  "copy.546781372686": "min ·",
  "copy.e3e928cd8b91": "No practice records yet",
  "copy.50365c8b1c0f": "More Practice",
  "copy.c102ca35eb71": "Your Instruments",
  "copy.1074b7d3aa15": "Instrument name",
  "copy.e63281af03ef": "Type / family",
  "copy.4e216a6ccd18": "Add Instrument",
  "copy.eb05313bf373": " · Archived",
  "copy.64fd89d84c4c": "Add your first instrument",
  "copy.2b7636165517": "Practice and repertoire will be connected to this instrument.",
  "copy.03e58df3a6e7": "Planned",
  "copy.ba8b861a7e92": "In practice",
  "copy.781abed95a2b": "Repertoire",
  "copy.a43cae108a0a": "Piece",
  "copy.c4c3cefeabdf": "Composer",
  "copy.7896c7265ffa": "Add Piece",
  "copy.e94bb018d8a0": "More Pieces",
  "copy.c0fdc01c14d5": "Weekly Goals",
  "copy.c805a1d6a98b": "Weekly goal (minutes)",
  "copy.b40e3e2e5d3c": "Also create a daily 30-minute practice routine",
  "copy.b29371d18de9": "More Goals",
  "copy.1dd6ed9afc67": "{{value1}} / {{value2}} minutes",
  "copy.f503634d3ef8": "Goal: {{value1}} minutes · Measurement currently unavailable",
  "copy.c90f6e1ceab2": "Practice Routines",
  "copy.e2cd081b30a2": "Music Profile",
  "copy.d9a085bab7e5": "Profile name",
  "copy.ddf7b36c1e27": "Just starting",
  "copy.bea8b751adee": "Separate entries with commas.",
  "copy.7c3579be0c4d": "Notification inbox",
  "copy.f64afd4e37dc": "Persistent notifications from your rules and personal actions.",
  "copy.2f0e888986dc": "No notification access",
  "copy.44b49b676d25": "This session does not have permission to read notifications.",
  "copy.927eaa66f42c": "Unread notifications only",
  "copy.304124a5b190": "Could not load notifications",
  "copy.46eafa26b692": "No unread notifications",
  "copy.4a29ba463779": "The notification inbox is empty",
  "copy.78875f7bbc13": "Notifications generated by rules appear here.",
  "copy.ca8965684f72": "Mark as read",
  "copy.c162125b89a8": "Read",
  "copy.54e696c573c2": "This view shows the latest 100 notifications.",
  "copy.029f2d8c3a68": "Could not update the notification.",
  "copy.5cb4a7c44d22": "Friend",
  "copy.65ebed86a586": "Select friend",
  "copy.2226db5278b0": "Select {{value1}}",
  "copy.329d4b483ecc": "Select record",
  "copy.01414d69e4db": "Untitled record",
  "copy.810aa07099e6": "Selected record",
  "copy.33243111d4e6": "Create Live Share",
  "copy.8b4578a65b94": "You retain the source. Selected fields are shared in their current state until access ends.",
  "copy.34e4475ca31b": "Live share created.",
  "copy.e0ef8264cc9f": "Type to share",
  "copy.e14ef28e6b51": "Sharing scope",
  "copy.d172963b8c03": "One record",
  "copy.6e4749c7632c": "Selected records",
  "copy.649dbcd38c47": "One table",
  "copy.6a634a619f03": "One Life area",
  "copy.5786dca239b5": "Visible fields",
  "copy.cc64312788d5": "Allow editing of the selected fields",
  "copy.d47fb074c3b5": "Also show record dates and times",
  "copy.9a2a6a1d5448": "Also share records created in the future",
  "copy.05bc45cfb40e": "Also allow results calculated from my private data to be written to this share",
  "copy.53c00d95d282": "sources ·",
  "copy.a0aa70146433": "visible fields ·",
  "copy.459743052b3f": "View and edit",
  "copy.06f510148a5a": "View only",
  "copy.6fff1249112c": ". You can revoke access at any time.",
  "copy.e901677380a2": "Share Selected Fields",
  "copy.e151b3eba900": "Table and fields",
  "copy.5c0cdd57ae69": "Select a table to choose published fields.",
  "copy.a6bae99be6a1": "Could not load sources. Select the area or table again.",
  "copy.c64e213dadaf": "Shares",
  "copy.2c6f2721b83b": "Shared with Me",
  "copy.fbe321d799e3": "Shared by Me",
  "copy.f82639d3e1ef": "Could not load shares, or access has changed.",
  "copy.10e9dc59c4b1": "No shares in this list",
  "copy.2cd1c2657961": "Access revoked",
  "copy.cad7966fb650": "{{value1}} visible fields · {{value2}}",
  "copy.267bd110ff42": "Editable",
  "copy.ec6eb0960edf": "View",
  "copy.4b808287d627": "Revoke Access",
  "copy.21ae9a0a2082": "This share has",
  "copy.5b5d67171211": "selected fields. Fields:",
  "copy.e0acb4d14692": "New records are included.",
  "copy.7328030d8a94": "New records are not added automatically.",
  "copy.4460e10d21af": "You separately authorised outputs calculated from private data.",
  "copy.d1addec0cc28": "Outputs calculated from private data are not authorised.",
  "copy.eb04e999aa74": "Select a share to inspect it.",
  "copy.79efbbcfbb65": "More Shares",
  "copy.eec5f80ad665": "This share is no longer available. Hidden fields are not shown.",
  "copy.7d560bdc3279": "No visible records",
  "copy.59d91b0a1e93": "More Shared Records",
  "copy.69a6fed4edb2": "Load Current Record",
  "copy.90970be0fae5": "Shared Life Record",
  "copy.aa20a4eac88d": "Your change was saved · version {{value1}}",
  "copy.ec4224650e2a": " ({{value1}})",
  "copy.8f331b53de89": " — {{value1}}",
  "copy.9a1b49340a04": "Edit Visible Fields",
  "copy.6f7d17742cbd": "Access to this share has ended.",
  "copy.7074f1ed7f11": "Enter each option on a separate line.",
  "copy.85ae77c7c7c7": "Only the receipt for your own change is returned. The source owner's private rules and results are not shared.",
  "copy.50be7607bf65": "The source or share is unavailable.",
  "copy.621156a998c9": "Shared",
  "copy.6640372dab0f": "Shared Space",
  "copy.051fdb634371": "Placement of shared records. Records retain their own projects and connections.",
  "copy.90adee1fa376": "Share to add to the space",
  "copy.69bbfa6b40da": "Select share",
  "copy.39290b866133": "Shared record",
  "copy.87dfc4e1c5b9": "Record ·",
  "copy.366a747c901a": "Add to Shared Space",
  "copy.d7ad06454fe3": "Remove from Space",
  "copy.bb6b3fcc87f6": "Open it from the Shares section",
  "copy.451f149c1b5a": "More Placements",
  "copy.de4bf796d637": "More Sharing Options",
  "copy.6f400a971e79": "Shared Life area",
  "copy.06c2353ad761": "Table in the shared area",
  "copy.11b1cf1ddb67": "Shared table",
  "copy.010d33a7306a": "Life record to share",
  "copy.88f9e251a135": "Could not load records.",
  "copy.08d693f840e3": "Manage your friendships, explicitly shared records and availability.",
  "copy.1880195e390e": "Social sections",
  "copy.de675304418f": "Friends",
  "copy.ff9817183890": "Note Copies",
  "copy.34f2295bb9b6": "Availability",
  "copy.3f83fb55cde5": "Could not load friendships.",
  "copy.995b91a50ceb": "Close Sharing Form",
  "copy.0255d737df24": "New Live Share",
  "copy.2db0c4bd1de1": "Select a friend for the shared space",
  "copy.7a6d41df984b": "More Friendships",
  "copy.12ed1ebecf00": "Private Invitation",
  "copy.3918b5e16cf9": "There is no account search. Share the code only with the person you want to connect with.",
  "copy.08a06f684acf": "Create Invitation Code",
  "copy.8c8ee9e55708": "Your invitation code",
  "copy.35eb5cc99c9b": "Expires:",
  "copy.20fcfdd75945": "Invitation code copied.",
  "copy.ba07b97ecf0c": "Select the code to copy it.",
  "copy.c14e7316845a": "Copy Code",
  "copy.72ed0a55f01f": "Friend request sent.",
  "copy.1115c6e28f05": "Invitation code you received",
  "copy.00090b4b0cbf": "Send Friend Request",
  "copy.1046092e9e0f": "Your Friendships",
  "copy.c4b3563b59f7": "Friendship alone does not grant access to your private data.",
  "copy.75a3ddfde60f": "No friendships yet",
  "copy.67df3cc43e58": "Accept",
  "copy.fd78c713b1a0": "Reject",
  "copy.1ee9f680f738": "Withdraw Request",
  "copy.cebeafe79e70": "End Friendship",
  "copy.42d863f01216": "Block",
  "copy.d219dde1fadf": "Ending or blocking closes live shares and availability access. Accepted note copies remain with the recipient.",
  "copy.52de0ec377af": "Offer Independent Note Copy",
  "copy.1d7cfbda3d39": "If the recipient accepts, they own their copy. Later changes do not sync; an accepted copy cannot be recalled.",
  "copy.f5cc7afb221f": "Offer Note Copy",
  "copy.ed0907f679e1": "Copy Offers",
  "copy.2737ad09599d": "Copy offered to you",
  "copy.6db1b5040eaa": "Copy you offered",
  "copy.1caa73c4aad6": "Review Content",
  "copy.8d6d07623105": "Revoke Offer",
  "copy.a0e6440d040b": "Open Your Note",
  "copy.95e5d7f36ba5": "No copy offers",
  "copy.b8be4f967f78": "More Offers",
  "copy.3ac8451d04a3": "This copy offer is no longer available.",
  "copy.3df93ebabe2a": "Note copy preview",
  "copy.ecaa5be87e41": "Accepting adds an independent copy to your notes. It does not create a live share.",
  "copy.27c4009b94c4": "Copy to My Notes",
  "copy.ba81b4ffe354": "Reject Copy",
  "copy.de5b45f3d079": "Close Preview",
  "copy.e70bb6a2fb7b": "Available",
  "copy.c1846c73bd74": "Busy",
  "copy.41cdcbb9457d": "Away",
  "copy.703df33c4c0c": "Your Availability",
  "copy.678d2ecc733b": "Your general preference applies to all accepted friendships. Saving for one friend creates a specific preference for them.",
  "copy.38faf42183e9": "Preference scope",
  "copy.9e6888728499": "General preference for all friends",
  "copy.7ae5de664c2b": "Your Friend's Availability",
  "copy.49451f45f178": "Only your friend's explicitly reported status and authorised time windows are visible.",
  "copy.4ac8ab998cc8": "Start date",
  "copy.c3c51b8639a8": "End date",
  "copy.d925897cad40": "View Availability",
  "copy.be50271dfabf": "Up to 31 days. The calendar provides only free/busy times; titles and record contents are hidden.",
  "copy.7da744c981c8": "Availability is not shared",
  "copy.7b6988b293b9": "Not all intervals fit. Choose a shorter date range.",
  "copy.a3e2bcca6678": "Availability preference saved.",
  "copy.b43347d5e002": "Share my availability",
  "copy.274b37543154": "Your reported status",
  "copy.0925c172b610": "Also share free/busy intervals from my calendar",
  "copy.fb5b81150d56": "Calendar titles are not shared. Unscheduled tasks are not used to infer busy time.",
  "copy.193e2a8dbc3e": "Your reported time windows",
  "copy.bfbd5bfe3428": "Interval start",
  "copy.ea6902e15c44": "Interval end",
  "copy.ef48306b0c11": "Remove Interval",
  "copy.8a99fb2f0d81": "Add Time Window",
  "copy.337b3d71f975": "Select a start and then an end; each interval can span up to 31 days.",
  "copy.2a4db7772763": "Save Availability",
  "copy.404e9b3089ed": "Awaiting response",
  "copy.294b4baa9952": "Accepted",
  "copy.c028f549f351": "Withdrawn",
  "copy.b3629ca82080": "Closed",
  "copy.9042c04fab94": "Life table view",
  "copy.1508ac959d13": "Metrics",
  "copy.9cc4262aecb2": "Rules",
  "copy.1d4b6cc8a1db": "Preview Layout",
  "copy.3e4e27ae96d2": "Save Layout",
  "copy.34fc129cb86d": "Positions have not been saved yet.",
  "copy.9d9beea930b8": "Some connections could not be loaded.",
  "copy.e4eb74dc7900": "The connection view is limited. Open the selected item’s Connections panel for details.",
  "copy.81655e4824dd": "This record was saved using an earlier table definition. Old values for fields whose type, unit or currency changed were not carried into the form; re-enter them using their current meaning. Previous values remain in record history after saving.",
  "copy.7a1889e11ef6": "Open the persistent notification inbox",
  "extensions.workspace.description": "Bring your interests into one workspace. Choose an app, connect your Life data and continue where you left off.",
  "extensions.hub.musicDescription": "Build a repertoire, record practice sessions and follow your instrument goals.",
  "extensions.hub.lessonsDescription": "Keep lessons, session notes, transcripts and follow-up tasks together.",
  "extensions.hub.cyclingDescription": "Log rides, review distance and duration, and set your weekly cycling goal.",
  "extensions.hub.devicesDescription": "Connect devices, manage data permissions and review recorded summaries.",
  "extensions.hub.socialDescription": "Stay connected through invitations, shared spaces and precisely chosen access.",
  "extensions.hub.preferencesDescription": "Choose the Life areas, data displays and defaults used by your apps.",
  "extensions.hub.lifeData": "Life data",
  "extensions.hub.catalogCount": "Available apps",
  "extensions.hub.active": "Active",
  "extensions.hub.paused": "Paused",
  "extensions.hub.search": "Find an app",
  "extensions.hub.filter": "Filter apps",
  "extensions.hub.all": "All apps",
  "extensions.hub.available": "Discover",
  "extensions.hub.unavailable": "Unavailable",
  "extensions.hub.notInstalled": "Not installed",
  "extensions.hub.empty": "No apps match this view",
  "extensions.hub.emptyDescription": "Try a different search or show all apps.",
  "extensions.hub.reset": "Show all apps",
  "extensions.hub.dataNote": "You choose each app’s permissions before installation. Life tables, records and independent notes remain yours when an app is removed.",
  "apps.workspace.lede": "Bring your Life records, saved views and charts together in your own pages.",
  "apps.workspace.mode": "Application mode",
  "apps.workspace.open": "My applications",
  "apps.workspace.edit": "Edit layout",
  "apps.workspace.empty": "A space shaped around your life",
  "apps.workspace.emptyHint": "Create an application, add a page and connect your existing Life tables, views, charts or entry forms.",
  "apps.workspace.create": "Create an application",
  "apps.workspace.applications": "Saved applications",
  "apps.workspace.pageCount": "Pages: {{count}}",
  "apps.workspace.configure": "Configure pages",
  "apps.workspace.pages": "Application pages",
  "apps.workspace.noSections": "This page is ready for its first section",
  "apps.workspace.noSectionsHint": "Use Configure pages to add content from Life.",
  "apps.workspace.sourceUnavailable": "This source is unavailable",
  "apps.workspace.sourceUnavailableHint": "The saved layout is preserved. Choose an available source in Edit layout.",
  "apps.workspace.noPages": "Add your first page",
  "apps.workspace.loadError": "The source could not be loaded. Try again or check its connection in Edit layout.",
  "apps.workspace.formHint": "Add a record to {{title}} using its current fields and validation.",
  "apps.workspace.addRecord": "Add a record",
  "apps.workspace.recordSaved": "Your record is saved in Life and available in connected views.",
  "apps.workspace.recordCount": "Records: {{count}}",
  "apps.workspace.noRecords": "No records in this view yet",
  "apps.workspace.openRecord": "Open record",
  "apps.workspace.moreRecords": "Load more records",
  "apps.music.goals": "Goals",
  "apps.music.profile": "Profile",
  "apps.social.rejected": "Rejected",
  "life.workspace.metrics": "Metrics",
  "life.workspace.rules": "Rules",
  "life.tools.metricsIntro": "Turn your Life records into metrics, charts and budget views. Choose a source to begin.",
  "life.tools.rulesIntro": "Set up actions around your records and goals. Review each rule, grant its permissions and follow its runs here.",
  "life.tools.manageAreas": "Life areas",
  "life.tools.areasError": "Life areas could not be loaded",
  "life.tools.startTitle": "Start with a Life area",
  "life.tools.startMetrics": "Create an area and a record table, then build metrics and charts from your own data.",
  "life.tools.startRules": "Create an area and a record table, then add rules for changes, schedules or manual runs.",
  "life.tools.createArea": "Create your first area",
  "life.tools.source": "Choose your source",
  "life.tools.area": "Life area",
  "life.tools.schema": "Record table",
  "life.tools.chooseSchema": "Choose a table",
  "life.tools.schemasError": "Record tables could not be loaded",
  "life.tools.noSchema": "This area has no record table yet",
  "life.tools.noSchemaHint": "Open the area to create a table for the information you want to track.",
  "life.tools.openArea": "Open area",
  "life.tools.metricContext": "Metrics and displays use this table. Target values can also come from a parameter or another Life record.",
  "life.tools.ruleContext": "New event rules use this table. Scheduled and manual rules remain available alongside it.",
  "life.tools.openRecords": "Records and history",
  "life.recordPicker.search": "Find a record",
  "life.recordPicker.searchHint": "Search by record content",
  "life.recordPicker.loading": "Loading records…",
  "life.recordPicker.choose": "Choose a record",
  "life.recordPicker.saved": "Previously selected record",
  "life.recordPicker.untitled": "Untitled record",
  "life.recordPicker.empty": "No records match this search in the selected table.",
  "life.recordPicker.error": "Records could not be loaded",
  "life.recordPicker.savedUnavailable": "The selected record is unavailable. Choose another record before saving.",
  "life.recordPicker.more": "Load more records",
  "life.target.area": "Target area",
  "life.target.schema": "Target table",
  "life.target.record": "Target record",
  "life.target.chooseField": "Choose a numeric field",
  "life.target.updateRecord": "Record to update",
  "life.metrics.unavailableDisplays": "Displays without an active source",
  "life.metrics.unavailableHint": "These displays have no metric in the active source list. You can archive them here.",
  "life.metrics.unavailableError": "Other display sources could not be checked",
  "security.totp.scan_instruction": "Scan this QR code with your authenticator app, then enter the six-digit code it shows.",
  "security.totp.manual_secret": "Can't scan it? Enter this setup key manually",
  "security.totp.qr_alt": "QR code for adding Exognitos to an authenticator app",
  "security.totp.qr_failed": "The QR code could not be generated. Use the manual setup key below.",
  "security.totp.login_hint": "Enter the six-digit authenticator code or one of your ten-character recovery codes. This sign-in attempt expires at {{time}}.",
  "security.totp.recovery_title": "Save your recovery codes",
  "security.totp.recovery_description": "Each code signs you in once if your authenticator is unavailable. Store them somewhere private and separate from this device.",
  "security.totp.recovery_once": "For your security, Exognitos cannot show these codes again after you close this panel.",
  "security.totp.copy_recovery": "Copy all codes",
  "security.totp.download_recovery": "Download .txt",
  "security.totp.recovery_copied": "Recovery codes copied",
  "security.totp.recovery_saved_confirmation": "I saved these recovery codes in a safe place",
  "security.totp.recovery_done": "Finish setup",
  "security.totp.recovery_count": "{{count}} recovery codes remaining",
  "security.totp.recovery_count_loading": "Checking recovery codes…",
  "security.totp.regenerate": "Replace recovery codes",
  "security.totp.regenerate_title": "Replace all recovery codes?",
  "security.totp.regenerate_description": "Every existing recovery code will stop working immediately. The new codes are shown only once.",
  "security.totp.regenerated": "New recovery codes created",
  "security.totp.regenerate_failed": "Recovery codes could not be replaced",
  "security.totp.recovery_file_intro": "Exognitos two-factor recovery codes — each code can be used once. Keep this file private.",
  "shortcuts.title": "Keyboard shortcuts",
  "shortcuts.description": "Product-wide shortcuts pause while a dialog or sheet is open, so typing never triggers an action behind it.",
  "shortcuts.group.global": "Anywhere",
  "shortcuts.group.capture": "Quick Capture",
  "shortcuts.group.review": "Rediscover review",
  "shortcuts.search": "Search, run a command, or navigate",
  "shortcuts.capture": "Open Quick Capture",
  "shortcuts.capture_simple": "Open Quick Capture when you are not typing",
  "shortcuts.reference": "Open this shortcut reference",
  "shortcuts.close_layer": "Close the active dialog or sheet",
  "shortcuts.single_save": "Save a single thought",
  "shortcuts.dump_save": "Save a multi-line brain dump",
  "shortcuts.review_previous": "Previous review card",
  "shortcuts.review_next": "Next review card",
  "connectivity.offline_title": "Connection lost.",
  "connectivity.offline_description": "Live information cannot refresh. Unsent changes remain on screen but are not queued; reconnect before closing this tab.",
  "offline.enabled_description": "Live information cannot refresh. Quick Captures are encrypted on this device and will be sent after you reconnect.",
  "offline.capture_saved_title": "Capture saved on this device",
  "offline.capture_saved_description": "It is encrypted and will be sent once you are signed in and online.",
  "offline.capture_failed_title": "Could not save this capture offline",
  "offline.capture_failed_description": "Keep this window open and copy the text before closing it.",
  "offline.replaying_title": "Sending {{count}} saved capture(s).",
  "offline.replaying_description": "Each capture keeps its original retry identity, so reconnecting cannot create a duplicate.",
  "offline.review_title": "{{count}} offline capture(s) need review.",
  "offline.review_description": "The server rejected these drafts or their encrypted data could not be verified.",
  "offline.review_action": "Review drafts",
  "offline.review_dialog_title": "Offline capture review",
  "offline.review_dialog_description": "Your text stays encrypted until you open this account-scoped review. Retry or explicitly discard each draft.",
  "offline.review_empty": "No offline drafts need review.",
  "offline.corrupted_body": "This encrypted draft is damaged and cannot be safely displayed.",
  "offline.retry_action": "Retry",
  "offline.discard_title": "Discard this offline draft?",
  "offline.discard_description": "The encrypted local copy will be permanently removed. No server record is deleted.",
  "offline.discard_action": "Discard draft",
  "offline.state.pending": "waiting",
  "offline.state.conflict": "conflict",
  "offline.state.rejected": "rejected",
  "offline.state.corrupted": "damaged",
  "offline.update_title": "An Exognitos update is ready.",
  "offline.update_description": "Refresh when it is safe to reload this workspace. Unsaved form text stays on screen until you choose.",
  "offline.update_later": "Later",
  "offline.update_now": "Refresh now",
  "offline.last_known_inbox": "Last known: {{count}} unprocessed capture(s), saved {{time}}. Read-only and possibly stale.",
  "offline.clear_title": "Offline data on this device",
  "offline.clear_description": "Remove the encrypted last-known snapshot and {{count}} saved capture(s) for this account.",
  "offline.clear_confirm_title": "Clear offline data from this device?",
  "offline.clear_confirm_description": "This permanently removes this account's encrypted local snapshots and pending captures. Server records are not deleted.",
  "offline.clear_action": "Clear offline data",
  "offline.clear_success": "Offline data was cleared from this device.",
  "activity.title": "Activity & Security",
  "activity.lede": "See how your account, connected assistants, and security credentials have been used.",
  "activity.export": "Export CSV",
  "activity.filters.title": "Filters",
  "activity.filters.description": "Narrow the accountability trail without exposing record contents or secrets.",
  "activity.filters.clear": "Clear filters",
  "activity.filters.family": "Activity",
  "activity.filters.outcome": "Outcome",
  "activity.filters.actor": "Actor",
  "activity.filters.entity": "Record type",
  "activity.filters.entity_placeholder": "For example, task",
  "activity.filters.from": "From",
  "activity.filters.to": "Through",
  "activity.filters.suspicious": "Suspicious only",
  "activity.filters.suspicious_hint": "Failures, denials, and blocked access",
  "activity.filters.all": "All",
  "activity.events.title": "Account events",
  "activity.events.description": "Recent security and delegated-access events.",
  "activity.retention": "Events are retained for {{count}} days. Exports contain the same safe fields shown here.",
  "activity.native_notice": "This security log requires your first-party browser session. Open Exognitos in a browser to view or export it.",
  "activity.error": "The activity log could not be loaded.",
  "activity.empty.title": "No activity events",
  "activity.empty.description": "Security-relevant account activity will appear here.",
  "activity.empty.filtered": "No events match these filters. Clear one or more filters to broaden the view.",
  "activity.more": "Load older events",
  "activity.suspicious": "Suspicious",
  "activity.request": "Request {{id}}",
  "activity.entity.open": "Open {{kind}} · {{id}}",
  "activity.family.account": "Account",
  "activity.family.assistant": "Assistant",
  "activity.family.auth": "Sign-in & security",
  "activity.family.backup": "Backup",
  "activity.family.data": "Data",
  "activity.family.import": "Import",
  "activity.family.integration": "Integrations",
  "activity.family.life": "Life records",
  "activity.family.mcp": "MCP",
  "activity.family.notifications": "Notifications",
  "activity.family.oauth": "OAuth",
  "activity.family.relations": "Relations",
  "activity.family.settings": "Settings",
  "activity.family.token": "API keys",
  "activity.outcome.success": "Succeeded",
  "activity.outcome.failure": "Failed",
  "activity.outcome.denied": "Denied",
  "activity.actor.human_web": "You · web",
  "activity.actor.human_mobile": "You · mobile",
  "activity.actor.human_desktop": "You · desktop",
  "activity.actor.api_token": "Personal API key",
  "activity.actor.oauth_client": "Connected assistant",
  "activity.actor.mcp": "MCP client",
  "activity.actor.import": "Import or restore",
  "activity.actor.system": "Exognitos system",
  "activity.actor.tool": "Tool · {{name}}",
  "activity.action.auth_login": "Signed in",
  "activity.action.auth_login_failed": "Sign-in failed",
  "activity.action.auth_logout": "Signed out",
  "activity.action.auth_register": "Account created",
  "activity.action.password_changed": "Password changed",
  "activity.action.password_reset_requested": "Password reset requested",
  "activity.action.password_reset_completed": "Password reset completed",
  "activity.action.session_revoked": "Session revoked",
  "activity.action.mfa_enrolled": "Two-step verification enabled",
  "activity.action.mfa_challenge_issued": "Two-step verification requested",
  "activity.action.mfa_verified": "Two-step verification completed",
  "activity.action.mfa_disabled": "Two-step verification disabled",
  "activity.action.mfa_failed": "Two-step verification failed",
  "activity.action.token_create": "Personal API key created",
  "activity.action.token_revoke": "Personal API key revoked",
  "activity.action.oauth_authorize": "Assistant access approved",
  "activity.action.oauth_revoke": "Assistant access revoked",
  "activity.action.oauth_token_issued": "Assistant credential issued",
  "activity.action.oauth_denied": "Assistant access denied",
  "activity.action.mcp_tool_call": "MCP tool used",
  "activity.action.mcp_denied": "MCP tool blocked",
  "activity.action.mcp_batch": "MCP batch applied",
  "activity.action.life_mutation": "Life record changed",
  "activity.action.relations_mutation": "Relationship changed",
  "activity.action.notifications_mutation": "Notification changed",
  "activity.action.assistant_mutation": "Assistant setting changed",
  "activity.action.account_delete": "Account deletion requested",
  "activity.action.data_purge": "Data permanently deleted",
  "activity.action.data_bulk_command": "Bulk change applied",
  "activity.action.backup_export": "Backup exported",
  "activity.action.backup_restore": "Backup restored",
  "activity.action.backup_inspect": "Backup inspected",
  "activity.action.import_run": "Import completed",
  "activity.action.integration_connect": "Integration connected",
  "activity.action.integration_disconnect": "Integration disconnected",
  "activity.action.security_setting_changed": "Security setting changed",
  "activity.action.saved_view_mutation": "Saved view changed",
  "savedViews.actions": "Saved view actions",
  "savedViews.archive": "Archive view",
  "savedViews.archived": "Saved view archived",
  "savedViews.cancel": "Cancel",
  "savedViews.confirm": "Save",
  "savedViews.dialog.create": "Save this view",
  "savedViews.dialog.duplicate": "Duplicate saved view",
  "savedViews.dialog.rename": "Rename saved view",
  "savedViews.duplicate": "Duplicate",
  "savedViews.error.generic": "The saved view could not be changed.",
  "savedViews.error.invalidImport": "This is not a valid saved-view file for this collection.",
  "savedViews.error.load": "Saved views unavailable",
  "savedViews.error.migrationRequired": "This saved view must be migrated before it can open.",
  "savedViews.error.unsupportedOnSurface": "This saved view uses options this screen cannot display safely.",
  "savedViews.export": "Export",
  "savedViews.import": "Import saved view",
  "savedViews.makeDefault": "Make default",
  "savedViews.makePrivate": "Make private",
  "savedViews.makeShareable": "Allow sharing",
  "savedViews.name": "View name",
  "savedViews.pin": "Pin",
  "savedViews.removeDefault": "Remove default",
  "savedViews.rename": "Rename",
  "savedViews.save": "Save view",
  "savedViews.select": "Saved views",
  "savedViews.shared.choose": "Shareable saved views",
  "savedViews.shared.copyName": "Shared view copy",
  "savedViews.shared.definition": "View definition",
  "savedViews.shared.entity": "Saved view",
  "savedViews.shared.noneEligible": "Mark a saved view as shareable from its collection before granting access.",
  "savedViews.shared.saveCopy": "Save a private copy",
  "savedViews.shared.summary": "{{filters}} filters · {{columns}} columns",
  "savedViews.shared.unavailable": "This shared view is no longer available.",
  "savedViews.surfaces.projects": "Projects",
  "savedViews.surfaces.tasks": "Tasks",
  "savedViews.undo": "Undo",
  "savedViews.unpin": "Unpin",
  "savedViews.update": "Update with current filters",
  "entity.detail.breadcrumbs": "Detail path",
  "entity.detail.context": "Context",
  "entity.detail.metadata": "Detail context",
  "entity.detail.provenance": "Provenance",
  "entity.detail.source": "Source",
  "entity.detail.status": "Status",
  "entity.detail.type": "Type",
  "entity.lifecycle.actions": "Record actions",
  "entity.lifecycle.archive": "Archive",
  "entity.lifecycle.archived": "Archived",
  "entity.lifecycle.complete": "Complete goal",
  "entity.lifecycle.completed": "Completed",
  "entity.lifecycle.decision.closed": "Closed",
  "entity.lifecycle.decision.considering": "Considering",
  "entity.lifecycle.decision.decided": "Decided",
  "entity.lifecycle.decision.revisiting": "Revisiting",
  "entity.lifecycle.error": "The record could not be changed. Try again.",
  "entity.lifecycle.open": "Open",
  "entity.lifecycle.reopen": "Reopen goal",
  "entity.lifecycle.reopened": "Goal reopened",
  "entity.lifecycle.unarchive": "Restore",
  "entity.lifecycle.unarchived": "Restored",
  "search.archived": "Archived",
  "search.match.content": "Matched in content",
  "search.match.exactTitle": "Exact title match",
  "search.match.lexical": "Matched search terms",
  "search.match.titlePrefix": "Title starts with query",
  "search.match.titleSimilarity": "Similar title",
  "notifications.actions.label": "Actions for {{title}}",
  "notifications.actions.acknowledge": "Done",
  "notifications.actions.snooze10": "10 min",
  "notifications.actions.snooze60": "1 hour",
  "notifications.actions.cancel": "Cancel",
  "notifications.actions.pending": "Updating reminder…",
  "notifications.actions.error": "The reminder could not be updated. Try again.",
  "notifications.actions.success.acknowledge": "{{title}} acknowledged.",
  "notifications.actions.success.snooze10": "{{title}} snoozed for 10 minutes.",
  "notifications.actions.success.snooze60": "{{title}} snoozed for 1 hour.",
  "notifications.actions.success.cancel": "{{title}} cancelled.",
  "collection.selectRecord": "Select {{title}}",
  "collection.archiveSelected": "Archive selected",
  "collection.completeSelected": "Complete selected",
  "collection.reopenSelected": "Reopen selected",
  "collection.pauseSelected": "Pause selected",
  "collection.resumeSelected": "Resume selected",
  "collection.tasksArchived": "Archived {{count}} tasks",
  "collection.tasksCompleted": "Completed {{count}} tasks",
  "collection.tasksReopened": "Reopened {{count}} tasks",
  "collection.routinesArchived": "Archived {{count}} routines",
  "collection.routinesPaused": "Paused {{count}} routines",
  "collection.routinesResumed": "Resumed {{count}} routines",
  "collection.notesArchived": "Archived {{count}} notes",
  "collection.projectsArchived": "Archived {{count}} projects",
  "review.reason.snoozed": "Snoozed"
}
